import React, { useState, useEffect, useCallback, useMemo, useRef } from 'react';
import { initializeApp } from 'firebase/app';
import {
    getAuth,
    onAuthStateChanged,
    createUserWithEmailAndPassword,
    signInWithEmailAndPassword,
    signOut,
    signInWithCustomToken,
    signInAnonymously
} from 'firebase/auth';
import {
    initializeFirestore,
    persistentLocalCache,
    collection, doc, addDoc, getDocs, updateDoc, deleteDoc,
    query, where, onSnapshot, writeBatch, setLogLevel, orderBy, Timestamp,
    runTransaction, setDoc, getDoc, collectionGroup, enableNetwork, disableNetwork, limit,
} from 'firebase/firestore';
import {
    PlusCircle, Edit3, Trash2, Bell, CheckCircle, XCircle, User, Phone,
    PawPrint, CalendarDays, Info, Send, Search, ListChecks, Stethoscope,
    Pill, FileText, CreditCard, Eye, ChevronLeft, ChevronRight, BookOpen,
    Archive, DollarSign, PackagePlus, Hospital, Thermometer, ClipboardList, AlertTriangle, TrendingUp, TrendingDown, Loader2, Download, Users, History, FileOutput, Sparkles, MessageSquareText, ExternalLink, ListTodo, Weight, Heart, LogOut, KeyRound, Mail, Maximize, ZoomIn, ZoomOut, HandCoins, Calculator, UserPlus, UserCog, Printer, Save, Share2, Home, UserSquare, Building, UserCheck,
    LayoutDashboard, MessagesSquare, DatabaseBackup, BarChart3, Users2, Syringe, ClipboardPlus, MessageCircle, Smartphone, PieChart as PieChartIcon, Activity, CalendarClock, BookOpenText, Target, Wallet, CalendarCheck, Clock, Layers
} from 'lucide-react';
import { PieChart, Pie, Cell, BarChart, Bar, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer, LineChart, CartesianGrid, Line, AreaChart, Area, ComposedChart } from 'recharts';

// html2canvas kütüphanesini dinamik olarak yüklemek için bir fonksiyon
const loadScript = (src) => {
    return new Promise((resolve, reject) => {
        if (document.querySelector(`script[src="${src}"]`)) {
            resolve();
            return;
        }
        const script = document.createElement('script');
        script.src = src;
        script.onload = () => resolve();
        script.onerror = () => reject(new Error(`Script load error for ${src}`));
        document.head.appendChild(script);
    });
};

// Firebase config
const firebaseConfig = {
  apiKey: "AIzaSyAf8n5slBo1TI-cvCi4xSppy7fiK2hruzk",
  authDomain: "cetinvet-1bf7a.firebaseapp.com",
  projectId: "cetinvet-1bf7a",
  storageBucket: "cetinvet-1bf7a.firebasestorage.app",
  messagingSenderId: "50218318248",
  appId: "1:50218318248:web:b2f2e946ffcc95cfbd859d"
};

const appId = typeof __app_id !== 'undefined' ? __app_id : 'default-app-id';

// Aşı ve Tedavi Takvimleri
const treatmentSchedules = {
    "Köpek": [
        { id: "kopek_karma_1", name: "DHPPi+L (Karma) 1. Doz", note: "6-8 hafta arası", followUp: { days: 21, nextDoseId: "kopek_karma_2" }, type: "Aşı" },
        { id: "kopek_karma_2", name: "DHPPi+L (Karma) 2. Doz", note: "10-12 hafta arası", followUp: { days: 21, nextDoseId: "kopek_karma_3" }, type: "Aşı" },
        { id: "kopek_karma_3", name: "DHPPi+L (Karma) 3. Doz (Rapel)", note: "14-16 hafta arası. Yıllık tekrar önerilir.", isFinalSystemDose: true, annualNote: "Yıllık Tekrar Önerilir", type: "Aşı" },
        { id: "kopek_kuduz", name: "Kuduz Aşısı (Köpek)", note: "12-16 hafta arası. Yıllık tekrar önerilir.", annualNote: "Yıllık Tekrar Önerilir", type: "Aşı" },
        { id: "kopek_bordetella", name: "Bordetella (Kennel Cough)", note: "6-8 hafta arası. Yıllık tekrar önerilir.", annualNote: "Yıllık Tekrar Önerilir", type: "Aşı" },
        { id: "kopek_lyme_1", name: "Lyme Hastalığı 1. Doz", note: "12 hafta civarı (Riskli bölgelerde)", followUp: { days: 28, nextDoseId: "kopek_lyme_2" }, type: "Aşı" },
        { id: "kopek_lyme_2", name: "Lyme Hastalığı 2. Doz", note: "16 hafta civarı. Yıllık tekrar önerilir (Riskli bölgelerde).", isFinalSystemDose: true, annualNote: "Yıllık Tekrar Önerilir", type: "Aşı" },
        { id: "kopek_kalpkurdu", name: "Kalp Kurdu Koruma", note: "6 hafta başlangıç. Aylık tekrar.", monthlyNote: "Aylık Tekrar", type: "Parazit Tedavisi", parasiteType: "Kalp Kurdu" },
        { id: "kopek_icparazit_seri", name: "İç Parazit (Seri)", note: "2, 4, 6, 8 hafta. Sonrası 3 ayda bir.", type: "Parazit Tedavısı", parasiteType: "İç Parazit", series: [
            { dose: 1, note: "2 Hafta", followUpDays: 14 }, { dose: 2, note: "4 Hafta", followUpDays: 14 },
            { dose: 3, note: "6 Hafta", followUpDays: 14 }, { dose: 4, note: "8 Hafta", quarterlyNote: "3 Ayda Bir Tekrar" }
        ]},
        { id: "kopek_disparazit", name: "Dış Parazit Koruma", note: "Veteriner hekim tavsiyesine göre. Genellikle aylık.", monthlyNote: "Aylık Tekrar", type: "Parazit Tedavisi", parasiteType: "Dış Parazit" },
    ],
    "Kedi": [
        { id: "kedi_karma_1", name: "FVRCP (Karma) 1. Doz", note: "6-8 hafta arası", followUp: { days: 21, nextDoseId: "kedi_karma_2" }, type: "Aşı" },
        { id: "kedi_karma_2", name: "FVRCP (Karma) 2. Doz", note: "10-12 hafta arası", followUp: { days: 21, nextDoseId: "kedi_karma_3" }, type: "Aşı" },
        { id: "kedi_karma_3", name: "FVRCP (Karma) 3. Doz (Rapel)", note: "14-16 hafta arası. Yıllık tekrar önerilir.", isFinalSystemDose: true, annualNote: "Yıllık Tekrar Önerilir", type: "Aşı" },
        { id: "kedi_kuduz", name: "Kuduz Aşısı (Kedi)", note: "12-16 hafta arası. Yıllık tekrar önerilir.", annualNote: "Yıllık Tekrar Önerilir", type: "Aşı" },
        { id: "kedi_losemi_1", name: "FeLV (Lösemi) 1. Doz", note: "8 hafta civarı (Risk grubuna, test sonrası)", followUp: { days: 28, nextDoseId: "kedi_losemi_2" }, type: "Aşı" },
        { id: "kedi_losemi_2", name: "FeLV (Lösemi) 2. Doz", note: "12 hafta civarı. Yıllık tekrar önerilir (Risk grubuna).", isFinalSystemDose: true, annualNote: "Yıllık Tekrar Önerilir (Risk grubuna)", type: "Aşı" },
        { id: "kedi_fiv_test", name: "FIV Testi", note: "Genellikle 6 ay civarı, risk durumuna göre.", type: "Test" },
        { id: "kedi_icparazit_seri", name: "İç Parazit (Seri)", note: "2, 4, 6, 8 hafta. Sonrası 3 ayda bir.", type: "Parazit Tedavisi", parasiteType: "İç Parazit", series: [
            { dose: 1, note: "2 Hafta", followUpDays: 14 }, { dose: 2, note: "4 Hafta", followUpDays: 14 },
            { dose: 3, note: "6 Hafta", followUpDays: 14 }, { dose: 4, note: "8 Hafta", quarterlyNote: "3 Ayda Bir Tekrar" }
        ]},
        { id: "kedi_disparazit", name: "Dış Parazit Korunma", note: "8 hafta başlangıç. Aylık tekrar.", monthlyNote: "Aylık Tekrar", type: "Parazit Tedavisi", parasiteType: "Dış Parazit" },
    ],
    "Sığır": [
        { id: "sigir_solunum_1", name: "IBR/BVD/PI3/BRSV 1. Doz", note: "3-4 ay civarı", followUp: { days: 28, nextDoseId: "sigir_solunum_2" }, type: "Aşı" },
        { id: "sigir_solunum_2", name: "IBR/BVD/PI3/BRSV 2. Doz", note: "4-5 ay civarı. Yıllık tekrar.", isFinalSystemDose: true, annualNote: "Yıllık Tekrar", type: "Aşı" },
        { id: "sigir_clost_1", name: "Clostridial (7-yollu) 1. Doz", note: "2-3 ay civarı", followUp: { days: 28, nextDoseId: "sigir_clost_2" }, type: "Aşı" },
        { id: "sigir_clost_2", name: "Clostridial (7-yollu) 2. Doz", note: "3-4 ay civarı. Yıllık tekrar.", isFinalSystemDose: true, annualNote: "Yıllık Tekrar", type: "Aşı" },
        { id: "sigir_sap", name: "Şap Hastalığı Aşısı", note: "4-6 ay başlangıç. 6 ayda bir tekrar.", semiAnnualNote: "6 Ayda Bir Tekrar", type: "Aşı" },
        { id: "sigir_brucella", name: "Brucella Aşısı (RB51 Dişi)", note: "Tek Doz (4-12 ay arası dişi buzağılara).", type: "Aşı" },
        { id: "sigir_sarbon", name: "Anthrax (Şarbon) Aşısı", note: "6 ay civarı. Yıllık tekrar (riskli bölgelerde).", annualNote: "Yıllık Tekrar", type: "Aşı" },
        { id: "sigir_pasteurella", name: "Pasteurella Aşısı", note: "3-4 ay civarı. Yıllık tekrar.", annualNote: "Yıllık Tekrar", type: "Aşı" },
        { id: "sigir_parazit_genel", name: "Parazit Tedavisi (Sığır)", note: "Programa göre (örn: 1, 3, 6 ay).", type: "Parazit Tedavisi", parasiteType: "Genel" },
        { id: "mastit_asisi", name: "Mastit Aşısı", note: "Doğumdan önce/sonra programa göre.", type: "Aşı" }, 
    ],
    "Buzağı": [
        { id: "buzagi_solunum_1", name: "IBR/BVD/PI3/BRSV 1. Doz (Buzağı)", note: "3-4 ay civarı", followUp: { days: 28, nextDoseId: "buzagi_solunum_2" }, type: "Aşı" },
        { id: "buzagi_solunum_2", name: "IBR/BVD/PI3/BRSV 2. Doz (Buzağı)", note: "4-5 ay civarı. Yıllık tekrar.", isFinalSystemDose: true, annualNote: "Yıllık Tekrar", type: "Aşı" },
        { id: "buzagi_clost_1", name: "Clostridial (7-yollu) 1. Doz (Buzağı)", note: "2-3 ay civarı", followUp: { days: 28, nextDoseId: "buzagi_clost_2" }, type: "Aşı" },
        { id: "buzagi_clost_2", name: "Clostridial (7-yollu) 2. Doz (Buzağı)", note: "3-4 ay civarı. Yıllık tekrar.", isFinalSystemDose: true, annualNote: "Yıllık Tekrar", type: "Aşı" },
        { id: "buzagi_icparazit", name: "İç Parazit (Buzağı)", note: "Veteriner hekim programına göre.", type: "Parazit Tedavisi", parasiteType: "İç Parazit" },
    ],
    "At": [
        { id: "at_karma_1", name: "Karma Aşı (Tetanoz,Infl,EHV) 1. Doz", note: "4-6 aylıkken başlanır.", followUp: { days: 28, nextDoseId: "at_karma_2" } , type: "Aşı"},
        { id: "at_karma_2", name: "Karma Aşı (Tetanoz,Infl,EHV) 2. Doz", note: "1. dozdan 4-6 hafta sonra", followUp: { days: 6 * 30, nextDoseId: "at_karma_3_rapel" } , type: "Aşı"},
        { id: "at_karma_3_rapel", name: "Karma Aşı (Tetanoz,Infl,EHV) Rapel", note: "2. dozdan 6 ay sonra veya yıllık. Yıllık tekrar.", isFinalSystemDose: true, annualNote: "Yıllık Tekrar", type: "Aşı" },
        { id: "at_kuduz", name: "Kuduz Aşısı (At)", note: "12-16 hafta arası. Yıllık tekrar önerilir.", annualNote: "Yıllık Tekrar Önerilir", type: "Aşı" },
        { id: "at_batnil", name: "Batı Nil Virüsü Aşısı", note: "Bölgesel risk durumuna göre.", annualNote: "Yıllık Tekrar", type: "Aşı" },
        { id: "at_icparazit", name: "İç Parazit (At)", note: "Programa göre (2-3 ayda bir).", type: "Parazit Tedavisi", parasiteType: "İç Parazit" },
    ],
    "Sürü": [
        { id: "suni_tohumlama", name: "Suni Tohumlama (ST)", note: "Gebelik/Kuruluğa Çıkarma Takibi", defaultFollowUpDays: [21, 40, 210, 280], defaultFollowUpNames: ["Tekrar Kızgınlık Kontrolü (21 Gün)", "Gebelik Kontrolü (40 Gün)", "Kuruya Çıkarma (210 Gün)", "Doğum Tahmini (280 Gün)"], type: "Sürü Takibi" },
        { id: "kuruluga_cikarma", name: "Kuruya Çıkarma", note: "Doğumdan 60 gün önce", defaultFollowUpDays: [60], defaultFollowUpNames: ["Doğum Tahmini"], type: "Sürü Takibi" },
        { id: "dogum", name: "Doğum", note: "Yeni dönem başlangıcı", type: "Sürü Takibi" },
        { id: "gebelik_tespiti", name: "Gebelik Tespiti", note: "ST'den 45-60 gün sonra", type: "Sürü Takibi" },
        { id: "mastit_asisi_suru", name: "Mastit Aşısı (Sürü)", note: "Özel takip günleri tanımlanabilir.", defaultFollowUpDays: [7, 30], defaultFollowUpNames: ["1. Kontrol", "2. Kontrol"], type: "Sürü Takibi" },
    ]
};
window.treatmentSchedules = treatmentSchedules; 

let app;
let auth;
let db;

try {
    app = initializeApp(firebaseConfig);
    auth = getAuth(app);
    db = initializeFirestore(app, { cache: persistentLocalCache() });
    setLogLevel('error'); 
} catch (error) {
    console.error("Firebase başlatma kritik hatası:", error);
}

const formatCurrency = (value) => {
    const number = Number(value) || 0;
    if (isNaN(number)) return '0.00'; 
    return number.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

// Stil sabitleri
const buttonClasses = "px-4 py-2 rounded-lg text-white font-semibold shadow-md focus:outline-none focus:ring-2 focus:ring-opacity-75 flex items-center justify-center space-x-2 transition-all duration-200 ease-in-out transform hover:scale-105 disabled:opacity-50 disabled:cursor-not-allowed disabled:scale-100";
const primaryButtonClasses = `${buttonClasses} bg-blue-600 hover:bg-blue-700 focus:ring-blue-500`;
const dangerButtonClasses = `${buttonClasses} bg-red-600 hover:bg-red-700 focus:ring-red-500`;
const successButtonClasses = `${buttonClasses} bg-green-600 hover:bg-green-700 focus:ring-green-500`;
const secondaryButtonClasses = `${buttonClasses} bg-slate-500 hover:bg-slate-600 focus:ring-slate-400`;
const warningButtonClasses = `${buttonClasses} bg-yellow-500 hover:bg-yellow-600 focus:ring-yellow-400 text-white`;
const infoButtonClasses = `${buttonClasses} bg-teal-500 hover:bg-teal-600 focus:ring-teal-400`;
const purpleButtonClasses = `${buttonClasses} bg-purple-600 hover:bg-purple-700 focus:ring-purple-500`;

const inputClasses = "mt-1 block w-full px-3 py-2 bg-white border border-slate-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm disabled:bg-slate-100";
const labelClasses = "block text-sm font-medium text-slate-700 mb-1";
const textareaClasses = `${inputClasses} min-h-[80px]`;

const OfflineIndicator = () => {
    const [isOnline, setIsOnline] = useState(navigator.onLine);

    useEffect(() => {
        const handleOnline = () => { setIsOnline(true); if (db) enableNetwork(db); };
        const handleOffline = () => { setIsOnline(false); if (db) disableNetwork(db); };

        window.addEventListener('online', handleOnline);
        window.addEventListener('offline', handleOffline);

        if (!navigator.onLine && db) disableNetwork(db);

        return () => {
            window.removeEventListener('online', handleOnline);
            window.removeEventListener('offline', handleOffline);
        };
    }, []);
    
    return (
        <div className={`fixed top-2 right-2 z-[200] px-3 py-1 text-xs font-bold text-white rounded-full shadow-lg flex items-center transition-all duration-300 ${isOnline ? 'bg-green-500' : 'bg-red-500 animate-pulse'}`}>
            {isOnline ? (
                <><CheckCircle size={12} className="mr-1.5" /> Çevrimiçi</>
            ) : (
                <><XCircle size={12} className="mr-1.5" /> Çevrimdışı</>
            )}
        </div>
    );
};

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
    if (totalPages <= 1) return null;

    return (
        <nav className="mt-4 flex justify-center items-center space-x-2">
            <button onClick={() => onPageChange(currentPage - 1)} disabled={currentPage === 1} className={`${secondaryButtonClasses} text-sm !px-3 !py-1`}><ChevronLeft size={16} /></button>
            <span className="text-sm text-slate-600">Sayfa {currentPage} / {totalPages}</span>
            <button onClick={() => onPageChange(currentPage + 1)} disabled={currentPage === totalPages} className={`${secondaryButtonClasses} text-sm !px-3 !py-1`}><ChevronRight size={16} /></button>
        </nav>
    );
};

function App() {
    const [currentUser, setCurrentUser] = useState(null);
    const [userId, setUserId] = useState(null);
    const [isAuthReady, setIsAuthReady] = useState(false);
    const [authError, setAuthError] = useState('');
    const [activeUser, setActiveUser] = useState(null); 
    
    const [viewMode, setViewMode] = useState('entry'); 
    const [portalOwnerData, setPortalOwnerData] = useState(null); 

    const [patients, setPatients] = useState([]);
    const [reminders, setReminders] = useState([]);
    const [todaysReminders, setTodaysReminders] = useState([]);
    const [visits, setVisits] = useState([]);
    const [allVisits, setAllVisits] = useState([]); 
    const [inventoryItems, setInventoryItems] = useState([]);
    const [creditSales, setCreditSales] = useState([]); 
    
    const [isExporting, setIsExporting] = useState(false);
    const [showPastReminders, setShowPastReminders] = useState(false);

    const [isPatientModalOpen, setIsPatientModalOpen] = useState(false);
    const [isReminderModalOpen, setIsReminderModalOpen] = useState(false);
    const [isVisitModalOpen, setIsVisitModalOpen] = useState(false);
    const [isPatientDetailModalOpen, setIsPatientDetailModalOpen] = useState(false);
    const [isInventoryModalOpen, setIsInventoryModalOpen] = useState(false);
    const [isInventoryItemModalOpen, setIsInventoryItemModalOpen] = useState(false);
    const [isAccountingModalOpen, setIsAccountingModalOpen] = useState(false);
    const [isNotificationModalOpen, setIsNotificationModalOpen] = useState(false);
    const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
    const [isDateDetailModalOpen, setIsDateDetailModalOpen] = useState(false);
    const [isOwnerListModalOpen, setIsOwnerListModalOpen] = useState(false);
    const [isOwnerPatientsModalOpen, setIsOwnerPatientsModalOpen] = useState(false);
    const [isOwnerReportModalOpen, setIsOwnerReportModalOpen] = useState(false); 
    const [isReportSelectionModalOpen, setIsReportSelectionModalOpen] = useState(false);
    const [isAISuggestionModalOpen, setIsAISuggestionModalOpen] = useState(false);
    const [aiSuggestionTitle, setAISuggestionTitle] = useState('');
    const [aiTargetField, setAITargetField] = useState(null);
    const [isCreditSalesViewOpen, setIsCreditSalesViewOpen] = useState(false);
    const [isCreditSaleFormOpen, setIsCreditSaleFormOpen] = useState(false);
    const [creditSaleToEdit, setCreditSaleToEdit] = useState(null);
    const [isCreditSaleDetailModalOpen, setIsCreditSaleDetailModalOpen] = useState(false);
    const [selectedCreditSale, setSelectedCreditSale] = useState(null);
    const [isOwnerCreditSalesModalOpen, setIsOwnerCreditSalesModalOpen] = useState(false);
    const [selectedOwnerForCredit, setSelectedOwnerForCredit] = useState(null);
    const [isChartModalOpen, setIsChartModalOpen] = useState(false);
    const [selectedChart, setSelectedChart] = useState(null);
    const [isPrescriptionWriterModalOpen, setIsPrescriptionWriterModalOpen] = useState(false);
    const [isDashboardModalOpen, setIsDashboardModalOpen] = useState(false);
    const [isBulkMessageModalOpen, setIsBulkMessageModalOpen] = useState(false);
    const [isBackupModalOpen, setIsBackupModalOpen] = useState(false);
    const [isBackingUp, setIsBackingUp] = useState(false);
    const [isSendMessageModalOpen, setIsSendMessageModalOpen] = useState(false);
    const [sendMessageConfig, setSendMessageConfig] = useState({ phone: '', message: '', onSend: null });
    const [isHerdManagementModalOpen, setIsHerdManagementModalOpen] = useState(false);
    const [selectedPatientForHerd, setSelectedPatientForHerd] = useState(null); 
    const [isPaymentCollectionModalOpen, setIsPaymentCollectionModalOpen] = useState(false);
    const [selectedOwnerForPayment, setSelectedOwnerForPayment] = useState(null);
    
    const [isSavingPatient, setIsSavingPatient] = useState(false);
    const [isSavingVisit, setIsSavingVisit] = useState(false);
    const [isSavingInventory, setIsSavingInventory] = useState(false);
    const [isSavingReminder, setIsSavingReminder] = useState(false);
    const [isSavingCreditSale, setIsSavingCreditSale] = useState(false);
    const [isCollectingPayment, setIsCollectingPayment] = useState(false);
    const [isSavingHerdEvent, setIsSavingHerdEvent] = useState(false);

    const [confirmMessage, setConfirmMessage] = useState("");
    const [confirmAction, setConfirmAction] = useState(null);
    const [currentPatient, setCurrentPatient] = useState(null);
    const [patientToEdit, setPatientToEdit] = useState(null);
    const [visitToEdit, setVisitToEdit] = useState(null);
    const [inventoryItemToEdit, setInventoryItemToEdit] = useState(null);
    const [notificationMessage, setNotificationMessage] = useState('');
    const [searchTerm, setSearchTerm] = useState('');
    const [inventorySearchTerm, setInventorySearchTerm] = useState('');
    const [selectedCalendarDate, setSelectedCalendarDate] = useState(null);
    const [selectedOwner, setSelectedOwner] = useState(null);
    
    const [aiSuggestionText, setAISuggestionText] = useState('');
    const [isGeneratingAIText, setIsGeneratingAIText] = useState(false);
    const [reminderTextDraft, setReminderTextDraft] = useState('Merhaba [HastaSahibiAdi], [HayvanAdi] için aşı/tedavi zamanı gelmiştir. Detaylı bilgi ve randevu için lütfen kliniğimizle iletişime geçin. Geçmiş olsun dileklerimizle.');
    const [isGeneratingReminderText, setIsGeneratingReminderText] = useState(false);
    const cleanupRan = useRef(false); 

    const [uniqueDiagnoses, setUniqueDiagnoses] = useState([]);
    
    const [currentPage, setCurrentPage] = useState(1);
    const [patientsPerPage] = useState(10); 

    const handleRegister = async (email, password) => {
        setAuthError('');
        try {
            await createUserWithEmailAndPassword(auth, email, password);
        } catch (error) {
            if (error.code === 'auth/email-already-in-use') setAuthError('Bu e-posta adresi zaten kullanılıyor.');
            else if (error.code === 'auth/weak-password') setAuthError('Şifre en az 6 karakter olmalıdır.');
            else setAuthError('Kayıt sırasında bir hata oluştu. Lütfen tekrar deneyin.');
        }
    };

    const handleLogin = async (email, password) => {
        setAuthError('');
        try {
            await signInWithEmailAndPassword(auth, email, password);
        } catch (error) {
            setAuthError('E-posta veya şifre hatalı.');
        }
    };
    
    const handleLogout = async () => {
        try {
            await signOut(auth);
            setPatients([]); setReminders([]); setInventoryItems([]); setCreditSales([]); setAllVisits([]);
            setCurrentUser(null); setUserId(null); setActiveUser(null); setViewMode('entry');
        } catch (error) {
            setNotification("Çıkış yapılamadı. Lütfen tekrar deneyin.");
        }
    };

    useEffect(() => {
        if (!auth) { setIsAuthReady(true); return; }
        const unsubscribe = onAuthStateChanged(auth, async (user) => {
            if (user) {
                setCurrentUser(user); 
                setUserId(user.uid);
                setIsAuthReady(true);
            } else {
                const initialAuthToken = typeof window.__initial_auth_token !== 'undefined' ? window.__initial_auth_token : null;
                try {
                    if (initialAuthToken) {
                        try { 
                            await signInWithCustomToken(auth, initialAuthToken); 
                        } catch (e) { 
                            await signInAnonymously(auth); 
                        }
                    } else { 
                        await signInAnonymously(auth); 
                    }
                } catch (error) {
                    console.error("Anonim giriş başarısız oldu. Firebase konsolundan 'Anonymous' girişi aktif etmeniz gerekebilir:", error);
                } finally {
                    // Hata fırlatsa bile Yükleniyor ekranını kaldır!
                    setIsAuthReady(true); 
                }
            }
        });
        return () => unsubscribe();
    }, []);

    const setNotification = useCallback((message) => {
        setNotificationMessage(message); setIsNotificationModalOpen(true);
    }, []);

    const fetchData = useCallback((collectionName, setData, collectionPathFn, orderByField = null, orderDirection = "asc") => {
        if (!userId || !db) return; 
        const colPath = collectionPathFn(appId, userId);
        let q = orderByField ? query(collection(db, colPath), orderBy(orderByField, orderDirection)) : query(collection(db, colPath));

        const unsubscribe = onSnapshot(q, (snapshot) => {
            setData(snapshot.docs.map(d => ({ id: d.id, ...d.data() })));
        }, (error) => setNotification(`${collectionName} verileri çekilemedi.`));
        return unsubscribe;
    }, [userId, setNotification]);

    useEffect(() => {
        if (!isAuthReady || !userId) {
            setPatients([]); setReminders([]); setInventoryItems([]); setUniqueDiagnoses([]); setCreditSales([]); setAllVisits([]); return;
        }

        const unsubPatients = fetchData("Hasta", setPatients, (appId, userId) => `artifacts/${appId}/users/${userId}/patients`, "ownerName"); 
        const unsubReminders = fetchData("Hatırlatma", setReminders, (appId, userId) => `artifacts/${appId}/users/${userId}/reminders`, "reminderDate", "desc");
        const unsubInventory = fetchData("Stok", setInventoryItems, (appId, userId) => `artifacts/${appId}/users/${userId}/inventory`, "itemName");
        const unsubDiagnoses = fetchData("uniqueDiagnoses", setUniqueDiagnoses, (appId, userId) => `artifacts/${appId}/users/${userId}/uniqueDiagnoses`, "name");
        const unsubCreditSales = fetchData("İlaç Satış", setCreditSales, (appId, userId) => `artifacts/${appId}/users/${userId}/creditSales`, "saleDate", "desc");
        
        const visitsQuery = query(collectionGroup(db, 'visits'), where('userId', '==', userId));
        const unsubAllVisits = onSnapshot(visitsQuery, (snapshot) => {
            setAllVisits(snapshot.docs.map(doc => {
                 const data = doc.data();
                 return { 
                    id: doc.id, ...data,
                    visitCost: Number(data.visitCost) || 0, 
                    paymentAmount: Number(data.paymentAmount) || 0, 
                    remainingDebt: Number(data.remainingDebt) || 0, 
                 };
            }));
        }, (error) => setNotification("Genel borç hesaplaması için ziyaret verileri çekilemedi."));

        return () => {
            if(unsubPatients) unsubPatients(); if(unsubReminders) unsubReminders(); if(unsubInventory) unsubInventory();
            if(unsubDiagnoses) unsubDiagnoses(); if(unsubCreditSales) unsubCreditSales(); if(unsubAllVisits) unsubAllVisits();
        };
    }, [isAuthReady, userId, fetchData]);
    
    useEffect(() => {
        const now = new Date();
        const dayBefore = new Date(now); dayBefore.setDate(now.getDate() - 1); dayBefore.setHours(0, 0, 0, 0);
        const dayAfterTomorrow = new Date(now); dayAfterTomorrow.setDate(now.getDate() + 2); dayAfterTomorrow.setHours(0, 0, 0, 0);

        setTodaysReminders(reminders.filter(r => {
            const reminderDate = r.reminderDate?.toDate();
            return reminderDate && reminderDate >= dayBefore && reminderDate < dayAfterTomorrow && r.status === 'pending';
        }).sort((a, b) => (a.reminderDate?.toDate() || 0) - (b.reminderDate?.toDate() || 0)));
    }, [reminders]);

    useEffect(() => {
        if (!isAuthReady || !userId || !db || !currentPatient?.id) { setVisits([]); return; }
        const visitsColPath = `artifacts/${appId}/users/${userId}/patients/${currentPatient.id}/visits`;
        const q = query(collection(db, visitsColPath), orderBy("visitDate", "desc"), limit(50));
        const unsubscribe = onSnapshot(q, (snapshot) => setVisits(snapshot.docs.map(d => ({ id: d.id, ...d.data() }))));
        return () => unsubscribe();
    }, [isAuthReady, userId, currentPatient, setNotification]);

    useEffect(() => {
        if (reminders.length > 0 && !cleanupRan.current && userId && db) {
            cleanupRan.current = true;
            const deleteOldReminders = async () => {
                const oneMonthAgo = new Date(); oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);
                const oldRemindersToDelete = reminders.filter(r => r.status !== 'pending' && r.reminderDate?.toDate() < oneMonthAgo);
                if (oldRemindersToDelete.length > 0) {
                    try {
                        const batch = writeBatch(db);
                        oldRemindersToDelete.forEach(reminder => {
                            batch.delete(doc(db, `artifacts/${appId}/users/${userId}/reminders/${reminder.id}`));
                            batch.delete(doc(db, `artifacts/${appId}/public/data/patient_reminders/${reminder.patientId}/reminders/${reminder.id}`));
                        });
                        await batch.commit();
                    } catch (error) {}
                }
            };
            setTimeout(deleteOldReminders, 5000);
        }
    }, [reminders, userId, db, appId]);
    
    useEffect(() => {
        if (!isAuthReady || !userId) return;
        const today = new Date();
        const currentMonthKey = `backupNotification_${today.getFullYear()}-${today.getMonth()}`;
        if (today.getDate() > 24 && !localStorage.getItem(currentMonthKey)) {
             setConfirmAction(() => () => setIsBackupModalOpen(true));
            setConfirmMessage("Bu ayın sonuna yaklaştık. Klinik verilerinizin yedeğini almak ister misiniz?");
            setIsConfirmModalOpen(true);
            localStorage.setItem(currentMonthKey, 'shown');
        }
    }, [isAuthReady, userId]);

    const generatePublicId = () => {
        const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZ2345789';
        let result = '';
        for (let i = 0; i < 6; i++) result += chars.charAt(Math.floor(Math.random() * chars.length));
        return result;
    };

    const handleSendNewPatientWelcomeMessage = (patient) => {
        if (!patient || !patient.ownerPhone) return;
        const message = `Sn. ${patient.ownerName},\n\nÇETİN VETERİNER KLİNİĞİ ailesine hoş geldiniz! Kaydınız oluşturulmuştur.\nPortal ID'niz: ${patient.publicId}\n${patient.name} için randevu ve takip bilgileriniz bu ID üzerinden erişilebilir.\n\nİyi günler dileriz.`;
        openSendMessageModal(patient.ownerPhone, message, null);
    };

    const handleSavePatient = async (patientData, sendWelcomeMessage) => {
        if (!userId || !db) return setNotification("Kullanıcı doğrulanmadı veya veritabanı hazır değil.");
        setIsSavingPatient(true);
        const patientsColPath = `artifacts/${appId}/users/${userId}/patients`;
        const publicPortalsColPath = `artifacts/${appId}/public`;

        try {
            const dataToSave = { 
                ...patientData, userId,
                weight: Number(patientData.weight) || null,
                lastDiagnosis: patientData.lastDiagnosis || '-', 
                lastVisitDate: patientData.lastVisitDate || null,
                ...( !patientToEdit && { createdAt: Timestamp.now() } )
            };
            if (dataToSave.birthDate) dataToSave.birthDate = Timestamp.fromDate(new Date(dataToSave.birthDate));
            if (dataToSave.boardingStartDate) dataToSave.boardingStartDate = Timestamp.fromDate(new Date(dataToSave.boardingStartDate));
            if (dataToSave.boardingEndDate) dataToSave.boardingEndDate = Timestamp.fromDate(new Date(dataToSave.boardingEndDate));
            
            let ownerId = patientToEdit?.ownerId;
            const ownerName = dataToSave.ownerName.trim();
            
            if (!patientToEdit) {
                 const q = query(collection(db, patientsColPath), where("ownerName", "==", ownerName), where("userId", "==", userId), limit(1));
                 const existingOwnerPatients = await getDocs(q);
                 ownerId = existingOwnerPatients.empty ? generatePublicId() : existingOwnerPatients.docs[0].data().publicId; 
            } else {
                 ownerId = patientToEdit.publicId; 
            }
            
            dataToSave.ownerId = ownerId;
            dataToSave.publicId = ownerId; 

            if (patientToEdit) {
                await updateDoc(doc(db, patientsColPath, patientToEdit.id), dataToSave);
                const publicPortalRef = doc(db, publicPortalsColPath, patientToEdit.publicId);
                const publicPortalSnap = await getDoc(publicPortalRef);
                if (publicPortalSnap.exists()) {
                    const patientsArray = publicPortalSnap.data().patients || [];
                    const updatedPatientsArray = patientsArray.map(p => p.id === patientToEdit.id ? { id: p.id, name: dataToSave.name, species: dataToSave.species } : p);
                    await updateDoc(publicPortalRef, { ownerName: dataToSave.ownerName, patients: updatedPatientsArray });
                }
                setNotification("Hasta başarıyla güncellendi!");
            } else {
                await runTransaction(db, async (transaction) => {
                    const publicPortalRef = doc(db, publicPortalsColPath, ownerId);
                    const publicPortalDoc = await transaction.get(publicPortalRef);
                    const newPatientDocRef = doc(collection(db, patientsColPath));
                    transaction.set(newPatientDocRef, dataToSave);
                    const newPatientInfo = { id: newPatientDocRef.id, name: dataToSave.name, species: dataToSave.species };
                    
                    if (publicPortalDoc.exists()) {
                        transaction.update(publicPortalRef, { patients: [...(publicPortalDoc.data().patients || []), newPatientInfo], ownerName: dataToSave.ownerName });
                    } else {
                        transaction.set(publicPortalRef, { userId: userId, ownerName: dataToSave.ownerName.trim(), createdAt: Timestamp.now(), patients: [newPatientInfo] });
                    }
                });
                setNotification("Hasta başarıyla eklendi!");
                if (sendWelcomeMessage) handleSendNewPatientWelcomeMessage(dataToSave); 
            }
            closePatientModal();
        } catch (e) {
            setNotification(`Hasta kaydedilemedi: ${e.message}`);
        } finally {
            setIsSavingPatient(false);
        }
    };

   const handleDeletePatient = async (patientId) => {
    if (!userId || !db) return setNotification("Kullanıcı doğrulanmadı veya veritabanı hazır değil.");

    setConfirmAction(() => async () => {
        try {
            const patientRef = doc(db, `artifacts/${appId}/users/${userId}/patients/${patientId}`);
            const patientSnap = await getDoc(patientRef);
            if (!patientSnap.exists()) throw new Error("Silinecek hasta bulunamadı.");

            const { publicId } = patientSnap.data(); 
            const batch = writeBatch(db);
            batch.delete(patientRef);

            const visitsSnap = await getDocs(query(collection(patientRef, 'visits')));
            visitsSnap.forEach(visitDoc => batch.delete(visitDoc.ref));
            
            const herdEventsSnap = await getDocs(query(collection(patientRef, 'herdEvents')));
            herdEventsSnap.forEach(eventDoc => batch.delete(eventDoc.ref));

            const remindersSnap = await getDocs(query(collection(db, `artifacts/${appId}/users/${userId}/reminders`), where("patientId", "==", patientId)));
            remindersSnap.forEach(remDoc => batch.delete(remDoc.ref));
            
            const publicRemindersSnap = await getDocs(query(collection(db, `artifacts/${appId}/public/data/patient_reminders/${patientId}/reminders`)));
            publicRemindersSnap.forEach(doc => batch.delete(doc.ref));
            
            const publicVisitsSnap = await getDocs(query(collection(db, `artifacts/${appId}/public/data/patient_visits/${patientId}/visits`)));
            publicVisitsSnap.forEach(doc => batch.delete(doc.ref));

            if (publicId) {
                const publicPortalRef = doc(db, `artifacts/${appId}/public`, publicId);
                const publicPortalSnap = await getDoc(publicPortalRef);
                if (publicPortalSnap.exists()) {
                    const updatedPatientsArray = (publicPortalSnap.data().patients || []).filter(p => p.id !== patientId);
                    if (updatedPatientsArray.length > 0) {
                        batch.update(publicPortalRef, { patients: updatedPatientsArray });
                    } else {
                        batch.delete(publicPortalRef);
                        const creditSalesSnap = await getDocs(query(collection(db, `artifacts/${appId}/users/${userId}/creditSales`), where("ownerId", "==", publicId), where("status", "in", ["unpaid", "partially-paid"])));
                        creditSalesSnap.forEach(csDoc => {
                            batch.update(csDoc.ref, { patientName: 'SİLİNEN HASTA', patientId: null, notes: (csDoc.data().notes || '') + ' - ÖNEMLİ: Bu satışın hastası silindi.' });
                        });
                    }
                }
            }

            await batch.commit();
            setNotification("Hasta başarıyla silindi. Sahibe ait finansal borç kaydı korunmuştur.");
            if (currentPatient?.id === patientId) closePatientDetailModal();
        } catch (e) {
            setNotification(`Hasta silinemedi: ${e.message}`);
        } finally {
            setIsConfirmModalOpen(false);
        }
    });
    setConfirmMessage("Bu hastayı ve tüm ilişkili kayıtları silmek istediğinizden emin misiniz? Bu işlem geri alınamaz ve sahibine ait borç kayıtları korunacaktır.");
    setIsConfirmModalOpen(true);
};

    const handleSaveReminder = async (formDataFromForm) => {
        if (!userId || !db || !currentPatient) return;
        setIsSavingReminder(true);
        const remindersColPath = `artifacts/${appId}/users/${userId}/reminders`;
        const { treatmentId, customTreatmentName, parasiteType: formParasiteType, ...reminderData } = formDataFromForm; 

        try {
            const batch = writeBatch(db);
            let mainReminderDescription = reminderData.description || '';
            const scheduleForSpecies = currentPatient?.species ? window.treatmentSchedules[currentPatient.species] : [];
            const savedTreatmentName = treatmentId === "Diger" ? customTreatmentName : scheduleForSpecies?.find(v => v.id === treatmentId)?.name;

            if ((reminderData.reminderType === 'Aşı' || reminderData.reminderType === 'Parazit Tedavisi') && savedTreatmentName) {
                if (!mainReminderDescription.includes(savedTreatmentName)) mainReminderDescription = `${savedTreatmentName}${mainReminderDescription ? ' - ' + mainReminderDescription : ''}`;
            }
            
            let parasiteTypeValue = null;
            if (reminderData.reminderType === 'Parazit Tedavisi') {
                if (treatmentId && treatmentId !== "Diger") parasiteTypeValue = scheduleForSpecies?.find(t => t.id === treatmentId)?.parasiteType || null;
                else if (treatmentId === "Diger") parasiteTypeValue = formParasiteType || null;
            } else if (reminderData.reminderType === 'Sürü Takibi') {
                 const scheduleEntry = (window.treatmentSchedules["Sürü"] || []).find(t => t.name === reminderData.eventType);
                 if (!mainReminderDescription.includes(scheduleEntry?.name)) mainReminderDescription = `${scheduleEntry?.name}${mainReminderDescription ? ' - ' + mainReminderDescription : ''}`;
            }

            const mainReminderData = {
                patientId: currentPatient.id, patientName: currentPatient.name, ownerPhone: currentPatient.ownerPhone,
                reminderDate: Timestamp.fromDate(new Date(reminderData.reminderDate)), reminderType: reminderData.reminderType,
                description: mainReminderDescription, treatmentId: treatmentId, customTreatmentName: treatmentId === "Diger" ? customTreatmentName : null,
                parasiteType: parasiteTypeValue, status: 'pending', userId, eventType: reminderData.eventType || null, 
            };
            
            const newMainReminderRef = doc(collection(db, remindersColPath));
            batch.set(newMainReminderRef, mainReminderData);
            batch.set(doc(db, `artifacts/${appId}/public/data/patient_reminders/${currentPatient.id}/reminders`, newMainReminderRef.id), {
                reminderDate: mainReminderData.reminderDate, reminderType: mainReminderData.reminderType, description: mainReminderData.description, status: 'pending'
            });

            let notificationMsg = "Hatırlatma başarıyla eklendi!";

            const createFollowUpReminder = (fDate, fDesc, nTreatId, nParType, rTypeOverride = mainReminderData.reminderType, eTypeOverride = mainReminderData.eventType) => {
                const fData = { ...mainReminderData, reminderDate: Timestamp.fromDate(fDate), description: fDesc, treatmentId: nTreatId, parasiteType: nParType, reminderType: rTypeOverride, eventType: eTypeOverride };
                const nRef = doc(collection(db, remindersColPath));
                batch.set(nRef, fData);
                batch.set(doc(db, `artifacts/${appId}/public/data/patient_reminders/${currentPatient.id}/reminders`, nRef.id), { reminderDate: fData.reminderDate, reminderType: fData.reminderType, description: fData.description, status: 'pending' });
            };

            if (reminderData.reminderType === 'Sürü Takibi' && reminderData.eventType) {
                const baseDate = mainReminderData.reminderDate.toDate();
                const scheduleEntry = window.treatmentSchedules["Sürü"].find(t => t.name === reminderData.eventType);
                if (scheduleEntry?.defaultFollowUpDays) {
                    scheduleEntry.defaultFollowUpDays.forEach((days, index) => {
                        const followUpDate = new Date(baseDate); followUpDate.setDate(baseDate.getDate() + days);
                        createFollowUpReminder(followUpDate, scheduleEntry.defaultFollowUpNames[index] || `${scheduleEntry.name} Takibi`, `st_takip_${days}`, null, 'Sürü Takibi', reminderData.eventType);
                        notificationMsg += ` ${days} gün sonrasına takip hatırlatması eklendi.`;
                    });
                }
            } else if (treatmentId && treatmentId !== "Diger") {
                const scheduleEntry = scheduleForSpecies?.find(v => v.id === treatmentId);
                if (scheduleEntry) {
                    const savedName = treatmentId === "Diger" ? customTreatmentName : scheduleEntry.name;
                    if (scheduleEntry?.followUp) {
                        const followUpDate = new Date(mainReminderData.reminderDate.toDate()); followUpDate.setDate(followUpDate.getDate() + scheduleEntry.followUp.days);
                        const nextDoseEntry = scheduleForSpecies?.find(v => v.id === scheduleEntry.followUp.nextDoseId);
                        createFollowUpReminder(followUpDate, nextDoseEntry ? `${nextDoseEntry.name}${nextDoseEntry.note ? ' (' + nextDoseEntry.note + ')' : ''}` : `${savedName} - Takip Dozu`, scheduleEntry.followUp.nextDoseId, nextDoseEntry?.parasiteType);
                        notificationMsg += ` ${scheduleEntry.followUp.days} gün sonrasına takip eklendi.`;
                    } else if (scheduleEntry?.monthlyNote) {
                        const followUpDate = new Date(mainReminderData.reminderDate.toDate()); followUpDate.setMonth(followUpDate.getMonth() + 1);
                        createFollowUpReminder(followUpDate, `${savedName} (${scheduleEntry.monthlyNote})`, treatmentId, scheduleEntry.parasiteType);
                    } else if (scheduleEntry?.annualNote && scheduleEntry.isFinalSystemDose) {
                        const followUpDate = new Date(mainReminderData.reminderDate.toDate()); followUpDate.setFullYear(followUpDate.getFullYear() + 1);
                        createFollowUpReminder(followUpDate, `${savedName} (${scheduleEntry.annualNote})`, treatmentId, scheduleEntry.parasiteType);
                    }
                }
            }
            await batch.commit();
            setNotification(notificationMsg); closeReminderModal();
        } catch (e) { setNotification(`Hata: ${e.message}`); } finally { setIsSavingReminder(false); }
    };

    const handleMarkReminderAsSent = async (reminderId) => {
        if (!userId || !db) return;
        const reminder = reminders.find(r => r.id === reminderId);
        if (!reminder) return;
        try {
            const batch = writeBatch(db);
            batch.update(doc(db, `artifacts/${appId}/users/${userId}/reminders/${reminderId}`), { status: 'sent', sentDate: Timestamp.now() });
            batch.update(doc(db, `artifacts/${appId}/public/data/patient_reminders/${reminder.patientId}/reminders/${reminderId}`), { status: 'sent', sentDate: Timestamp.now() });
            await batch.commit();
            setNotification(`${reminder.patientName} için hatırlatma gönderildi işaretlendi.`);
        } catch (e) {}
    };
    
    const handleDeleteReminder = async (reminderId) => {
        if (!userId || !db) return;
        const reminderToDelete = reminders.find(r => r.id === reminderId);
        if (!reminderToDelete) return;

        setConfirmAction(() => async () => {
            try {
                const batch = writeBatch(db);
                batch.delete(doc(db, `artifacts/${appId}/users/${userId}/reminders/${reminderId}`));
                batch.delete(doc(db, `artifacts/${appId}/public/data/patient_reminders/${reminderToDelete.patientId}/reminders/${reminderId}`));
                await batch.commit();
                setNotification("Hatırlatma silindi.");
            } catch (e) {} finally { setIsConfirmModalOpen(false); }
        });
        setConfirmMessage("Bu hatırlatmayı kalıcı olarak silmek istediğinizden emin misiniz?");
        setIsConfirmModalOpen(true);
    };

    const handleSaveVisit = async (visitData, usedStockItems, nonStockItemsUsed) => {
        if (!userId || !db || !currentPatient || !activeUser) return;
        setIsSavingVisit(true);

        const visitsColPath = `artifacts/${appId}/users/${userId}/patients/${currentPatient.id}/visits`;
        const publicVisitsColPath = `artifacts/${appId}/public/data/patient_visits/${currentPatient.id}/visits`;

        try {
            await runTransaction(db, async (transaction) => {
                const inventoryColPath = `artifacts/${appId}/users/${userId}/inventory`;
                const allItemsUsed = [...usedStockItems.map(item => ({...item, isStock: true})), ...nonStockItemsUsed.map(item => ({...item, isStock: false}))];
                const stockItemsToDeductIds = new Set(usedStockItems.filter(item => item.inventoryItemId).map(item => item.inventoryItemId));
                
                if (visitToEdit && visitToEdit.usedStockItems) {
                    visitToEdit.usedStockItems.filter(item => item.isStock && item.inventoryItemId).forEach(item => stockItemsToDeductIds.add(item.inventoryItemId));
                }

                const stockRefsToRead = Array.from(stockItemsToDeductIds).map(id => doc(db, inventoryColPath, id));
                const stockSnapshots = await Promise.all(stockRefsToRead.map(ref => transaction.get(ref)));

                let diagnosisRef = null;
                if (visitData.diagnosis && visitData.diagnosis.trim() !== '') {
                    diagnosisRef = doc(db, `artifacts/${appId}/users/${userId}/uniqueDiagnoses`, `${visitData.diagnosis.trim()}_${currentPatient.species}`);
                }
                const patientRef = doc(db, `artifacts/${appId}/users/${userId}/patients`, currentPatient.id);
                await transaction.get(patientRef); 

                const stockQuantitiesToUpdate = new Map();
                for (const snapshot of stockSnapshots) {
                    if (snapshot.exists()) stockQuantitiesToUpdate.set(snapshot.id, Number(snapshot.data().quantityInStock));
                }

                if (visitToEdit && visitToEdit.usedStockItems) {
                    for (const oldUsedItem of visitToEdit.usedStockItems.filter(item => item.isStock)) {
                        const itemId = oldUsedItem.inventoryItemId;
                        if (stockQuantitiesToUpdate.has(itemId)) stockQuantitiesToUpdate.set(itemId, stockQuantitiesToUpdate.get(itemId) + Number(oldUsedItem.quantityUsed));
                    }
                }
                
                for (const newItem of usedStockItems) {
                    const itemId = newItem.inventoryItemId; const quantityToUse = Number(newItem.quantityUsed);
                    if (!itemId || quantityToUse <= 0) continue;
                    if (stockQuantitiesToUpdate.has(itemId)) {
                        const currentQuantity = stockQuantitiesToUpdate.get(itemId);
                        const newQuantity = currentQuantity - quantityToUse;
                        if (newQuantity < 0) throw new Error("Yetersiz stok!");
                        stockQuantitiesToUpdate.set(itemId, newQuantity);
                    }
                }

                for (const [itemId, newQuantity] of stockQuantitiesToUpdate.entries()) {
                    transaction.update(doc(db, inventoryColPath, itemId), { quantityInStock: newQuantity });
                }

                const dataToSave = { 
                    ...visitData, 
                    visitCost: Number(visitData.visitCost) || 0, 
                    paymentAmount: Number(visitData.paymentAmount) || 0, 
                    remainingDebt: Math.round(((Number(visitData.visitCost) || 0) - (Number(visitData.paymentAmount) || 0)) * 100) / 100, 
                    usedStockItems: allItemsUsed, patientId: currentPatient.id, userId, performedBy: activeUser.name, performedByEmail: currentUser.email, isCreditSale: false, isPrescriptionOnly: false, isPaymentRecord: false, 
                };
                if (dataToSave.visitDate) dataToSave.visitDate = Timestamp.fromDate(new Date(dataToSave.visitDate));
                if (dataToSave.nextRevisitDate) dataToSave.nextRevisitDate = Timestamp.fromDate(new Date(dataToSave.nextRevisitDate));

                const visitRef = visitToEdit ? doc(db, visitsColPath, visitToEdit.id) : doc(collection(db, visitsColPath));
                transaction.set(visitRef, dataToSave);

                const publicVisitData = {
                    visitDate: dataToSave.visitDate, diagnosis: dataToSave.diagnosis || "Belirtilmemiş", procedures: dataToSave.procedures || "", notes: "", isCreditSale: false, isPrescriptionOnly: false, visitCost: dataToSave.visitCost, paymentAmount: dataToSave.paymentAmount, remainingDebt: dataToSave.remainingDebt,
                    usedStockItems: allItemsUsed.map(item => ({ itemName: item.itemName, quantityUsed: item.quantityUsed, isStock: item.isStock || false, unitPrice: item.unitPrice || 0, unit: item.unit || 'Adet' }))
                };
                transaction.set(doc(db, publicVisitsColPath, visitRef.id), publicVisitData);

                if (diagnosisRef && visitData.diagnosis.trim() !== '') {
                    transaction.set(diagnosisRef, { name: visitData.diagnosis.trim(), species: currentPatient.species, createdAt: Timestamp.now(), userId }, {merge: true});
                }

                if (dataToSave.nextRevisitDate && !visitToEdit) { 
                    transaction.set(doc(collection(db, `artifacts/${appId}/users/${userId}/reminders`)), { patientId: currentPatient.id, patientName: currentPatient.name, ownerPhone: currentPatient.ownerPhone, reminderDate: dataToSave.nextRevisitDate, reminderType: "Sonraki Kontrol", description: "Planlanan kontrol.", status: 'pending', userId });
                }

                const patientUpdateData = { lastVisitDate: dataToSave.visitDate };
                if (visitData.diagnosis && visitData.diagnosis.trim() !== '') patientUpdateData.lastDiagnosis = visitData.diagnosis.trim();
                if (visitData.bodyWeight) patientUpdateData.weight = parseFloat(visitData.bodyWeight);
                transaction.update(patientRef, patientUpdateData);
            });
            setNotification(visitToEdit ? "Ziyaret başarıyla güncellendi!" : "Ziyaret başarıyla eklendi!");
            closeVisitModal();
        } catch (e) { setNotification(`Hata: ${e.message}`); } finally { setIsSavingVisit(false); }
    };

    const handleDeleteVisit = async (visitId) => {
        if (!userId || !db || !currentPatient) return;
        setConfirmAction(() => async () => {
            try {
                await deleteDoc(doc(db, `artifacts/${appId}/users/${userId}/patients/${currentPatient.id}/visits/${visitId}`));
                await deleteDoc(doc(db, `artifacts/${appId}/public/data/patient_visits/${currentPatient.id}/visits/${visitId}`));
                setNotification("Ziyaret kaydı silindi.");
            } catch (e) {} finally { setIsConfirmModalOpen(false); }
        });
        setConfirmMessage("Bu ziyareti silmek istediğinizden emin misiniz? (Stok iadesi otomatik yapılmaz)");
        setIsConfirmModalOpen(true);
    };

    const handleSaveInventoryItem = async (itemData) => {
        if (!userId || !db) return;
        setIsSavingInventory(true);
        try {
            const dataToSave = { 
                ...itemData, userId, 
                quantityInStock: Number(itemData.quantityInStock) || 0, unitPrice: Number(itemData.unitPrice) || 0,
                bottleML: Number(itemData.bottleML) || 0, lowStockThreshold: Number(itemData.lowStockThreshold) || 5,
            };
            if(dataToSave.expiryDate) dataToSave.expiryDate = Timestamp.fromDate(new Date(dataToSave.expiryDate));

            if (inventoryItemToEdit) {
                await updateDoc(doc(db, `artifacts/${appId}/users/${userId}/inventory`, inventoryItemToEdit.id), dataToSave);
            } else {
                await addDoc(collection(db, `artifacts/${appId}/users/${userId}/inventory`), dataToSave);
            }
            setNotification("Stok ürünü kaydedildi."); closeInventoryItemModal();
        } catch (e) {} finally { setIsSavingInventory(false); }
    };

    const handleDeleteInventoryItem = async (itemId) => {
        if (!userId || !db) return;
        setConfirmAction(() => async () => {
            try {
                await deleteDoc(doc(db, `artifacts/${appId}/users/${userId}/inventory/${itemId}`));
                setNotification("Stok ürünü silindi.");
            } catch (e) {} finally { setIsConfirmModalOpen(false); }
        });
        setConfirmMessage("Bu stok ürününü silmek istediğinizden emin misiniz?");
        setIsConfirmModalOpen(true);
    };
    
    // GÜNCELLEME: İlaç Satışında Doğrudan Sahibe Satış İmkanı
    const handleSaveCreditSale = async (saleData, items, editingSale, sendWhatsAppNotification) => {
        if (!userId || !db || !activeUser) return;
        if (items.length === 0) return setNotification("Ürün ekleyin.");
        setIsSavingCreditSale(true);

        try {
            const ownerId = saleData.ownerId;
            const ownerName = saleData.ownerName;
            
            // patientId opsiyonel, referans amaçlı.
            const patient = saleData.patientId ? patients.find(p => p.id === saleData.patientId) : null;

            await runTransaction(db, async (transaction) => {
                const allItemIds = new Set(items.filter(i => i.isStockItem).map(i => i.inventoryItemId));
                if (editingSale) editingSale.items.filter(i => i.isStockItem).forEach(i => allItemIds.add(i.inventoryItemId));
                
                const stockSnapshots = await Promise.all(Array.from(allItemIds).map(id => transaction.get(doc(db, `artifacts/${appId}/users/${userId}/inventory`, id))));
                
                let existingVisitDoc = null;
                if (editingSale && editingSale.visitId && editingSale.patientId) {
                     existingVisitDoc = await transaction.get(doc(db, `artifacts/${appId}/users/${userId}/patients/${editingSale.patientId}/visits`, editingSale.visitId));
                }

                const stockUpdates = new Map();
                for (const snapshot of stockSnapshots) {
                    if (snapshot.exists()) stockUpdates.set(snapshot.id, Number(snapshot.data().quantityInStock) || 0);
                }

                if (editingSale) {
                    for (const oldItem of editingSale.items.filter(i => i.isStockItem)) {
                        const currentQty = stockUpdates.get(oldItem.inventoryItemId);
                        if (currentQty !== undefined) stockUpdates.set(oldItem.inventoryItemId, currentQty + (Number(oldItem.quantity) || 0));
                    }
                }

                for (const newItem of items.filter(i => i.isStockItem)) {
                    const itemId = newItem.inventoryItemId; const qtyToUse = Number(newItem.quantity);
                    if (!itemId || qtyToUse <= 0) continue;
                    if (stockUpdates.has(itemId)) {
                        const newQty = stockUpdates.get(itemId) - qtyToUse;
                        if (newQty < 0) throw new Error("Yetersiz stok!");
                        stockUpdates.set(itemId, newQty);
                    }
                }
                
                for (const [itemId, newQuantity] of stockUpdates.entries()) {
                    transaction.update(doc(db, `artifacts/${appId}/users/${userId}/inventory`, itemId), { quantityInStock: newQuantity });
                }

                const totalAmount = items.reduce((sum, item) => sum + (Number(item.quantity) * Number(item.priceAtSale)), 0);
                
                const finalSaleData = {
                    ...saleData, saleDate: Timestamp.fromDate(new Date(saleData.saleDate)),
                    ownerId: ownerId, 
                    ownerName: ownerName,
                    patientName: patient ? patient.name : 'Sahibe Doğrudan Satış',
                    patientId: patient ? patient.id : null,
                    items: items.map(item => ({
                        itemId: item.itemId || crypto.randomUUID(), inventoryItemId: item.inventoryItemId || null, itemName: item.itemName,
                        quantity: Number(item.quantity) || 0, priceAtSale: Number(item.priceAtSale) || 0, isStockItem: item.isStockItem || false, unit: item.unit || 'Adet',
                        paidQuantity: editingSale ? (Number(editingSale.items.find(eItem => eItem.itemId === item.itemId)?.paidQuantity) || 0) : 0, 
                    })),
                    totalAmount: totalAmount, userId, performedBy: activeUser.name, performedByEmail: currentUser.email,
                };
                
                const newTotalPaidAmount = finalSaleData.items.reduce((sum, item) => sum + ((Number(item.paidQuantity) || 0) * (Number(item.priceAtSale) || 0)), 0);
                finalSaleData.paidAmount = newTotalPaidAmount;
                finalSaleData.status = finalSaleData.items.every(item => (Number(item.paidQuantity) || 0) >= (Number(item.quantity) || 0)) ? 'paid' : (newTotalPaidAmount > 0 ? 'partially-paid' : 'unpaid');

                let currentVisitRef = null;
                const creditSalesColRef = collection(db, `artifacts/${appId}/users/${userId}/creditSales`);

                if (editingSale) {
                    transaction.update(doc(creditSalesColRef, editingSale.id), finalSaleData);
                    // Eğer eski satışta bir visit varsa güncelleyelim
                    if (editingSale.visitId && existingVisitDoc?.exists()) {
                        currentVisitRef = doc(db, `artifacts/${appId}/users/${userId}/patients/${editingSale.patientId}/visits`, editingSale.visitId);
                        transaction.update(currentVisitRef, {
                            visitCost: finalSaleData.totalAmount, paymentAmount: finalSaleData.paidAmount || 0, remainingDebt: finalSaleData.totalAmount - (finalSaleData.paidAmount || 0),
                            procedures: `İlaç Satış Güncellendi`,
                            notes: `Satılan ürünler güncellendi: ${finalSaleData.items.map(i => `${i.itemName} (x${i.quantity} ${i.unit})`).join(', ')}`,
                            usedStockItems: finalSaleData.items.map(i => ({ itemName: i.itemName, quantityUsed: i.quantity, isStock: i.isStockItem, unitPrice: i.priceAtSale, unit: i.unit })),
                        });
                    }
                } else {
                    const newSaleRef = doc(creditSalesColRef);
                    transaction.set(newSaleRef, finalSaleData);

                    // Sadece hasta seçildiyse visit oluştur (Geçmişe not düşmek için)
                    if (patient) {
                        currentVisitRef = doc(collection(db, `artifacts/${appId}/users/${userId}/patients/${patient.id}/visits`));
                        finalSaleData.visitId = currentVisitRef.id;
                        transaction.update(newSaleRef, { visitId: currentVisitRef.id });

                        transaction.set(currentVisitRef, {
                            visitId: currentVisitRef.id, creditSaleId: newSaleRef.id, patientId: patient.id, visitDate: finalSaleData.saleDate,
                            visitCost: finalSaleData.totalAmount, paymentAmount: finalSaleData.paidAmount || 0, remainingDebt: finalSaleData.totalAmount - (finalSaleData.paidAmount || 0),
                            procedures: `İlaç Satış`, notes: `Satılan ürünler: ${finalSaleData.items.map(i => `${i.itemName} (x${i.quantity} ${i.unit})`).join(', ')}`,
                            userId, performedBy: activeUser.name, performedByEmail: currentUser.email,
                            usedStockItems: finalSaleData.items.map(i => ({ itemName: i.itemName, quantityUsed: i.quantity, isStock: i.isStockItem, unitPrice: i.priceAtSale, unit: i.unit })),
                            isCreditSale: true, isPrescriptionOnly: false, isPaymentRecord: false,
                        });
                    }
                }
                
                if (currentVisitRef && patient) {
                    transaction.set(doc(db, `artifacts/${appId}/public/data/patient_visits/${patient.id}/visits`, currentVisitRef.id), {
                        visitDate: finalSaleData.saleDate, diagnosis: "Finansal Hareket (İlaç Satış)", procedures: `İlaç Satış`,
                        notes: `Satılan Ürünler: ${finalSaleData.items.map(i => `${i.itemName} (x${i.quantity} ${i.unit})`).join(', ')}`,
                        isCreditSale: true, visitCost: finalSaleData.totalAmount, paymentAmount: finalSaleData.paidAmount || 0, remainingDebt: finalSaleData.totalAmount - (finalSaleData.paidAmount || 0),
                        usedStockItems: finalSaleData.items.map(i => ({ itemName: i.itemName, quantityUsed: i.quantity, isStock: i.isStockItem, unitPrice: i.priceAtSale, unit: i.unit })),
                    }, {merge: true});
                }
            });

            setNotification("İlaç satışı kaydedildi.");
            closeCreditSaleForm();
            if (!editingSale && ownerName) {
                // Satış tamamlandıktan sonra tahsilat penceresini aç
                openPaymentCollectionModal(ownerName);
            }

        } catch (error) { setNotification(`Hata: ${error.message}`); } finally { setIsSavingCreditSale(false); }
    };
    
    // GÜNCELLEME: Tahsilat İşlemi (Bulk Payment) - 'path' Hatası Düzeltildi
    const handleProcessBulkPayment = async (ownerPublicId, amount, paymentMethod) => {
        if (!userId || !db || !activeUser) return setNotification("Kullanıcı doğrulanmadı.");
        if (!ownerPublicId) return setNotification("Tahsilat için sahip ID'si eksik.");
        if (amount <= 0) return setNotification("Tahsil edilecek tutar sıfırdan büyük olmalıdır.");
        setIsCollectingPayment(true);

        const ownerPatients = patients.filter(p => p.ownerId === ownerPublicId || p.publicId === ownerPublicId);
        if (ownerPatients.length === 0) {
            setIsCollectingPayment(false);
            return setNotification("Bu sahibe ait hasta bulunamadı. Tahsilat logu oluşturulamıyor.");
        }
        // Tahsilat logunun atılacağı temsili birincil hasta
        const primaryPatient = ownerPatients[0];

        try {
            // 1. OKUMA İŞLEMLERİ (Transaction dışına alındı, 'path' hatasını önlemek için)
            const creditSalesRef = collection(db, `artifacts/${appId}/users/${userId}/creditSales`);
            const salesQuery = query(creditSalesRef, where("ownerId", "==", ownerPublicId), where("status", "in", ["unpaid", "partially-paid"]));
            const salesSnap = await getDocs(salesQuery);
            
            const allVisitsData = [];
            for (const p of ownerPatients) {
                const visitsRef = collection(db, `artifacts/${appId}/users/${userId}/patients/${p.id}/visits`);
                const vSnap = await getDocs(visitsRef);
                vSnap.docs.forEach(doc => {
                    allVisitsData.push({ id: doc.id, ref: doc.ref, patientId: p.id, data: doc.data() });
                });
            }

            // 2. YAZMA İŞLEMLERİ (Batch kullanarak)
            const batch = writeBatch(db);
            let remainingAmount = amount;
            
            // A. İlaç Satışlarını Güncelle (Eskiden Yeniye)
            const salesToUpdate = salesSnap.docs.map(d => ({ref: d.ref, id: d.id, data: d.data()}))
                .sort((a,b) => a.data.saleDate.toDate() - b.data.saleDate.toDate());

            for (const sale of salesToUpdate) {
                if (remainingAmount <= 0) break;
                
                const saleData = sale.data;
                let isUpdated = false;

                for (const item of saleData.items) {
                    if (remainingAmount <= 0) break;
                    const qtyLeft = (Number(item.quantity) || 0) - (Number(item.paidQuantity) || 0);
                    if (qtyLeft > 0) {
                        const price = Number(item.priceAtSale) || 0;
                        const debtForItem = qtyLeft * price;
                        const payForItem = Math.min(remainingAmount, debtForItem);
                        const qtyPaidNow = price > 0 ? payForItem / price : qtyLeft;
                        
                        item.paidQuantity = (Number(item.paidQuantity) || 0) + qtyPaidNow;
                        remainingAmount -= payForItem;
                        isUpdated = true;
                    }
                }

                if (isUpdated) {
                    const newTotalPaid = saleData.items.reduce((s, i) => s + ((Number(i.paidQuantity) || 0) * (Number(i.priceAtSale) || 0)), 0);
                    const status = (saleData.totalAmount - newTotalPaid <= 0.01) ? 'paid' : 'partially-paid';
                    
                    batch.update(sale.ref, { items: saleData.items, paidAmount: newTotalPaid, status });

                    // Eğer satış bir visit ile ilişkiliyse onu da güncelle
                    if (saleData.visitId && saleData.patientId) {
                        const linkedVisit = allVisitsData.find(v => v.id === saleData.visitId);
                        if (linkedVisit) {
                            const newDebt = Math.round((saleData.totalAmount - newTotalPaid) * 100) / 100;
                            batch.update(linkedVisit.ref, { paymentAmount: newTotalPaid, remainingDebt: newDebt });
                            
                            const pubRef = doc(db, `artifacts/${appId}/public/data/patient_visits/${linkedVisit.patientId}/visits`, linkedVisit.id);
                            batch.update(pubRef, { paymentAmount: newTotalPaid, remainingDebt: newDebt });
                        }
                    }
                }
            }

            // B. Klinik Ziyaretlerini Güncelle
            const visitsToUpdate = allVisitsData
                .filter(v => !v.data.isCreditSale && !v.data.isPaymentRecord && Number(v.data.remainingDebt) > 0.01)
                .sort((a,b) => a.data.visitDate.toDate() - b.data.visitDate.toDate());

            for (const visit of visitsToUpdate) {
                if (remainingAmount <= 0) break;
                
                const debt = Number(visit.data.remainingDebt) || 0;
                const pay = Math.min(remainingAmount, debt);
                
                const newPaid = (Number(visit.data.paymentAmount) || 0) + pay;
                const newDebt = debt - pay;
                
                batch.update(visit.ref, {
                    paymentAmount: Math.round(newPaid * 100) / 100,
                    remainingDebt: Math.round(newDebt * 100) / 100
                });

                const pubRef = doc(db, `artifacts/${appId}/public/data/patient_visits/${visit.patientId}/visits`, visit.id);
                batch.update(pubRef, {
                    paymentAmount: Math.round(newPaid * 100) / 100,
                    remainingDebt: Math.round(newDebt * 100) / 100
                });

                remainingAmount -= pay;
            }

            // C. Tahsilat Log (Geçmiş) Kaydını Oluştur (Cari hesap toplamlarını bozmamak için 0 ve özel alan)
            const logRef = doc(collection(db, `artifacts/${appId}/users/${userId}/patients/${primaryPatient.id}/visits`));
            const logData = {
                patientId: primaryPatient.id,
                visitDate: Timestamp.now(),
                visitCost: 0,
                paymentAmount: 0, // Toplamları çifte hesaplamaması için 0
                collectionAmount: amount, // Asıl yatan para miktarını log tutmak için kullanıyoruz
                remainingDebt: 0,
                procedures: `Borç Tahsilatı (${paymentMethod})`,
                notes: `${primaryPatient.ownerName} kişisinden ${paymentMethod} ile tahsilat yapıldı. Toplam: ${formatCurrency(amount)} TL.`,
                userId,
                performedBy: activeUser.name,
                performedByEmail: currentUser.email,
                usedStockItems: [],
                isCreditSale: false,
                isPrescriptionOnly: false,
                isPaymentRecord: true,
            };
            
            batch.set(logRef, logData);
            
            const pubLogRef = doc(db, `artifacts/${appId}/public/data/patient_visits/${primaryPatient.id}/visits`, logRef.id);
            batch.set(pubLogRef, {
                ...logData,
                diagnosis: "Finansal Hareket (Tahsilat)"
            });

            await batch.commit();

            setNotification(`${primaryPatient.ownerName} sahibinden ${formatCurrency(amount)} TL tahsilat kaydedildi! Borçlar güncellendi.`);

        } catch (error) {
            setNotification(`Tahsilat İşlem Hatası: ${error.message}`);
        } finally {
            setIsCollectingPayment(false);
            closePaymentCollectionModal();
        }
    };
    
    const handleSaveHerdEvent = async ({patientId, eventType, eventDate, notes, followUps}) => {
        if (!userId || !db || !patientId) return;
        setIsSavingHerdEvent(true);
        try {
            const patient = patients.find(p => p.id === patientId);
            const eventData = { patientId, patientName: patient.name, ownerName: patient.ownerName, eventType, eventDate: Timestamp.fromDate(new Date(eventDate)), notes, userId, createdAt: Timestamp.now() };
            await runTransaction(db, async (transaction) => {
                await transaction.get(doc(db, `artifacts/${appId}/users/${userId}/patients/${patientId}`)); 
                transaction.set(doc(collection(db, `artifacts/${appId}/users/${userId}/patients/${patientId}/herdEvents`)), eventData); 
                if (followUps && followUps.length > 0) {
                    const baseDate = new Date(eventDate);
                    for (const fu of followUps) {
                        if (fu.checked && fu.days > 0) {
                            const followUpDate = new Date(baseDate); followUpDate.setDate(baseDate.getDate() + fu.days);
                            const rData = { patientId: patient.id, patientName: patient.name, ownerPhone: patient.ownerPhone, reminderDate: Timestamp.fromDate(followUpDate), reminderType: 'Sürü Takibi', description: `${fu.name} Takibi - ${patient.name}`, treatmentId: `st_otomatik_${fu.name.replace(/\s/g, '_')}`, eventType: eventType, status: 'pending', userId };
                            const nRef = doc(collection(db, `artifacts/${appId}/users/${userId}/reminders`));
                            transaction.set(nRef, rData); 
                            transaction.set(doc(db, `artifacts/${appId}/public/data/patient_reminders/${patient.id}/reminders`, nRef.id), { reminderDate: rData.reminderDate, reminderType: rData.reminderType, description: rData.description, status: 'pending' });
                        }
                    }
                }
            });
            setNotification(`${patient.name} için ${eventType} kaydedildi.`);
        } catch (e) {} finally { setIsSavingHerdEvent(false); }
    };

    const openPatientModal = (patient = null) => { setPatientToEdit(patient); setIsPatientModalOpen(true); };
    const closePatientModal = () => { setIsPatientModalOpen(false); setPatientToEdit(null); };
    const openReminderModal = (patient) => { setCurrentPatient(patient); setIsReminderModalOpen(true); };
    const closeReminderModal = () => { setIsReminderModalOpen(false); }; 
    const openVisitModal = (patient, visit = null) => { setCurrentPatient(patient); setVisitToEdit(visit); setIsVisitModalOpen(true); };
    const closeVisitModal = () => { setIsVisitModalOpen(false); setVisitToEdit(null); setAISuggestionText(''); };
    const openPatientDetailModal = (patient) => { setCurrentPatient(patient); setIsPatientDetailModalOpen(true); };
    const closePatientDetailModal = () => { setIsPatientDetailModalOpen(false); setCurrentPatient(null); setVisits([]); };
    const openInventoryModal = () => setIsInventoryModalOpen(true);
    const closeInventoryModal = () => setIsInventoryModalOpen(false);
    const openInventoryItemModal = (item = null) => { setInventoryItemToEdit(item); setIsInventoryItemModalOpen(true); };
    const closeInventoryItemModal = () => { setIsInventoryItemModalOpen(false); setInventoryItemToEdit(null); };
    const openAccountingModal = () => setIsAccountingModalOpen(true); 
    const closeAccountingModal = () => setIsAccountingModalOpen(false);
    const openDateDetailModal = (date) => { setSelectedCalendarDate(date); setIsDateDetailModalOpen(true); };
    const closeDateDetailModal = () => { setIsDateDetailModalOpen(false); setSelectedCalendarDate(null); };
    const openOwnerListModal = () => setIsOwnerListModalOpen(true);
    const closeOwnerListModal = () => setIsOwnerListModalOpen(false);
    const openOwnerPatientsModal = (ownerName) => { setSelectedOwner(ownerName); setIsOwnerPatientsModalOpen(true); };
    const closeOwnerPatientsModal = () => { setIsOwnerPatientsModalOpen(false); setSelectedOwner(null); };
    const openOwnerReportModal = (ownerName) => { setSelectedOwner(ownerName); setIsOwnerReportModalOpen(true); };
    const closeOwnerReportModal = () => { setIsOwnerReportModalOpen(false); setSelectedOwner(null); };
    const openReportSelectionModal = () => setIsReportSelectionModalOpen(true);
    const closeReportSelectionModal = () => setIsReportSelectionModalOpen(false);
    const openCreditSalesView = () => setIsCreditSalesViewOpen(true);
    const closeCreditSalesView = () => setIsCreditSalesViewOpen(false);
    const openCreditSaleForm = (saleToEdit = null) => { setCreditSaleToEdit(saleToEdit); setIsCreditSaleFormOpen(true); };
    const closeCreditSaleForm = () => { setCreditSaleToEdit(null); setIsCreditSaleFormOpen(false); };
    const openCreditSaleDetailModal = (sale) => { setSelectedCreditSale(sale); setIsCreditSaleDetailModalOpen(true); };
    const closeCreditSaleDetailModal = () => { setSelectedCreditSale(null); setIsCreditSaleDetailModalOpen(false); };
    const openOwnerCreditSalesModal = (ownerName) => { setSelectedOwnerForCredit(ownerName); setIsOwnerCreditSalesModalOpen(true); };
    const closeOwnerCreditSalesModal = () => { setIsOwnerCreditSalesModalOpen(false); setSelectedOwnerForCredit(null); };
    const openAISuggestionModal = (title, targetField) => { setAISuggestionTitle(title); setAITargetField(targetField); setIsAISuggestionModalOpen(true); };
    const closeAISuggestionModal = () => { setIsAISuggestionModalOpen(false); setAISuggestionText(''); setAISuggestionTitle(null); setAITargetField(null); };
    const openPrescriptionWriterModal = () => setIsPrescriptionWriterModalOpen(true);
    const closePrescriptionWriterModal = () => { setIsPrescriptionWriterModalOpen(false); setAISuggestionText(''); };
    const openSendMessageModal = (phone, message, onSendCallback) => {
        setSendMessageConfig({ phone, message, onSend: onSendCallback });
        setIsSendMessageModalOpen(true);
    };
    const closeSendMessageModal = () => setIsSendMessageModalOpen(false);
    const openHerdManagementModal = (patient = null) => { setSelectedPatientForHerd(patient); setIsHerdManagementModalOpen(true); };
    const closeHerdManagementModal = () => { setIsHerdManagementModalOpen(false); setSelectedPatientForHerd(null); };
    const openPaymentCollectionModal = (ownerName) => { setSelectedOwnerForPayment(ownerName); setIsPaymentCollectionModalOpen(true); };
    const closePaymentCollectionModal = () => { setIsPaymentCollectionModalOpen(false); setSelectedOwnerForPayment(null); };

    const handleGenerateDiagnosisSuggestion = async (anamnesis, species) => {
        if (!anamnesis || !species) return;
        setIsGeneratingAIText(true); setAISuggestionText('');
        const prompt = `Veteriner hekimim. **${species}** türünde bir hasta için anamnez bilgileri: "**${anamnesis}**". Bilimsel önerilerde bulun (madde madde, giriş/sonuç olmadan).`;
        const payload = { contents: [{ role: "user", parts: [{ text: prompt }] }] };
        try {
            const response = await fetchWithExponentialBackoff(`https://generativelanguage.googleapis.com/v1beta/models/gemini-2.5-flash-preview-09-2025:generateContent?key=`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) });
            const result = await response.json();
            if (result.candidates?.[0]?.content?.parts?.[0]?.text) setAISuggestionText(result.candidates[0].content.parts[0].text);
        } catch (error) { setAISuggestionText(`Hata: ${error.message}`); } finally { setIsGeneratingAIText(false); }
    };
    
    const fetchWithExponentialBackoff = async (url, options, maxRetries = 5) => {
        for (let attempt = 0; attempt < maxRetries; attempt++) {
            try {
                const response = await fetch(url, options);
                if (response.status !== 429 && response.status < 500) return response;
            } catch (error) {}
            const delay = Math.pow(2, attempt) * 1000;
            if (attempt < maxRetries - 1) await new Promise(resolve => setTimeout(resolve, delay));
            else throw new Error("API hatası.");
        }
    };

    const handleGenerateReminderText = (patientName) => {
        setReminderTextDraft(reminderTextDraft.replace(/\[(HastaSahibiAdi|sahip|hasta sahibi)\]/gi, patientName).replace(/\[(HayvanAdi|hayvan|hasta)\]/gi, currentPatient.name));
        setNotification("Taslak oluşturuldu.");
    };
    
    const handleSendDebtReminder = (sale) => {
        if (!sale || !sale.ownerId) return;
        const patient = patients.find(p => p.ownerId === sale.ownerId); 
        if (!patient || !patient.ownerPhone) return;
        const remainingDebt = (Number(sale.totalAmount) || 0) - (Number(sale.paidAmount) || 0);
        const message = `Sayın ${sale.ownerName},\n\nÇETİN VETERİNER KLİNİĞİ olarak ${sale.saleDate.toDate().toLocaleDateString('tr-TR')} tarihli alımınızdan kalan borcunuz: ${formatCurrency(remainingDebt)} TL.\nÖdemenizi en kısa sürede gerçekleştirmenizi rica ederiz. İyi günler.`;
        openSendMessageModal(patient.ownerPhone, message, null);
    };

    const handleGeneratePrescription = async (diagnosis, patientSpecies, currentPatientWeight, anamnesis, vitalSigns, inventoryItems) => {
        if (!patientSpecies || !diagnosis.trim() || currentPatientWeight <= 0) return;
        setIsGeneratingAIText(true); setAISuggestionText('');
        const payload = { contents: [{ role: "user", parts: [{ text: `Hasta: ${patientSpecies}, Kilo: ${currentPatientWeight} kg. Teşhis: "${diagnosis}". Reçete oluştur.` }] }] };
        try {
            const response = await fetchWithExponentialBackoff(`https://generativelanguage.googleapis.com/v1beta/models/gemini-2.5-flash-preview-09-2025:generateContent?key=`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) });
            const result = await response.json();
            if (result.candidates?.[0]?.content?.parts?.[0]?.text) setAISuggestionText(result.candidates[0].content.parts[0].text);
        } catch (error) {} finally { setIsGeneratingAIText(false); }
    };
    
    const addDiagnosisToQuickList = async (diagnosisText, patientSpecies) => {
        if (!userId || !db || !diagnosisText.trim() || !patientSpecies) return;
        try {
            await setDoc(doc(db, `artifacts/${appId}/users/${userId}/uniqueDiagnoses`, `${diagnosisText.trim()}_${patientSpecies}`), { name: diagnosisText.trim(), species: patientSpecies, createdAt: Timestamp.now(), userId }, { merge: true });
        } catch (error) {}
    };

    const handleSavePrescriptionAsVisit = async (prescriptionData) => {
        if (!userId || !db || !activeUser || !prescriptionData.patientId) return;
        setIsSavingVisit(true);
        try {
            await runTransaction(db, async (transaction) => {
                const newVisitRef = doc(collection(db, `artifacts/${appId}/users/${userId}/patients/${prescriptionData.patientId}/visits`));
                const visitData = { patientId: prescriptionData.patientId, visitDate: Timestamp.now(), visitCost: 0, paymentAmount: 0, remainingDebt: 0, diagnosis: prescriptionData.diagnosis || "Reçete", procedures: "Sadece reçete oluşturuldu.", notes: prescriptionData.fullPrescriptionText, userId, performedBy: activeUser.name, performedByEmail: currentUser.email, usedStockItems: [], isCreditSale: false, isPrescriptionOnly: true, isPaymentRecord: false };
                transaction.set(newVisitRef, visitData);
                transaction.set(doc(db, `artifacts/${appId}/public/data/patient_visits/${prescriptionData.patientId}/visits`, newVisitRef.id), { ...visitData, notes: "" });
            });
            setNotification("Reçete kaydedildi."); closePrescriptionWriterModal();
        } catch (e) {} finally { setIsSavingVisit(false); }
    };

    const patientsMap = useMemo(() => new Map(patients.map(p => [p.id, p])), [patients]);
    const filteredPatients = useMemo(() => {
       const filtered = patients.filter(p => (p.name?.toLowerCase().includes(searchTerm.toLowerCase())) || (p.ownerName?.toLowerCase().includes(searchTerm.toLowerCase())) || (p.species?.toLowerCase().includes(searchTerm.toLowerCase())) || (p.breed?.toLowerCase().includes(searchTerm.toLowerCase())) || (p.chipNumber?.toLowerCase().includes(searchTerm.toLowerCase())) || (p.lastDiagnosis?.toLowerCase().includes(searchTerm.toLowerCase())));
       if (searchTerm) setCurrentPage(1); return filtered;
    }, [patients, searchTerm]);

    const upcomingReminders = useMemo(() => reminders.filter(r => r.status === 'pending').sort((a, b) => (a.reminderDate?.toDate() || 0) - (b.reminderDate?.toDate() || 0)), [reminders]);
    const pastReminders = useMemo(() => reminders.filter(r => r.status !== 'pending').sort((a, b) => (b.reminderDate?.toDate() || 0) - (a.reminderDate?.toDate() || 0)), [reminders]); 
    const filteredInventoryItems = useMemo(() => inventoryItems.filter(item => item.itemName?.toLowerCase().includes(inventorySearchTerm.toLowerCase()) || item.itemType?.toLowerCase().includes(inventorySearchTerm.toLowerCase())), [inventoryItems, inventorySearchTerm]);
    
    const indexOfLastPatient = currentPage * patientsPerPage;
    const indexOfFirstPatient = indexOfLastPatient - patientsPerPage;
    const currentPatients = filteredPatients.slice(indexOfFirstPatient, indexOfLastPatient);
    const totalPages = Math.ceil(filteredPatients.length / patientsPerPage);

    if (!isAuthReady) return <div className="min-h-screen flex items-center justify-center bg-slate-100"><div className="text-xl font-semibold p-8 text-center">Yükleniyor... <Loader2 className="inline-block animate-spin h-6 w-6 ml-2"/></div></div>;
    if (viewMode === 'entry') return <EntrySelectionScreen setViewMode={setViewMode} />;
    if (viewMode === 'portal_login') return <PatientPortalLoginScreen db={db} appId={appId} setViewMode={setViewMode} setPortalOwnerData={setPortalOwnerData} setNotification={setNotification} />;
    if (viewMode === 'portal_view') return <PatientPortalView db={db} appId={appId} ownerData={portalOwnerData} patientsMap={patientsMap} onExit={() => { setViewMode('entry'); setPortalOwnerData(null); }} />;
    if (viewMode === 'clinic') {
        if (!currentUser) return <LoginScreen onLogin={handleLogin} onRegister={handleRegister} error={authError} setError={setAuthError} setViewMode={setViewMode} />;
        if (!activeUser) return <UserSelectionScreen mainUserId={userId} onUserSelected={setActiveUser} onLogout={handleLogout} setConfirmAction={setConfirmAction} setIsConfirmModalOpen={setIsConfirmModalOpen} setNotification={setNotification} setViewMode={setViewMode} setConfirmMessage={setConfirmMessage} />;
        if (!db || !auth) return <div className="min-h-screen flex items-center justify-center bg-slate-100 p-4"><div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative shadow-md" role="alert"><strong className="font-bold">Kritik Hata!</strong><span className="block sm:inline"> Firebase başlatılamadı. Lütfen sayfayı yenileyin.</span></div></div>;
    } else if (viewMode !== 'entry' && viewMode !== 'portal_login' && viewMode !== 'portal_view') {
        return <div className="min-h-screen flex items-center justify-center bg-slate-100"><div className="text-xl font-semibold p-8 text-center">Yükleniyor... <Loader2 className="inline-block animate-spin h-6 w-6 ml-2"/></div></div>;
    }

    return (
        <>
         <style>{`
            ::-webkit-scrollbar { width: 8px; height: 8px; }
            ::-webkit-scrollbar-track { background: #f1f1f1; border-radius: 10px; }
            ::-webkit-scrollbar-thumb { background: #a8a8a8; border-radius: 10px; }
            ::-webkit-scrollbar-thumb:hover { background: #888; }
            .animate-fade-in-fast { animation: fadeInFast 0.3s ease-out; }
            @keyframes fadeInFast { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }
            .max-h-modal-content { max-height: 80vh; }
        `}</style>
        <OfflineIndicator />

        {viewMode === 'clinic' && activeUser && (
            <div className="min-h-screen bg-slate-100 p-2 sm:p-4 md:p-6 font-sans">
                <header className="mb-4 md:mb-8">
                    <div className="text-center relative">
                        <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-teal-500 pb-1 leading-tight">
                            Veteriner Yönetim Paneli
                        </h1>
                        <p className="text-sm sm:text-base text-slate-500 mt-2 tracking-wider font-light">
                            ÇETİN VETERİNER KLİNİĞİ
                        </p>
                        <button onClick={() => setViewMode('entry')} className={`${secondaryButtonClasses} absolute top-0 left-0 text-sm py-1 px-3`} title="Ana Giriş Ekranı">
                            <Home size={16} className="mr-1.5"/> Ana Ekran
                        </button>
                    </div>
                    {currentUser && (
                        <div className="flex flex-col sm:flex-row justify-center items-center gap-2 sm:gap-4 mt-4">
                            <p className="text-sm text-slate-600">İşlem Yapan: <span className="font-semibold text-blue-700">{activeUser.name}</span></p>
                            <p className="text-sm text-slate-500 hidden sm:block">|</p>
                            <p className="text-sm text-slate-600">Ana Hesap: <span className="font-semibold text-slate-800">{currentUser.email}</span></p>
                            <button onClick={() => setActiveUser(null)} className={`${secondaryButtonClasses} text-sm py-1 px-3`}>
                                <UserCog size={16} className="mr-1.5"/> Kullanıcı Değiştir
                            </button>
                            <button onClick={handleLogout} className={`${dangerButtonClasses} text-sm py-1 px-3`}>
                                <LogOut size={16} className="mr-1.5"/> Çıkış Yap
                            </button>
                        </div>
                    )}
                </header>

                <nav className="mb-4 sm:mb-6 flex flex-wrap justify-center gap-2 sm:gap-3 items-start">
                    <button onClick={() => setIsDashboardModalOpen(true)} className={`${purpleButtonClasses} text-sm py-2 px-3`}><LayoutDashboard size={18} className="mr-1.5"/> Dashboard</button>
                    <button onClick={openInventoryModal} className={`${infoButtonClasses} text-sm py-2 px-3`}><Archive size={18} className="mr-1.5"/> Stok Yönetimi</button>
                    <button onClick={openCreditSalesView} className={`${warningButtonClasses} text-sm py-2 px-3`}><Pill size={18} className="mr-1.5"/> İlaç Satış</button>
                    <button onClick={openAccountingModal} className={`${successButtonClasses} text-sm py-2 px-3`}><DollarSign size={18} className="mr-1.5"/> Muhasebe Özeti</button>
                    <button onClick={openOwnerListModal} className={`${primaryButtonClasses} text-sm py-2 px-3`}><Users size={18} className="mr-1.5"/> Hasta Sahipleri</button>
                    <button onClick={() => setIsBulkMessageModalOpen(true)} className={`${infoButtonClasses} bg-cyan-500 hover:bg-cyan-600 focus:ring-cyan-400 text-sm py-2 px-3`}><MessagesSquare size={18} className="mr-1.5"/> Toplu Mesaj</button>
                    <button onClick={openPrescriptionWriterModal} className={`${infoButtonClasses} bg-pink-500 hover:bg-pink-600 focus:ring-pink-400 text-sm py-2 px-3`}><Printer size={18} className="mr-1.5"/> Reçete Yaz</button>
                    <button onClick={() => openHerdManagementModal()} className={`${purpleButtonClasses} bg-indigo-600 hover:bg-indigo-700 focus:ring-indigo-500 text-sm py-2 px-3`}><Users2 size={18} className="mr-1.5"/> Sürü Yönetimi</button>
                    <button onClick={openReportSelectionModal} className={`${purpleButtonClasses} text-sm py-2 px-3`} disabled={isExporting} title="Raporları indir">
                        {isExporting ? <Loader2 className="animate-spin h-5 w-5 mr-2" /> : <FileOutput size={18} className="mr-1.5"/>}
                        {isExporting ? "Hazırlanıyor..." : "Raporlar"}
                    </button>
                    <button onClick={() => setIsBackupModalOpen(true)} className={`${secondaryButtonClasses} text-sm py-2 px-3`} disabled={isBackingUp}>
                        {isBackingUp ? <Loader2 className="animate-spin h-5 w-5 mr-2" /> : <DatabaseBackup size={18} className="mr-1.5"/>}
                        {isBackingUp ? "Yedekleniyor..." : "Veri Tabanı Yedekle"}
                    </button>
                </nav>

                <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 md:gap-6">
                    <div className="lg:col-span-1 space-y-4 md:space-y-6">
                        <section className="p-3 sm:p-4 bg-white/80 backdrop-blur-md rounded-xl shadow-lg">
                            <h2 className="text-lg sm:text-xl font-semibold text-green-700 mb-3 flex items-center"><ListTodo size={22} className="mr-2 text-green-500"/> Yakın Dönem Hatırlatmalar ({todaysReminders.length})</h2>
                            {todaysReminders.length > 0 ? (
                                <div className="space-y-2.5 max-h-48 overflow-y-auto pr-1.5">
                                    {todaysReminders.map(r => {
                                        const reminderDate = r.reminderDate?.toDate();
                                        const patientForReminder = patients.find(p => p.id === r.patientId);
                                        const isPast = reminderDate && reminderDate < new Date().setHours(0,0,0,0);
                                        const defaultMessageText = reminderTextDraft.replace(/\[(HastaSahibiAdi|sahip|hasta sahibi)\]/gi, patientForReminder?.ownerName || 'Hasta Sahibi').replace(/\[(HayvanAdi|hayvan|hasta)\]/gi, r.patientName);

                                        return (
                                            <div key={`today-${r.id}`} className={`p-2.5 rounded-lg shadow-sm border-l-4 ${isPast ? "bg-red-50 border-red-500" : "bg-green-50 border-green-500"}`}>
                                                <h4 className={`font-semibold text-sm ${isPast ? "text-red-600 font-semibold" : "text-slate-800"}`}>{r.patientName} - {r.reminderType}</h4>
                                                <p className="text-xs text-slate-600">Tarih: {reminderDate ? reminderDate.toLocaleDateString('tr-TR') : 'Belirsiz'} {isPast && <span className="font-bold text-red-600">(Geçmiş)</span>}</p>
                                                {r.description && <p className="text-xs text-slate-500 truncate" title={r.description}>Not: {r.description}</p>}
                                                <div className="flex space-x-1 mt-1.5">
                                                    <button onClick={() => handleMarkReminderAsSent(r.id)} className={`${successButtonClasses} flex-1 text-xs py-1`}><CheckCircle size={12} className="mr-1"/> Yapıldı</button>
                                                    {patientForReminder?.ownerPhone && (
                                                        <button onClick={() => openSendMessageModal(patientForReminder.ownerPhone, defaultMessageText, () => handleMarkReminderAsSent(r.id))} className={`${infoButtonClasses} flex-1 text-xs py-1`}><Send size={12} className="mr-1"/> Mesaj Gönder</button>
                                                    )}
                                                    <button onClick={() => handleDeleteReminder(r.id)} className={`${dangerButtonClasses} text-xs p-1`} title="Sil"><Trash2 size={12}/></button>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            ) : (<p className="text-sm text-slate-500 text-center py-2">Yakın dönemde bekleyen hatırlatma yok.</p>)}
                        </section>
                        <button onClick={() => setShowPastReminders(!showPastReminders)} className={`${secondaryButtonClasses} text-sm w-full`}><History size={18} className="mr-2"/> {showPastReminders ? "Tüm Geçmiş Hatırlatmaları Gizle" : "Tüm Geçmiş Hatırlatmaları Göster"} ({pastReminders.length})</button>
                        {showPastReminders && (
                            <section className="mt-2 p-3 sm:p-4 bg-white/70 backdrop-blur-md rounded-xl shadow-lg animate-fade-in-fast">
                                <h2 className="text-lg sm:text-xl font-semibold text-slate-700 mb-3 flex items-center"><History size={22} className="mr-2"/> Geçmiş Hatırlatmalar</h2>
                                {pastReminders.length > 0 ? (
                                    <div className="space-y-2.5 max-h-60 overflow-y-auto pr-1.5">
                                        {pastReminders.slice(0,20).map(r => (
                                            <div key={`past-${r.id}`} className={`p-2.5 rounded-lg shadow-sm border-l-4 ${r.status === 'sent' ? 'bg-green-50 border-green-400' : 'bg-slate-50 border-slate-300'}`}>
                                                <div className="flex justify-between items-start">
                                                    <div>
                                                        <h4 className="font-semibold text-sm text-slate-800">{r.patientName} - {r.reminderType}</h4>
                                                        <p className="text-xs text-slate-600">Tarih: {r.reminderDate ? r.reminderDate.toDate().toLocaleDateString('tr-TR') : 'Belirsiz'}</p>
                                                        <p className="text-xs font-semibold mt-1">{r.status === 'sent' ? 'Gönderildi' : 'Tamamlandı/Diğer'}</p>
                                                    </div>
                                                    <button onClick={() => handleDeleteReminder(r.id)} className={`${dangerButtonClasses} text-xs p-1`}><Trash2 size={12}/></button>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                ) : (<p className="text-sm text-slate-500 text-center py-2">Geçmiş hatırlatma yok.</p>)}
                            </section>
                        )}
                        <CalendarDisplay reminders={reminders} patients={patients} onDateClick={openDateDetailModal} /> 
                    </div>

                    <div className="lg:col-span-2">
                        <section className="p-3 sm:p-4 bg-white/80 backdrop-blur-md rounded-xl shadow-lg">
                            <div className="flex flex-col sm:flex-row justify-between items-center mb-4 sm:mb-5">
                                <h2 className="text-lg sm:text-xl lg:text-2xl font-semibold text-slate-800 flex items-center"><PawPrint size={26} className="mr-2 text-blue-500"/> Hasta Listesi ({filteredPatients.length})</h2>
                                <button onClick={() => openPatientModal()} className={`${primaryButtonClasses} mt-2 sm:mt-0 w-full sm:w-auto text-sm py-2 px-3`}><PlusCircle size={18} className="mr-1.5"/> Yeni Hasta Ekle</button>
                            </div>
                            <div className="mb-3 sm:mb-4">
                                <div className="relative"><div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"><Search className="text-slate-400" size={18} /></div><input type="text" placeholder="Ad, sahip, tür, çip, son teşhis ile ara..." className={`${inputClasses} pl-10 text-sm`} value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)}/></div>
                            </div>
                            {filteredPatients.length === 0 && <p className="text-center text-slate-500 py-3"> {searchTerm ? 'Arama sonucu yok.' : 'Kayıtlı hasta yok.'}</p>}
                            <div className="overflow-x-auto">
                                <table className="min-w-full divide-y divide-slate-200">
                                    <thead className="bg-slate-50 sticky top-0"><tr>{["Adı", "Türü", "Sahip Adı", "Çip No", "Portal ID", "İşlemler"].map(h => <th key={h} className="px-3 py-2.5 text-left text-xs font-medium text-slate-500 uppercase tracking-wider whitespace-nowrap">{h}</th>)}</tr></thead>
                                    <tbody className="bg-white divide-y divide-slate-200">
                                        {currentPatients.map(patient => (
                                            <tr key={patient.id} className="hover:bg-slate-50 transition-colors">
                                                <td className="px-3 py-2.5 whitespace-nowrap text-sm font-medium text-slate-900">{patient.name}</td>
                                                <td className="px-3 py-2.5 whitespace-nowrap text-sm text-slate-500">{patient.species}</td>
                                                <td className="px-3 py-2.5 whitespace-nowrap text-sm text-slate-500">{patient.ownerName}</td>
                                                <td className="px-3 py-2.5 whitespace-nowrap text-sm text-slate-500">{patient.chipNumber || "-"}</td> 
                                                <td className="px-3 py-2.5 whitespace-nowrap text-sm text-slate-500 font-mono">{patient.publicId || "-"}</td>
                                                <td className="px-3 py-2.5 whitespace-nowrap text-sm font-medium"><div className="flex items-center space-x-1">
                                                    <button onClick={() => openPatientDetailModal(patient)} className={`${primaryButtonClasses} text-xs p-1 sm:p-1.5`} title="Detaylar"><Eye size={14}/></button>
                                                    <button onClick={() => openPatientModal(patient)} className={`${secondaryButtonClasses} text-xs p-1 sm:p-1.5`} title="Düzenle"><Edit3 size={14}/></button>
                                                    <button onClick={() => openPaymentCollectionModal(patient.ownerName)} className={`${warningButtonClasses} text-xs p-1 sm:p-1.5`} title="Tahsilat Yap (Sahibin Tüm Borçları Dahil)"><Wallet size={14}/></button>
                                                    <button onClick={() => openReminderModal(patient)} className={`${infoButtonClasses} text-xs p-1 sm:p-1.5`} title="Hatırlatma Ekle"><Bell size={14}/></button>
                                                    {patient.species === 'Sığır' && <button onClick={() => openHerdManagementModal(patient)} className={`${purpleButtonClasses} text-xs p-1 sm:p-1.5`} title="Sürü Yönetimi"><Users2 size={14}/></button>}
                                                    <button onClick={() => handleDeletePatient(patient.id)} className={`${dangerButtonClasses} text-xs p-1 sm:p-1.5`} title="Sil"><Trash2 size={14}/></button>
                                                </div></td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                            <Pagination currentPage={currentPage} totalPages={totalPages} onPageChange={setCurrentPage} />
                        </section>
                    </div>
                </div>
            </div>
        )}

        <Modal isOpen={isDashboardModalOpen} onClose={() => setIsDashboardModalOpen(false)} title="Klinik Performans Paneli" size="6xl">
            <DashboardView allVisits={allVisits} creditSales={creditSales} patients={patients} inventoryItems={inventoryItems} onChartClick={(chartData) => { setSelectedChart(chartData); setIsChartModalOpen(true); }} />
        </Modal>
        <Modal isOpen={isBulkMessageModalOpen} onClose={() => setIsBulkMessageModalOpen(false)} title="Toplu Mesaj Gönder" size="3xl">
            <BulkMessageModal patients={patients} setNotification={setNotification} openSendMessageModal={openSendMessageModal} /> 
        </Modal>
        <Modal isOpen={isBackupModalOpen} onClose={() => setIsBackupModalOpen(false)} title="Veritabanı Yedekleme" size="lg">
            <BackupModal isBackingUp={isBackingUp} setIsBackingUp={setIsBackingUp} setNotification={setNotification} userId={userId} db={db} appId={appId} />
        </Modal>
        <Modal isOpen={isHerdManagementModalOpen} onClose={closeHerdManagementModal} title={"Sürü Yönetimi"} size="5xl">
            <HerdManagementView patients={patients} onAddReminder={openReminderModal} onOpenPatientDetail={openPatientDetailModal} onSaveEvent={handleSaveHerdEvent} isSaving={isSavingHerdEvent} setNotification={setNotification} userId={userId} db={db} appId={appId} treatmentSchedules={window.treatmentSchedules} reminders={reminders} />
        </Modal>
        {selectedOwnerForPayment && isPaymentCollectionModalOpen && (
            <Modal isOpen={isPaymentCollectionModalOpen} onClose={closePaymentCollectionModal} title={`${selectedOwnerForPayment} - Borç Tahsilat`} size="lg" zIndex="z-[100]">
                <PaymentCollectionModal ownerName={selectedOwnerForPayment} allVisits={allVisits} allCreditSales={creditSales} patients={patients} onProcessPayment={handleProcessBulkPayment} isProcessing={isCollectingPayment} setNotification={setNotification} />
            </Modal>
        )}

        <Modal isOpen={isPatientModalOpen} onClose={closePatientModal} title={patientToEdit ? "Hastayı Düzenle" : "Yeni Hasta Ekle"} size="2xl" zIndex="z-[80]">
            <PatientForm patient={patientToEdit} onSave={handleSavePatient} onCancel={closePatientModal} setNotification={setNotification} isSaving={isSavingPatient} />
        </Modal>
        
        {currentPatient && isReminderModalOpen && (
            <Modal isOpen={isReminderModalOpen} onClose={closeReminderModal} title={`${currentPatient.name} İçin Hatırlatma`} size="lg" zIndex="z-[100]"> 
                <ReminderForm patient={currentPatient} onSave={handleSaveReminder} onCancel={closeReminderModal} onGenerateText={handleGenerateReminderText} generatedText={reminderTextDraft} isGeneratingText={isGeneratingReminderText} setGeneratedText={setReminderTextDraft} setNotification={setNotification} isSaving={isSavingReminder} openSendMessageModal={openSendMessageModal} />
            </Modal>
        )}
        
        {selectedOwner && isOwnerReportModalOpen && (
            <Modal isOpen={isOwnerReportModalOpen} onClose={closeOwnerReportModal} title={`${selectedOwner} - Finansal Özet Raporu`} size="5xl" zIndex="z-[80]">
                <OwnerFinancialReport ownerName={selectedOwner} patients={patients.filter(p => p.ownerName === selectedOwner)} allVisits={allVisits} creditSales={creditSales} patientsMap={patientsMap} onOpenCreditSales={openOwnerCreditSalesModal} onOpenPaymentCollection={openPaymentCollectionModal} allPatients={patients} />
            </Modal>
        )}

        {currentPatient && isPatientDetailModalOpen && (
            <Modal isOpen={isPatientDetailModalOpen} onClose={closePatientDetailModal} title={`${currentPatient.name} - Detaylar`} size="5xl" zIndex="z-[75]">
                <PatientDetailView patient={currentPatient} visits={visits} onAddVisit={() => openVisitModal(currentPatient)} onEditVisit={(v) => openVisitModal(currentPatient, v)} onDeleteVisit={handleDeleteVisit} onAddReminder={() => openReminderModal(currentPatient)} onEditPatient={() => openPatientModal(currentPatient)} allCreditSales={creditSales} allVisits={allVisits} isReadOnly={viewMode === 'portal_view'} reminders={reminders.filter(r => r.patientId === currentPatient.id)} openPaymentCollectionModal={openPaymentCollectionModal} />
            </Modal>
        )}

        {currentPatient && isVisitModalOpen && (
            <Modal isOpen={isVisitModalOpen} onClose={closeVisitModal} title={visitToEdit ? `${currentPatient.name} - Ziyaret Düzenle` : `${currentPatient.name} - Yeni Ziyaret Ekle`} size="3xl" zIndex="z-[90]">
                <VisitForm patient={currentPatient} visit={visitToEdit} onSave={handleSaveVisit} onCancel={closeVisitModal} inventoryItems={inventoryItems} onGenerateDiagnosisSuggestion={handleGenerateDiagnosisSuggestion} onGeneratePrescription={handleGeneratePrescription} uniqueDiagnoses={uniqueDiagnoses} addDiagnosisToQuickList={addDiagnosisToQuickList} setNotification={setNotification} openAISuggestionModal={openAISuggestionModal} isSaving={isSavingVisit} />
            </Modal>
        )}
        
        <Modal isOpen={isInventoryModalOpen} onClose={closeInventoryModal} title="Stok Yönetimi" size="4xl" zIndex="z-50">
            <InventoryView items={filteredInventoryItems} onAddItem={() => openInventoryItemModal()} onEditItem={openInventoryItemModal} onDeleteItem={handleDeleteInventoryItem} searchTerm={inventorySearchTerm} setSearchTerm={setInventorySearchTerm} setNotification={setNotification} />
        </Modal>

        {isInventoryItemModalOpen && (
            <Modal isOpen={isInventoryItemModalOpen} onClose={closeInventoryItemModal} title={inventoryItemToEdit ? "Stok Ürününü Düzenle" : "Yeni Stok Ürünü Ekle"} size="2xl" zIndex="z-[60]">
                <InventoryItemForm item={inventoryItemToEdit} onSave={handleSaveInventoryItem} onCancel={closeInventoryItemModal} setNotification={setNotification} isSaving={isSavingInventory} />
            </Modal>
        )}
        <Modal isOpen={isAccountingModalOpen} onClose={closeAccountingModal} title="Muhasebe Özeti" size="6xl" zIndex="z-50"> 
            <AccountingView isOpen={isAccountingModalOpen} userId={userId} db={db} patientsMap={patientsMap} setNotification={setNotification} onChartClick={(chartData) => { setSelectedChart(chartData); setIsChartModalOpen(true); }} /> 
        </Modal>
        
        {selectedCalendarDate && (
            <Modal isOpen={isDateDetailModalOpen} onClose={closeDateDetailModal} title={`${selectedCalendarDate.toLocaleDateString('tr-TR')} Detayları`} size="lg" zIndex="z-[70]">
                <DateDetailView date={selectedCalendarDate} reminders={reminders.filter(r => { const rDate = r.reminderDate?.toDate(); return rDate && rDate.getFullYear() === selectedCalendarDate.getFullYear() && rDate.getMonth() === selectedCalendarDate.getMonth() && rDate.getDate() === selectedCalendarDate.getDate(); })} onDeleteReminder={handleDeleteReminder} allPatients={patients} boardingPatients={patients.filter(p => { if (!p.isBoarding || !p.boardingStartDate?.toDate) return false; const startDate = p.boardingStartDate.toDate(); startDate.setHours(0,0,0,0); const endDate = p.boardingEndDate?.toDate ? p.boardingEndDate.toDate() : new Date(startDate.getTime() + 24*60*60*1000*30); endDate.setHours(23,59,59,999); return selectedCalendarDate >= startDate && selectedCalendarDate <= endDate; })} onPatientDetailOpen={openPatientDetailModal} setNotification={setNotification} />
            </Modal>
        )}
        <Modal isOpen={isOwnerListModalOpen} onClose={closeOwnerListModal} title="Hasta Sahipleri" size="5xl" zIndex="z-50">
            <OwnerListView patients={patients} onOwnerSelect={openOwnerPatientsModal} onOpenOwnerCreditSales={openOwnerCreditSalesModal} onOpenOwnerReport={openOwnerReportModal} onOpenPaymentCollection={openPaymentCollectionModal} userId={userId} db={db} setNotification={setNotification} allVisits={allVisits} allCreditSales={creditSales} openPatientModal={openPatientModal} />
        </Modal>

        {selectedOwner && isOwnerPatientsModalOpen && (
            <Modal isOpen={isOwnerPatientsModalOpen} onClose={closeOwnerPatientsModal} title={`${selectedOwner} Adlı Sahibin Hayvanları`} size="4xl" zIndex="z-[60]">
                <OwnerPatientsView ownerName={selectedOwner} patients={patients.filter(p => p.ownerName === selectedOwner)} onPatientDetailOpen={openPatientDetailModal} allVisits={allVisits} allCreditSales={creditSales} openNewPatientModal={() => openPatientModal({ ownerName: selectedOwner })} />
            </Modal>
        )}
        
        <ReportSelectionModal isOpen={isReportSelectionModalOpen} onClose={closeReportSelectionModal} patients={patients} allVisits={allVisits} inventoryItems={inventoryItems} setNotification={setNotification} />

        <Modal isOpen={isCreditSalesViewOpen} onClose={closeCreditSalesView} title="İlaç Satış Yönetimi" size="5xl" zIndex="z-60">
            <CreditSalesView creditSales={creditSales} onAddNewSale={() => openCreditSaleForm()} onEditSale={openCreditSaleForm} onOpenDetail={openCreditSaleDetailModal} setNotification={setNotification} />
        </Modal>
        
        <Modal isOpen={isCreditSaleFormOpen} onClose={closeCreditSaleForm} title={creditSaleToEdit ? "İlaç Satışını Düzenle" : "Yeni İlaç Satışı Ekle"} size="3xl" zIndex="z-[80]">
            <CreditSaleForm patients={patients} inventoryItems={inventoryItems} onSave={handleSaveCreditSale} onCancel={closeCreditSaleForm} isSaving={isSavingCreditSale} setNotification={setNotification} editingSale={creditSaleToEdit} allVisits={allVisits} allCreditSales={creditSales} />
        </Modal>

        {selectedCreditSale && isCreditSaleDetailModalOpen && (
             <CreditSaleDetailModal isOpen={isCreditSaleDetailModalOpen} onClose={closeCreditSaleDetailModal} sale={selectedCreditSale} onProcessBulkPayment={handleProcessBulkPayment} isProcessing={isCollectingPayment} setNotification={setNotification} onSendDebtReminder={handleSendDebtReminder} />
        )}
        
        {isOwnerCreditSalesModalOpen && selectedOwnerForCredit && (
             <Modal isOpen={isOwnerCreditSalesModalOpen} onClose={closeOwnerCreditSalesModal} title={`${selectedOwnerForCredit} - Tüm İlaç Satış Geçmişi`} size="5xl" zIndex="z-[60]">
                <CreditSalesView creditSales={creditSales.filter(cs => cs.ownerName === selectedOwnerForCredit)} onAddNewSale={() => openCreditSaleForm()} onEditSale={openCreditSaleForm} onOpenDetail={openCreditSaleDetailModal} setNotification={setNotification} isFilteredView={true} />
            </Modal>
        )}

        <PrescriptionWriterModal isOpen={isPrescriptionWriterModalOpen} onClose={closePrescriptionWriterModal} patients={patients} inventoryItems={inventoryItems.filter(i => i.itemType === 'İlaç')} clinicInfo={{ name: "ÇETİN VETERİNER KLİNİĞİ", address: "Klinik Adresi", phone: "Klinik Telefon" }} doctorInfo={{ name: activeUser?.name || "Veteriner Hekim" }} onSave={handleSavePrescriptionAsVisit} isSaving={isSavingVisit} setNotification={setNotification} />

        <SendMessageModal isOpen={isSendMessageModalOpen} onClose={closeSendMessageModal} config={sendMessageConfig} />

        <Modal isOpen={isNotificationModalOpen} onClose={() => setIsNotificationModalOpen(false)} title="Bilgilendirme" size="sm" zIndex="z-[130]">
            <p className="text-slate-700">{notificationMessage}</p>
            <div className="mt-5 flex justify-end"><button onClick={() => setIsNotificationModalOpen(false)} className={primaryButtonClasses}>Tamam</button></div>
        </Modal>

        <ConfirmationModal isOpen={isConfirmModalOpen} onClose={() => setIsConfirmModalOpen(false)} message={confirmMessage} onConfirm={confirmAction} />

        <AISuggestionModal isOpen={isAISuggestionModalOpen} onClose={closeAISuggestionModal} title={aiSuggestionTitle} suggestion={aiSuggestionText} isGenerating={isGeneratingAIText} onApply={() => { const targetElement = document.getElementById(aiTargetField); if(targetElement) targetElement.value = aiSuggestionText; closeAISuggestionModal(); }} onClearSuggestion={() => setAISuggestionText('')} />
        
        {isChartModalOpen && selectedChart && (
            <ChartModal isOpen={isChartModalOpen} onClose={() => setIsChartModalOpen(false)} chartInfo={selectedChart} />
        )}
        </>
    );
}

// *** BAĞIMSIZ BİLEŞENLER İKİNCİ BÖLÜMDE GÖNDERİLECEKTİR ***
// *** BAĞIMSIZ BİLEŞENLER - BÖLÜM 1/2 (devam) ***

// Hata #1 düzeltmesi: BulkMessageModal bileşeni eklendi
const BulkMessageModal = ({ patients, setNotification, openSendMessageModal }) => {
    const [messageDraft, setMessageDraft] = useState('Merhaba [HastaSahibiAdi], [HayvanAdi] için aşı/tedavi zamanı gelmiştir. Detaylı bilgi ve randevu için lütfen kliniğimizle iletişime geçin.');
    const [filterType, setFilterType] = useState('all');
    const [selectedSpecies, setSelectedSpecies] = useState('all');
    
    const uniqueSpecies = useMemo(() => {
        return ['all', ...new Set(patients.map(p => p.species).filter(s => s))];
    }, [patients]);
    
    const filteredPatients = useMemo(() => {
        return patients.filter(p => {
            const hasPhone = p.ownerPhone && p.ownerPhone.trim();
            const speciesMatch = selectedSpecies === 'all' || p.species === selectedSpecies;

            if (filterType === 'all') return hasPhone && speciesMatch;
            if (filterType === 'vaccination') return hasPhone && speciesMatch; // Aşı/Hatırlatma takibi için daha karmaşık filtreleme gerekebilir, şimdilik sadece telefon ve tür filtresi yeterli
            if (filterType === 'boarding') return hasPhone && speciesMatch && p.isBoarding;
            
            return false;
        });
    }, [patients, filterType, selectedSpecies]);

    const handleSendBulk = () => {
        if (filteredPatients.length === 0) {
            setNotification("Gönderilecek alıcı bulunamadı. Lütfen filtreleri kontrol edin.");
            return;
        }

        const formattedMessages = filteredPatients.map(p => {
            const finalMessage = messageDraft
                .replace(/\[(HastaSahibiAdi|sahip|hasta sahibi)\]/gi, p.ownerName || 'Hasta Sahibi')
                .replace(/\[(HayvanAdi|hayvan|hasta)\]/gi, p.name || 'Hayvanınız');
            return `tel:${p.ownerPhone.replace(/\D/g, '')} - ${finalMessage}`;
        }).join('\n');
        
        setNotification(`Toplam ${filteredPatients.length} alıcı için toplu mesaj metni hazırlandı. Tarayıcınız WhatsApp/SMS ile açılacaktır.`);
        
        // WhatsApp'ta toplu gönderim mümkün olmadığından, ilk kişinin mesajını açarız
        const firstPatient = filteredPatients[0];
        if (firstPatient) {
             const messageForFirst = messageDraft
                .replace(/\[(HastaSahibiAdi|sahip|hasta sahibi)\]/gi, firstPatient.ownerName || 'Hasta Sahibi')
                .replace(/\[(HayvanAdi|hayvan|hasta)\]/gi, firstPatient.name || 'Hayvanınız');
            
             openSendMessageModal(firstPatient.ownerPhone, messageForFirst, null);
        }

        // Toplu mesajı not olarak da gösterebiliriz (manuel gönderim için)
        console.log("Toplu Mesaj Metinleri (WhatsApp grupları veya diğer toplu gönderim araçları için manuel kopyalanabilir):\n", formattedMessages);
    };

    return (
        <div className="space-y-4">
            <p className="text-sm text-slate-600 border-b pb-2">
                Toplu mesaj gönderme özelliği, teknik kısıtlamalar nedeniyle (WhatsApp API'sine erişim olmadan) her bir kişiye tek tek mesaj göndermenizi gerektirebilir. Bu ekran, mesaj taslağını otomatik doldurmanıza yardımcı olur.
            </p>
            
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div>
                    <label className={labelClasses}>Mesaj Filtresi</label>
                    <select value={filterType} onChange={e => setFilterType(e.target.value)} className={inputClasses}>
                        <option value="all">Tüm Kayıtlı Sahipler</option>
                        <option value="vaccination">Hatırlatma Bekleyen Sahipler (Geliştirilecek)</option>
                        <option value="boarding">Konaklamada Olan Hayvanların Sahipleri</option>
                    </select>
                </div>
                 <div>
                    <label className={labelClasses}>Türe Göre Filtrele</label>
                    <select value={selectedSpecies} onChange={e => setSelectedSpecies(e.target.value)} className={inputClasses}>
                        {uniqueSpecies.map(s => <option key={s} value={s}>{s === 'all' ? 'Tüm Türler' : s}</option>)}
                    </select>
                </div>
            </div>

            <div>
                <label htmlFor="bulkMessageDraft" className={labelClasses}>Mesaj Taslağı*</label>
                <textarea
                    id="bulkMessageDraft"
                    value={messageDraft}
                    onChange={e => setMessageDraft(e.target.value)}
                    className={textareaClasses}
                    rows="4"
                    placeholder="[HastaSahibiAdi] ve [HayvanAdi] değişkenlerini kullanın."
                />
                <p className="text-xs text-slate-500 mt-1">
                    Kullanılabilir Değişkenler: `[HastaSahibiAdi]`, `[HayvanAdi]`.
                </p>
            </div>

            <div className="p-3 bg-blue-100 rounded-md">
                <p className="font-semibold text-blue-800">Seçilen Alıcı Sayısı: {filteredPatients.length}</p>
                {filteredPatients.length > 0 && (
                    <p className="text-xs text-blue-700 mt-1">Örn. Mesaj: {messageDraft
                        .replace(/\[(HastaSahibiAdi|sahip|hasta sahibi)\]/gi, filteredPatients[0].ownerName)
                        .replace(/\[(HayvanAdi|hayvan|hasta)\]/gi, filteredPatients[0].name)
                        .substring(0, 80)}...</p>
                )}
            </div>

            <button
                onClick={handleSendBulk}
                className={`${successButtonClasses} w-full py-3`}
                disabled={filteredPatients.length === 0}
            >
                <Send size={20} className="mr-2"/> Mesaj Gönderimini Başlat ({filteredPatients.length} Kişi)
            </button>
        </div>
    );
};


const EntrySelectionScreen = ({ setViewMode }) => {
    return (
        <div className="min-h-screen flex items-center justify-center bg-slate-100 p-4">
            <div className="w-full max-w-lg bg-white rounded-xl shadow-2xl p-8 space-y-8 text-center animate-fade-in">
                <div>
                    <h1 className="text-3xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-teal-500 pb-1">
                        Çetinler Veteriner Kliniği
                    </h1>
                    <p className="text-slate-500 mt-2">Lütfen giriş türünü seçiniz.</p>
                </div>
                <div className="flex flex-col md:flex-row gap-4">
                    <button 
                        onClick={() => setViewMode('clinic')} 
                        className="flex-1 p-6 bg-blue-50 rounded-lg shadow-sm hover:bg-blue-100 hover:shadow-md transition-all duration-200 flex flex-col items-center space-y-3"
                    >
                        <Building size={48} className="text-blue-600"/>
                        <span className="text-xl font-semibold text-blue-800">Klinik Girişi</span>
                    </button>
                    <button 
                        onClick={() => setViewMode('portal_login')} 
                        className="flex-1 p-6 bg-teal-50 rounded-lg shadow-sm hover:bg-teal-100 hover:shadow-md transition-all duration-200 flex flex-col items-center space-y-3"
                    >
                        <UserCheck size={48} className="text-teal-600"/>
                        <span className="text-xl font-semibold text-teal-800">Hasta Sahibi Portalı</span>
                    </button>
                </div>
            </div>
        </div>
    );
};

const LoginScreen = ({ onLogin, onRegister, error, setError, setViewMode }) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [isLoginView, setIsLoginView] = useState(true);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!email || !password) {
            setError("Lütfen e-posta ve şifre girin.");
            return;
        }
        if (isLoginView) {
            onLogin(email, password);
        } else {
            onRegister(email, password);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-slate-100 p-4">
            <div className="w-full max-w-md bg-white rounded-xl shadow-2xl p-8 space-y-6 animate-fade-in">
                <div className="text-center">
                    <h1 className="text-3xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-teal-500 pb-1">
                        Klinik Yönetim Paneli
                    </h1>
                    <p className="text-slate-500 mt-2">{isLoginView ? 'Giriş Yapın' : 'Yeni Hesap Oluşturun'}</p>
                </div>
                <form onSubmit={handleSubmit} className="space-y-4">
                    <div className="relative">
                         <Mail className="absolute left-3 top-1/2 -translate-y-1/2 h-5 w-5 text-slate-400" />
                        <input
                            type="email"
                            placeholder="E-posta Adresi"
                            value={email}
                            onChange={(e) => { setEmail(e.target.value); setError(''); }}
                            className={inputClasses + " pl-10"}
                            required
                            autoComplete="email"
                        />
                    </div>
                    <div className="relative">
                        <KeyRound className="absolute left-3 top-1/2 -translate-y-1/2 h-5 w-5 text-slate-400" />
                        <input
                            type="password"
                            placeholder="Şifre"
                            value={password}
                            onChange={(e) => { setPassword(e.target.value); setError(''); }}
                            className={inputClasses + " pl-10"}
                            required
                            autoComplete={isLoginView ? "current-password" : "new-password"}
                        />
                    </div>
                    {error && <p className="text-red-500 text-sm text-center">{error}</p>}
                    <button type="submit" className={`${primaryButtonClasses} w-full`}>
                        {isLoginView ? 'Giriş Yap' : 'Kayıt Ol'}
                    </button>
                </form>
                <div className="text-center space-y-3">
                    <button
                        onClick={() => {
                            setIsLoginView(!isLoginView);
                            setError('');
                        }}
                        className="text-sm text-blue-600 hover:underline"
                    >
                        {isLoginView ? 'Hesabınız yok mu? Kayıt Olun' : 'Zaten bir hesabınız var mı? Giriş Yapın'}
                    </button>
                    <button onClick={() => setViewMode('entry')} className={`${secondaryButtonClasses} !bg-transparent !text-slate-600 !shadow-none !hover:text-blue-600 w-full`}>
                        <ChevronLeft size={16} className="mr-1.5"/> Ana Ekrana Geri Dön
                    </button>
                </div>
            </div>
        </div>
    );
};
const UserSelectionScreen = ({ mainUserId, onUserSelected, onLogout, setConfirmAction, setIsConfirmModalOpen, setNotification, setViewMode, setConfirmMessage }) => {    const [subUsers, setSubUsers] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState('');
    
    const [isPinModalOpen, setIsPinModalOpen] = useState(false);
    const [selectedUserForPin, setSelectedUserForPin] = useState(null);
    const [pinInput, setPinInput] = useState('');
    const [pinError, setPinError] = useState('');

    const [isAddUserModalOpen, setIsAddUserModalOpen] = useState(false);
    const [newUserName, setNewUserName] = useState('');
    const [newUserPin, setNewUserPin] = useState('');
    const [isSavingUser, setIsSavingUser] = useState(false);

    const subUsersColPath = `artifacts/${appId}/users/${mainUserId}/subUsers`;

    useEffect(() => {
        if (!db || !mainUserId) return;
        const q = query(collection(db, subUsersColPath), orderBy("name"));
        const unsubscribe = onSnapshot(q, (snapshot) => {
            const usersList = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
            setSubUsers(usersList);
            setIsLoading(false);
        }, (err) => {
            setError("Kullanıcı listesi yüklenemedi.");
            setIsLoading(false);
        });
        return () => unsubscribe();
    }, [mainUserId, subUsersColPath]);

    const handleUserClick = (user) => {
        // PIN zorunlu değilse doğrudan giriş yap
        if (!user.pin || user.pin === '') {
            onUserSelected(user);
            return;
        }
        setSelectedUserForPin(user);
        setIsPinModalOpen(true);
        setPinInput('');
        setPinError('');
    };

    const handlePinSubmit = (e) => {
        e.preventDefault();
        if (pinInput === selectedUserForPin.pin) {
            onUserSelected(selectedUserForPin);
            setIsPinModalOpen(false);
        } else {
            setPinError("Hatalı PIN. Lütfen tekrar deneyin.");
            if (navigator.vibrate) {
                navigator.vibrate(200);
            }
        }
    };
    
    const handleAddUser = async (e) => {
        e.preventDefault();
        if (!newUserName.trim()) {
            setNotification("Kullanıcı adı boş olamaz.");
            return;
        }
        if (newUserPin.trim() && !/^\d{4,6}$/.test(newUserPin.trim())) {
            setNotification("PIN 4 ila 6 rakam arasında olmalıdır.");
            return;
        }
        setIsSavingUser(true);
        setError('');
        try {
            await addDoc(collection(db, subUsersColPath), {
                name: newUserName.trim(),
                pin: newUserPin.trim(),
                createdAt: Timestamp.now()
            });
            setIsAddUserModalOpen(false);
            setNewUserName('');
            setNewUserPin('');
            setNotification("Yeni kullanıcı başarıyla eklendi.");
        } catch (err) {
            setNotification("Kullanıcı eklenemedi. Lütfen tekrar deneyin.");
        } finally {
            setIsSavingUser(false);
        }
    };

    
    const handleDeleteUser = (userIdToDelete) => {
        setConfirmAction(() => async () => {
             try {
                await deleteDoc(doc(db, subUsersColPath, userIdToDelete));
                setNotification("Kullanıcı başarıyla silindi.");
                setIsConfirmModalOpen(false);
            } catch (err) {
                setNotification("Kullanıcı silinemedi.");
                setIsConfirmModalOpen(false);
            }
        });
        setConfirmMessage(`'${subUsers.find(u => u.id === userIdToDelete)?.name}' adlı kullanıcı silinecek. Onaylıyor musunuz?`);
        setIsConfirmModalOpen(true);
    };


    if (isLoading) {
        return <div className="min-h-screen flex items-center justify-center bg-slate-100"><Loader2 className="animate-spin h-10 w-10 text-blue-600"/></div>;
    }

    return (
        <div className="min-h-screen flex flex-col items-center justify-center bg-slate-100 p-4">
            <div className="w-full max-w-2xl bg-white rounded-xl shadow-2xl p-8 text-center animate-fade-in">
                <h1 className="text-3xl font-bold text-slate-800">Kullanıcı Seçin</h1>
                <p className="text-slate-500 mt-2 mb-8">İşlem yapacak kullanıcıyı seçerek devam edin.</p>
                
                {error && <p className="text-red-500 text-sm mb-4">{error}</p>}

                <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 mb-8">
                    {subUsers.map(user => (
                        <div key={user.id} className="relative group">
                            <button onClick={() => handleUserClick(user)} className="w-full p-4 bg-slate-50 rounded-lg shadow-sm hover:bg-blue-100 hover:shadow-md transition-all duration-200 flex flex-col items-center space-y-2">
                                <UserCog size={40} className="text-slate-500 group-hover:text-blue-600"/>
                                <span className="font-semibold text-slate-700">{user.name}</span>
                                {user.pin && <KeyRound size={16} className="text-red-400"/>}
                            </button>
                            <button onClick={() => handleDeleteUser(user.id)} className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full p-1 opacity-0 group-hover:opacity-100 transition-opacity z-10">
                                <Trash2 size={12}/>
                            </button>
                        </div>
                    ))}
                    <button onClick={() => setIsAddUserModalOpen(true)} className="w-full p-4 bg-green-50 rounded-lg shadow-sm hover:bg-green-100 hover:shadow-md transition-all duration-200 flex flex-col items-center justify-center space-y-2 border-2 border-dashed border-green-300">
                        <UserPlus size={40} className="text-green-600"/>
                        <span className="font-semibold text-green-700">Yeni Kullanıcı</span>
                    </button>
                </div>
                
                <div className="flex flex-col sm:flex-row justify-center items-center gap-4">
                    <button onClick={() => setViewMode('entry')} className={secondaryButtonClasses}>
                        <ChevronLeft size={16} className="mr-1.5"/> Geri
                    </button>
                    <button onClick={onLogout} className={dangerButtonClasses}>
                        <LogOut size={16} className="mr-1.5"/> Ana Hesaptan Çıkış Yap
                    </button>
                </div>
            </div>

            <Modal isOpen={isPinModalOpen} onClose={() => setIsPinModalOpen(false)} title={`${selectedUserForPin?.name} için PIN Girin`} size="sm">
                <form onSubmit={handlePinSubmit} className="space-y-4">
                    <div className="relative">
                        <KeyRound className="absolute left-3 top-1/2 -translate-y-1/2 h-5 w-5 text-slate-400" />
                        <input
                            type="password"
                            placeholder="PIN Kodu"
                            value={pinInput}
                            onChange={(e) => { setPinInput(e.target.value); setPinError(''); }}
                            className={inputClasses + " pl-10 text-center tracking-[.5em]"}
                            required
                            autoFocus
                            maxLength="6"
                        />
                    </div>
                    {pinError && <p className="text-red-500 text-sm text-center">{pinError}</p>}
                    <button type="submit" className={`${primaryButtonClasses} w-full`}>
                        Giriş Yap
                    </button>
                </form>
            </Modal>
            
            <Modal isOpen={isAddUserModalOpen} onClose={() => setIsAddUserModalOpen(false)} title="Yeni Kullanıcı Ekle" size="md">
                <form onSubmit={handleAddUser} className="space-y-4">
                     <div>
                        <label htmlFor="newUserName" className={labelClasses}>Kullanıcı Adı*</label>
                        <input
                            type="text"
                            id="newUserName"
                            placeholder="Örn: Dr. Ahmet"
                            value={newUserName}
                            onChange={(e) => setNewUserName(e.target.value)}
                            className={inputClasses}
                            required
                        />
                    </div>
                    <div>
                        <label htmlFor="newUserPin" className={labelClasses}>PIN Kodu (Opsiyonel, 4-6 Rakam)</label>
                        <input
                            type="password"
                            id="newUserPin"
                            placeholder="••••"
                            value={newUserPin}
                            onChange={(e) => setNewUserPin(e.target.value)}
                            className={inputClasses}
                            maxLength="6"
                            pattern="\d{4,6}"
                        />
                         <p className="text-xs text-slate-500 mt-1">PIN girilmezse direkt giriş yapılabilir.</p>
                    </div>
                    <div className="flex justify-end space-x-3 pt-3">
                        <button type="button" onClick={() => setIsAddUserModalOpen(false)} className={secondaryButtonClasses}>İptal</button>
                        <button type="submit" className={`${primaryButtonClasses} group`} disabled={isSavingUser}>
                            {isSavingUser ? <Loader2 className="animate-spin h-5 w-5 mr-1.5"/> : <Save size={18} className="mr-1.5"/>}
                            {isSavingUser ? 'Kaydediliyor...' : 'Kullanıcıyı Kaydet'}
                        </button>
                    </div>
                </form>
            </Modal>
        </div>
    );
};
const Modal = ({ isOpen, onClose, title, children, size = "md", zIndex = "z-50" }) => {
    if (!isOpen) return null;
    // 4- Pencereye oturma iyileştirmesi: max-h-[90vh] ve overflow-y-auto eklendi
    const sizeClasses = { sm: "max-w-sm", md: "max-w-md", lg: "max-w-lg", xl: "max-w-xl", "2xl": "max-w-2xl", "3xl": "max-w-3xl", "4xl": "max-w-4xl", "5xl": "max-w-5xl", "6xl": "max-w-6xl", full: "max-w-full mx-4 sm:mx-auto" };
    const handleBackdropClick = (e) => { if (e.target === e.currentTarget) { onClose(); } };
    return (
        <div className={`fixed inset-0 bg-slate-900 bg-opacity-75 h-full w-full ${zIndex} flex justify-center items-center p-4 animate-fade-in-fast`} onClick={handleBackdropClick}>
            <div className={`bg-slate-50 rounded-xl shadow-2xl w-full ${sizeClasses[size]} max-h-[90vh] flex flex-col`}>
                <div className="flex justify-between items-center mb-4 pb-2 border-b border-slate-200 flex-shrink-0 p-4 sm:p-6 sticky top-0 bg-slate-50 z-10">
                    <h3 className="text-lg sm:text-xl md:text-2xl font-semibold text-slate-800">{title}</h3>
                    <button onClick={onClose} className="text-slate-500 hover:text-slate-700 p-1 rounded-full hover:bg-slate-100"><XCircle size={28} /></button>
                </div>
                <div className="flex-grow p-4 sm:p-6 pt-0 overflow-y-auto">
                    {children}
                </div>
            </div>
        </div>
    );
};

const ConfirmationModal = ({ isOpen, onClose, message, onConfirm, zIndex = "z-[120]" }) => {
    if (!isOpen) return null;
    
    const handleConfirm = () => {
        if (typeof onConfirm === 'function') {
            onConfirm();
        }
        onClose();
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose} title="Onay Gerekli" size="sm" zIndex={zIndex}>
            <p className="text-slate-700 mb-6">{message}</p>
            <div className="flex justify-end space-x-3 pb-1">
                <button onClick={onClose} className={secondaryButtonClasses}>İptal</button>
                <button onClick={handleConfirm} className={dangerButtonClasses}>Evet, Onayla</button>
            </div>
        </Modal>
    );
};

const AISuggestionModal = ({ isOpen, onClose, title, suggestion, isGenerating, onApply, onClearSuggestion }) => {
    if (!isOpen) return null;
    return (
        <Modal isOpen={isOpen} onClose={onClose} title={title} size="lg" zIndex="z-[110]">
            <div className="space-y-4">
                {isGenerating ? (
                    <div className="flex flex-col items-center justify-center p-6 text-blue-600">
                        <Loader2 className="h-8 w-8 animate-spin mb-3" />
                        <p className="text-lg">Öneriler oluşturuluyor...</p>
                    </div>
                ) : (
                    <>
                        {suggestion ? (
                            <div className="bg-blue-50 border border-blue-200 rounded-md p-4 text-sm max-h-60 overflow-y-auto">
                                <p className="whitespace-pre-wrap leading-relaxed">{suggestion}</p>
                            </div>
                        ) : (
                            <p className="text-slate-500 text-center py-4">Öneri bulunamadı. Lütfen girişleri kontrol edin veya tekrar deneyin.</p>
                        )}
                        <div className="flex justify-end space-x-3 pb-1">
                            {suggestion && (
                                <button type="button" onClick={onApply} className={`${primaryButtonClasses} text-sm py-1.5 px-3`}>
                                    <CheckCircle size={16} className="mr-1.5"/> Uygula
                                </button>
                            )}
                            <button type="button" onClick={() => { onClearSuggestion(); onClose(); }} className={`${secondaryButtonClasses} text-sm py-1.5 px-3`}>
                                İptal
                            </button>
                        </div>
                    </>
                )}
            </div>
        </Modal>
    );
};

const SendMessageModal = ({ isOpen, onClose, config }) => {
    const { phone, message, onSend } = config;
    const [messageText, setMessageText] = useState('');
    const [platform, setPlatform] = useState('whatsapp');

    useEffect(() => {
        if (isOpen) {
            setMessageText(message || '');
            setPlatform('whatsapp');
        }
    }, [isOpen, message]);
    
    if (!isOpen) return null;
    
    const handleSend = () => {
        let formattedPhone = phone.replace(/\D/g, '');
        if (formattedPhone.length === 10) formattedPhone = '90' + formattedPhone;
        if (formattedPhone.length === 11 && formattedPhone.startsWith('0')) formattedPhone = '90' + formattedPhone.substring(1);
        
        const encodedMessage = encodeURIComponent(messageText);

        const url = platform === 'whatsapp'
            ? `https://wa.me/${formattedPhone}?text=${encodedMessage}`
            : `sms:${formattedPhone}?body=${encodedMessage}`;
        
        window.open(url, '_blank');
        
        if (typeof onSend === 'function') {
            onSend();
        }
        onClose();
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose} title="Mesaj Gönder" size="lg" zIndex="z-[125]">
            <div className="space-y-4">
                <div>
                    <label className={labelClasses}>Gönderim Yöntemi</label>
                    <div className="flex gap-4 items-center mt-2">
                        <label className="flex items-center gap-2 p-3 border rounded-lg cursor-pointer flex-1 hover:bg-slate-100 transition-colors">
                            <input type="radio" name="platform" value="whatsapp" checked={platform === 'whatsapp'} onChange={() => setPlatform('whatsapp')} className="h-5 w-5 text-green-600 border-gray-300 rounded focus:ring-green-500" />
                            <MessageCircle className="text-green-600" size={20}/>
                            <span className="font-semibold text-green-700">WhatsApp</span>
                        </label>
                         <label className="flex items-center gap-2 p-3 border rounded-lg cursor-pointer flex-1 hover:bg-slate-100 transition-colors">
                            <input type="radio" name="platform" value="sms" checked={platform === 'sms'} onChange={() => setPlatform('sms')} className="h-5 w-5 text-blue-600 focus:ring-blue-500" />
                            <Smartphone className="text-blue-600" size={20}/>
                            <span className="font-semibold text-blue-700">SMS</span>
                        </label>
                    </div>
                     <p className="text-xs text-slate-500 mt-2">SMS seçeneği, Windows'taki 'Telefon Bağlantısı' uygulaması veya mobil cihazınızın varsayılan mesajlaşma uygulaması üzerinden gönderim yapar.</p>
                </div>

                <div>
                    <label htmlFor="messageText" className={labelClasses}>Mesaj İçeriği</label>
                    <textarea 
                        id="messageText" 
                        value={messageText} 
                        onChange={(e) => setMessageText(e.target.value)}
                        className={textareaClasses} 
                        rows="6"
                    />
                </div>
                <div className="flex justify-end items-center gap-3 pt-4 border-t">
                    <button onClick={onClose} className={secondaryButtonClasses}>İptal</button>
                    <button onClick={handleSend} className={successButtonClasses}>
                        <Send size={18} className="mr-2"/> Yönlendir ve Gönder
                    </button>
                </div>
            </div>
        </Modal>
    );
};


const PatientForm = ({ patient, onSave, onCancel, setNotification, isSaving }) => {
    const speciesOptions = ["Köpek", "Kedi", "Sığır", "Buzağı", "At", "Diğer"];
    const [formData, setFormData] = useState({
        name: '', species: speciesOptions[0], breed: '', ownerName: '', ownerPhone: '', ownerAddress: '', birthDate: '', notes: '', chipNumber: '',
        allergies: '', isBoarding: false, boardingStartDate: '', boardingEndDate: '', boardingNotes: '', weight: ''
    });
    const [sendWelcomeMessage, setSendWelcomeMessage] = useState(false);

    useEffect(() => {
        if (patient) {
            setFormData({
                ...patient,
                species: patient.species || speciesOptions[0],
                birthDate: patient.birthDate?.toDate ? patient.birthDate.toDate().toISOString().split('T')[0] : '',
                boardingStartDate: patient.boardingStartDate?.toDate ? patient.boardingStartDate.toDate().toISOString().split('T')[0] : '',
                boardingEndDate: patient.boardingEndDate?.toDate ? patient.boardingEndDate.toDate().toISOString().split('T')[0] : '',
                isBoarding: patient.isBoarding || false,
                weight: patient.weight || '',
                ownerAddress: patient.ownerAddress || ''
            });
            // Düzenleme modunda mesaj göndermeyi varsayılan olarak kapalı tut
            setSendWelcomeMessage(false); 
        } else {
            setFormData({ name: '', species: speciesOptions[0], breed: '', ownerName: '', ownerPhone: '', ownerAddress: '', birthDate: '', notes: '', chipNumber: '', allergies: '', isBoarding: false, boardingStartDate: '', boardingEndDate: '', boardingNotes: '', weight: '' });
            // Yeni hasta kaydında varsayılan olarak açık tut
            setSendWelcomeMessage(true);
        }
    }, [patient]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
    };
    
    const handleSubmit = (e) => { 
        e.preventDefault(); 
        if (!formData.name || !formData.ownerName || !formData.ownerPhone) { 
            setNotification("Lütfen Hayvan Adı, Sahip Adı ve Sahip Telefonu alanlarını doldurun."); 
            return; 
        } 
        onSave(formData, sendWelcomeMessage); 
    };

    return (
        <form onSubmit={handleSubmit} className="space-y-3">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                <div><label htmlFor="name" className={labelClasses}><PawPrint size={14} className="inline mr-1"/>Hayvanın Adı*</label><input type="text" name="name" id="name" value={formData.name} onChange={handleChange} className={inputClasses} required autoComplete="off" /></div>
                <div>
                    <label htmlFor="species" className={labelClasses}>Türü</label>
                    <select name="species" id="species" value={formData.species} onChange={handleChange} className={inputClasses} autoComplete="off">
                        {speciesOptions.map(opt => <option key={opt} value={opt}>{opt}</option>)}
                    </select>
                </div>
                <div><label htmlFor="breed" className={labelClasses}>Cinsi</label><input type="text" name="breed" id="breed" value={formData.breed} onChange={handleChange} className={inputClasses} autoComplete="off" /></div>
                <div><label htmlFor="chipNumber" className={labelClasses}>Çip Numarası</label><input type="text" name="chipNumber" id="chipNumber" value={formData.chipNumber} onChange={handleChange} className={inputClasses} autoComplete="off" /></div>
                <div><label htmlFor="birthDate" className={labelClasses}><CalendarDays size={14} className="inline mr-1"/>Doğum Tarihi</label><input type="date" name="birthDate" id="birthDate" value={formData.birthDate} onChange={handleChange} className={inputClasses} /></div>
                <div><label htmlFor="ownerName" className={labelClasses}><User size={14} className="inline mr-1"/>Sahip Adı*</label><input type="text" name="ownerName" id="ownerName" value={formData.ownerName} onChange={handleChange} className={inputClasses} required autoComplete="off" /></div>
                <div><label htmlFor="ownerPhone" className={labelClasses}><Phone size={14} className="inline mr-1"/>Sahip Telefonu*</label><input type="tel" name="ownerPhone" id="ownerPhone" value={formData.ownerPhone} onChange={handleChange} className={inputClasses} placeholder="05XXXXXXXXX" required autoComplete="off" /></div>
                <div><label htmlFor="allergies" className={labelClasses}><Info size={14} className="inline mr-1"/>Alerjiler (Virgülle ayırın)</label><input type="text" name="allergies" id="allergies" value={formData.allergies} onChange={handleChange} className={inputClasses} autoComplete="off" /></div>
                <div><label htmlFor="weight" className={labelClasses}><Weight size={14} className="inline mr-1"/>Kilo (kg)</label><input type="number" step="0.1" name="weight" id="weight" value={formData.weight} onChange={handleChange} className={inputClasses} placeholder="Örn: 15.5" autoComplete="off"/></div>
                <div className="md:col-span-2"><label htmlFor="ownerAddress" className={labelClasses}>Adres (Opsiyonel)</label><textarea name="ownerAddress" id="ownerAddress" value={formData.ownerAddress} onChange={handleChange} rows="2" className={textareaClasses} autoComplete="off" placeholder="Hasta sahibinin adresi..."></textarea></div>
            </div>
            
            {!patient && (
                 <div className="flex items-center space-x-3 p-3 bg-blue-50 border border-blue-200 rounded-md">
                    <input 
                        type="checkbox" 
                        id="sendWelcomeMessage" 
                        checked={sendWelcomeMessage} 
                        onChange={(e) => setSendWelcomeMessage(e.target.checked)} 
                        className="h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                    />
                    <label htmlFor="sendWelcomeMessage" className="text-sm font-medium text-blue-800">
                        Hasta sahibine otomatik hoş geldiniz mesajı gönder (Portal ID dahil)
                    </label>
                </div>
            )}

            <div className="border-t pt-3 mt-3">
                <h4 className="text-md font-semibold text-slate-700 mb-2 flex items-center"><Hospital size={16} className="mr-2 text-indigo-500"/>Konaklama Bilgileri</h4>
                <div className="flex items-center space-x-3 mb-2">
                    <input type="checkbox" name="isBoarding" id="isBoarding" checked={formData.isBoarding} onChange={handleChange} className="h-4 w-4 text-indigo-600 border-slate-300 rounded focus:ring-indigo-500"/>
                    <label htmlFor="isBoarding" className="text-sm text-slate-700">Şu anda konaklamada mı?</label>
                </div>
                {formData.isBoarding && (
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                        <div><label htmlFor="boardingStartDate" className={labelClasses}>Konaklama Başlangıç Tarihi</label><input type="date" name="boardingStartDate" id="boardingStartDate" value={formData.boardingStartDate} onChange={handleChange} className={inputClasses} /></div>
                        <div><label htmlFor="boardingEndDate" className={labelClasses}>Konaklama Bitiş Tarihi (Tahmini)</label><input type="date" name="boardingEndDate" id="boardingEndDate" value={formData.boardingEndDate} onChange={handleChange} className={inputClasses} /></div>
                        <div className="md:col-span-2"><label htmlFor="boardingNotes" className={labelClasses}>Konaklama Notları</label><textarea name="boardingNotes" id="boardingNotes" value={formData.boardingNotes} onChange={handleChange} rows="2" className={textareaClasses} autoComplete="off"></textarea></div>
                    </div>
                )}
            </div>
            <div><label htmlFor="notes" className={labelClasses}><Info size={14} className="inline mr-1"/>Genel Notlar</label><textarea name="notes" id="notes" value={formData.notes} onChange={handleChange} rows="2" className={textareaClasses} autoComplete="off"></textarea></div>
            <div className="flex justify-end space-x-3 pt-3 border-t mt-4 pb-1">
                <button type="button" onClick={onCancel} className={secondaryButtonClasses}>İptal</button>
                <button type="submit" className={primaryButtonClasses} disabled={isSaving}>
                    {isSaving ? (
                        <><Loader2 size={18} className="animate-spin mr-1.5"/> Kaydediliyor...</>
                    ) : (
                        <><CheckCircle size={18} className="mr-1.5"/> Kaydet</>
                    )}
                </button>
            </div>
        </form>
    );
};

const ReminderForm = ({ patient, onSave, onCancel, onGenerateText, generatedText, isGeneratingText, setGeneratedText, setNotification, isSaving, openSendMessageModal }) => {
    const [formData, setFormData] = useState({ 
        reminderDate: new Date().toISOString().split('T')[0], 
        reminderType: 'Aşı', 
        description: '',
        treatmentId: '',
        customTreatmentName: '',
        parasiteType: '',
        eventType: '', // Sürü takibi için eklendi
    });

    useEffect(() => { 
        if (!formData.description) {
            onGenerateText(patient.ownerName);
        }
    }, [patient, formData.description, onGenerateText]);

    useEffect(() => { 
        if(generatedText && formData.description !== generatedText) {
            setFormData(prev => ({...prev, description: generatedText}));
        }
    }, [generatedText, formData.description]);


    const patientSpecies = patient?.species;
    const availableTreatments = patientSpecies ? (window.treatmentSchedules[patientSpecies] || []) : [];
    
    const availableVaccines = availableTreatments.filter(t => t.type === "Aşı");
    const availableParasiteTreatments = availableTreatments.filter(t => t.type === "Parazit Tedavisi");
    const availableHerdTracks = patientSpecies === 'Sığır' ? (window.treatmentSchedules["Sürü"] || []).filter(t => t.type === "Sürü Takibi") : [];

    const handleChange = (e) => {
        const { name, value } = e.target;
        let newFormData = { ...formData, [name]: value };

        if (name === "reminderType") { 
            newFormData = { ...newFormData, treatmentId: '', customTreatmentName: '', parasiteType: '', eventType: '' };
        }
        if (name === "treatmentId" && value !== "Diger") { 
             newFormData = { ...newFormData, customTreatmentName: '' };
             if (newFormData.reminderType === 'Parazit Tedavisi') { 
                 const selectedTreatment = availableParasiteTreatments.find(t => t.id === value);
                 if(selectedTreatment) newFormData.parasiteType = selectedTreatment.parasiteType || '';
             }
        }
           if (name === "treatmentId" && value === "Diger" && newFormData.reminderType === 'Parazit Tedavisi') {
            newFormData.parasiteType = 'Diğer Parazit'; 
        }
        // Sürü takibinde eventType'ı treatmentName'den al
        if (name === "eventType" && newFormData.reminderType === 'Sürü Takibi') {
             newFormData.treatmentId = value; // treatmentId'yi de eventType'a eşitle (takip kolaylığı için)
        }

        setFormData(newFormData);
        // Mesaj metni değiştiğinde draft'ı güncel tut
        if (name === 'description') setGeneratedText(value); 
    };

    const handleSubmit = (e) => { 
        e.preventDefault(); 
        if (!formData.reminderDate || !formData.reminderType) { 
            setNotification("Hatırlatma Tarihi ve Türü zorunludur."); return; 
        }
        if (formData.reminderType === 'Aşı') {
            if (!formData.treatmentId) {
                 setNotification("Lütfen bir aşı seçin veya 'Diğer Aşı' seçeneğini işaretleyip adını girin."); return;
            }
            if (formData.treatmentId === "Diger" && !formData.customTreatmentName.trim()) {
                setNotification("Lütfen 'Diğer Aşı' için aşı adını giriniz."); return;
            }
        }
        if (formData.reminderType === 'Parazit Tedavisi') {
            if (!formData.treatmentId) { 
                 setNotification("Lütfen bir parazit tedavisi seçin/girin."); return;
            }
             if (formData.treatmentId === "Diger" && !formData.customTreatmentName.trim()) {
                setNotification("Lütfen 'Diğer Parazit Tedavisi' için tedavi adını giriniz."); return;
            }
        }
        if (formData.reminderType === 'Sürü Takibi' && !formData.eventType) {
             setNotification("Lütfen bir sürü takibi olayı seçin."); return;
        }

        onSave(formData); 
    };
    
    const handleSendMessageClick = () => {
        if (!patient?.ownerPhone) {
            setNotification("Hastanın telefon numarası kayıtlı değil.");
            return;
        }
        const message = generatedText || `${patient.name} için ${formData.reminderType} hatırlatması.`;
        openSendMessageModal(patient.ownerPhone, message);
    };


    return (
        <form onSubmit={handleSubmit} className="space-y-3">
            <div><label htmlFor="reminderDate" className={labelClasses}><CalendarDays size={14} className="inline mr-1"/>Hatırlatma Tarihi*</label><input type="date" name="reminderDate" id="reminderDate" value={formData.reminderDate} onChange={handleChange} className={inputClasses} required /></div>
            <div>
                <label htmlFor="reminderType" className={labelClasses}><Bell size={14} className="inline mr-1"/>Hatırlatma Türü*</label>
                <select name="reminderType" id="reminderType" value={formData.reminderType} onChange={handleChange} className={inputClasses} required>
                    <option value="Aşı">Aşı</option>
                    <option value="Parazit Tedavisi">Parazit Tedavisi</option>
                    {patientSpecies === 'Sığır' && <option value="Sürü Takibi">Sürü Takibi</option>}
                    <option value="Kontrol">Kontrol</option>
                    <option value="Operasyon Sonrası Kontrol">Operasyon Sonrası Kontrol</option>
                    <option value="Randevu">Randevu</option>
                    <option value="Diğer">Diğer</option>
                </select>
            </div>

            {formData.reminderType === 'Aşı' && (
                <>
                    <div>
                        <label htmlFor="treatmentId" className={labelClasses}><Pill size={14} className="inline mr-1"/>Aşı Adı*</label>
                        <select name="treatmentId" id="treatmentId" value={formData.treatmentId} onChange={handleChange} className={inputClasses} required>
                            <option value="">Aşı Seçiniz...</option>
                            {availableVaccines.map(vaccine => (
                                <option key={vaccine.id} value={vaccine.id}>{vaccine.name} {vaccine.note ? `(${vaccine.note})` : ''}</option>
                            ))}
                            <option value="Diger">Diğer Aşı (Manuel Giriş)</option>
                        </select>
                    </div>
                    {formData.treatmentId === 'Diger' && (
                        <div>
                            <label htmlFor="customTreatmentName" className={labelClasses}>Diğer Aşı Adı*</label>
                            <input type="text" name="customTreatmentName" id="customTreatmentName" value={formData.customTreatmentName} onChange={handleChange} className={inputClasses} placeholder="Aşı adını girin" required autoComplete="off"/>
                        </div>
                    )}
                </>
            )}

            {formData.reminderType === 'Parazit Tedavisi' && (
                 <>
                    <div>
                        <label htmlFor="treatmentId" className={labelClasses}><Pill size={14} className="inline mr-1"/>Parazit Tedavisi Adı/Türü*</label>
                        <select name="treatmentId" id="treatmentId" value={formData.treatmentId} onChange={handleChange} className={inputClasses} required>
                            <option value="">Tedavi Seçiniz...</option>
                            {availableParasiteTreatments.map(treatment => (
                                <option key={treatment.id} value={treatment.id}>{treatment.name} {treatment.note ? `(${treatment.note})` : ''}</option>
                            ))}
                            <option value="Diger">Diğer Parazit Tedavisi (Manuel Giriş)</option>
                        </select>
                    </div>
                    {formData.treatmentId === 'Diger' && (
                        <div>
                            <label htmlFor="customTreatmentName" className={labelClasses}>Diğer Tedavi Adı*</label>
                            <input type="text" name="customTreatmentName" id="customTreatmentName" value={formData.customTreatmentName} onChange={handleChange} className={inputClasses} placeholder="Tedavi adını girin" required autoComplete="off"/>
                        </div>
                    )}
                     {(formData.treatmentId === 'Diger' || !availableParasiteTreatments.find(t => t.id === formData.treatmentId)?.parasiteType) && ( 
                        <div>
                            <label htmlFor="parasiteType" className={labelClasses}>Parazit Türü</label>
                            <select name="parasiteType" id="parasiteType" value={formData.parasiteType} onChange={handleChange} className={inputClasses} >
                                <option value="">Seçiniz...</option>
                                <option value="İç Parazit">İç Parazit</option>
                                <option value="Dış Parazit">Dış Parazit</option>
                                <option value="Kalp Kurdu">Kalp Kurdu</option>
                                <option value="Genel">Genel Parazit</option>
                                <option value="Diğer Parazit">Diğer Parazit</option>
                            </select>
                        </div>
                    )}
                </>
            )}
            
            {formData.reminderType === 'Sürü Takibi' && availableHerdTracks.length > 0 && (
                <div>
                     <label htmlFor="eventType" className={labelClasses}><CalendarClock size={14} className="inline mr-1"/>Sürü Takip Olayı*</label>
                     <select name="eventType" id="eventType" value={formData.eventType} onChange={handleChange} className={inputClasses} required>
                        <option value="">Olay Seçiniz...</option>
                        {availableHerdTracks.map(track => (
                            <option key={track.id} value={track.name}>{track.name} {track.note ? `(${track.note})` : ''}</option>
                        ))}
                     </select>
                </div>
            )}

            <div>
                <label htmlFor="description" className={labelClasses}><MessageSquareText size={14} className="inline mr-1"/>Mesaj Metni / Ek Açıklama*</label>
                <textarea name="description" id="description" value={generatedText} onChange={handleChange} className={textareaClasses} rows="3" placeholder="Hatırlatma için ek notlar veya SMS metni..." required autoComplete="off"></textarea>
                <p className="text-xs text-slate-500 mt-1">
                    [HastaSahibiAdi] ve [HayvanAdi] değişkenlerini kullanarak hazır mesaj şablonunu kullanabilirsiniz.
                </p>
                <div className="flex flex-col sm:flex-row gap-2 mt-2">
                    <button 
                        type="button" 
                        onClick={handleSendMessageClick} 
                        className={`${successButtonClasses} text-xs py-1 px-2 flex-1`}
                    >
                        <Send size={14} className="mr-1.5"/> Mesaj Gönder
                    </button>
                </div>
            </div>

            <div className="flex justify-end space-x-3 pt-3 border-t mt-4 pb-1">
                <button type="button" onClick={onCancel} className={secondaryButtonClasses}>İptal</button>
                <button type="submit" className={primaryButtonClasses} disabled={isSaving}>
                    {isSaving ? (
                        <><Loader2 size={18} className="animate-spin mr-1.5"/> Kaydediliyor...</>
                    ) : (
                        <><CheckCircle size={18} className="mr-1.5"/> Hatırlatma Ekle</>
                    )}
                </button>
            </div>
        </form>
    );
};

const InventoryItemForm = ({ item, onSave, onCancel, setNotification, isSaving }) => {
    const speciesOptions = ["Köpek", "Kedi", "Sığır", "Buzağı", "At", "Diğer"];
    const [formData, setFormData] = useState({ 
        itemName: '', itemType: 'İlaç', quantityInStock: 0, unitPrice: 0, unit: 'Adet', expiryDate: '', supplierInfo: '', notes: '', lowStockThreshold: 5,
        bottleML: 0, 
        dosages: {}
    });

    useEffect(() => {
        const initialDosages = {};
        speciesOptions.forEach(species => {
            initialDosages[species] = item?.dosages?.[species] || { dosagePerKg: '', concentration: '', dosageUnit: '', notes: '' };
        });

        if (item) {
            setFormData({ 
                ...item, 
                expiryDate: item.expiryDate?.toDate ? item.expiryDate.toDate().toISOString().split('T')[0] : '',
                bottleML: item.bottleML || 0,
                dosages: initialDosages,
                quantityInStock: Number(item.quantityInStock) || 0, // NaN/null check
                unitPrice: Number(item.unitPrice) || 0,
                lowStockThreshold: Number(item.lowStockThreshold) || 5,
            });
        } else {
            setFormData({ 
                itemName: '', itemType: 'İlaç', quantityInStock: 0, unitPrice: 0, unit: 'Adet', expiryDate: '', supplierInfo: '', notes: '', lowStockThreshold: 5,
                bottleML: 0,
                dosages: initialDosages 
            });
        }
    }, [item]);

    const handleChange = (e) => setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
    
    const handleDosageChange = (species, field, value) => {
        setFormData(prev => ({
            ...prev,
            dosages: {
                ...prev.dosages,
                [species]: {
                    ...prev.dosages[species],
                    [field]: value
                }
            }
        }));
    };

    const handleSubmit = (e) => { 
        e.preventDefault(); 
        if (!formData.itemName) { 
            setNotification("Ürün adı zorunludur."); 
            return; 
        } 
        const finalDosages = {};
        Object.entries(formData.dosages).forEach(([species, dosageData]) => {
            if (Object.values(dosageData).some(val => val && val.toString().trim() !== '')) {
                finalDosages[species] = dosageData;
            }
        });

        onSave({ ...formData, dosages: finalDosages }); 
    };

    return (
        <form onSubmit={handleSubmit} className="space-y-3">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                <div><label htmlFor="itemName" className={labelClasses}>Ürün Adı*</label><input type="text" name="itemName" id="itemName" value={formData.itemName} onChange={handleChange} className={inputClasses} required autoComplete="off"/></div>
                <div><label htmlFor="itemType" className={labelClasses}>Ürün Türü</label><select name="itemType" id="itemType" value={formData.itemType} onChange={handleChange} className={inputClasses}><option>İlaç</option><option>Aşı</option><option>Mama</option><option>Medikal Malzeme</option><option>Diğer</option></select></div>
                <div><label htmlFor="quantityInStock" className={labelClasses}>Stok Miktarı</label><input type="number" name="quantityInStock" id="quantityInStock" value={formData.quantityInStock} onChange={handleChange} className={inputClasses} autoComplete="off"/></div>
                <div><label htmlFor="unit" className={labelClasses}>Birim</label><input type="text" name="unit" id="unit" value={formData.unit} onChange={handleChange} className={inputClasses} placeholder="Adet, Kutu, ml, gr" autoComplete="off"/></div>
                <div><label htmlFor="unitPrice" className={labelClasses}>Birim Satış Fiyatı (TL)</label><input type="number" step="0.01" name="unitPrice" id="unitPrice" value={formData.unitPrice} onChange={handleChange} className={inputClasses} autoComplete="off"/></div>
                <div><label htmlFor="expiryDate" className={labelClasses}>Son Kullanma Tarihi</label><input type="date" name="expiryDate" id="expiryDate" value={formData.expiryDate} onChange={handleChange} className={inputClasses}/></div>
                <div><label htmlFor="lowStockThreshold" className={labelClasses}>Düşük Stok Eşiği</label><input type="number" name="lowStockThreshold" id="lowStockThreshold" value={formData.lowStockThreshold} onChange={handleChange} className={inputClasses} autoComplete="off"/></div>
                <div className="md:col-span-2"><label htmlFor="supplierInfo" className={labelClasses}>Tedarikçi Bilgisi</label><input type="text" name="supplierInfo" id="supplierInfo" value={formData.supplierInfo} onChange={handleChange} className={inputClasses} autoComplete="off"/></div>
            </div>
            {formData.itemType === 'İlaç' && (
                <div className="border-t pt-3 mt-3">
                    <h4 className="text-md font-semibold text-slate-700 mb-2 flex items-center"><Syringe size={16} className="mr-2 text-red-500"/>İlaç Şişesi Bilgileri</h4>
                    <div>
                        <label htmlFor="bottleML" className={labelClasses}>İlaç Şişesi Hacmi (ml)</label>
                        <input type="number" step="0.1" name="bottleML" id="bottleML" value={formData.bottleML} onChange={handleChange} className={inputClasses} placeholder="Örn: 50.0" autoComplete="off"/>
                    </div>
                    <h4 className="text-md font-semibold text-slate-700 mb-2 flex items-center mt-4"><Calculator size={16} className="mr-2 text-blue-500"/>Türe Göre Dozaj Bilgileri</h4>
                    <div className="space-y-4">
                        {speciesOptions.map(species => (
                            <div key={species} className="p-3 border rounded-md bg-slate-50">
                                <p className="font-semibold text-sm mb-2 text-slate-600">{species}</p>
                                <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                                    <div><label className={labelClasses + " text-xs"}>Doz (mg/kg vb.)</label><input type="number" step="0.01" value={formData.dosages[species]?.dosagePerKg || ''} onChange={(e) => handleDosageChange(species, 'dosagePerKg', e.target.value)} className={inputClasses + " text-sm"} placeholder="Örn: 10" /></div>
                                    <div><label className={labelClasses + " text-xs"}>Konsantrasyon (mg/ml vb.)</label><input type="number" step="0.01" value={formData.dosages[species]?.concentration || ''} onChange={(e) => handleDosageChange(species, 'concentration', e.target.value)} className={inputClasses + " text-sm"} placeholder="Örn: 50" /></div>
                                    <div><label className={labelClasses + " text-xs"}>Dozaj Birimi</label><input type="text" value={formData.dosages[species]?.dosageUnit || ''} onChange={(e) => handleDosageChange(species, 'dosageUnit', e.target.value)} className={inputClasses + " text-sm"} placeholder="ml, tablet" /></div>
                                </div>
                                <div className="mt-3">
                                    <label className={labelClasses + " text-xs"}>Önemli Notlar</label>
                                    <textarea value={formData.dosages[species]?.notes || ''} onChange={(e) => handleDosageChange(species, 'notes', e.target.value)} className={textareaClasses + " text-sm"} rows="2" placeholder={`${species} için özel kullanım notları...`}></textarea>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            )}
            <div><label htmlFor="notes" className={labelClasses}>Genel Notlar</label><textarea name="notes" id="notes" value={formData.notes} onChange={handleChange} rows="2" className={textareaClasses} autoComplete="off"></textarea></div>
            <div className="flex justify-end space-x-3 pt-3 border-t mt-4 pb-1">
                <button type="button" onClick={onCancel} className={secondaryButtonClasses}>İptal</button>
                <button type="submit" className={primaryButtonClasses} disabled={isSaving}>
                    {isSaving ? <><Loader2 size={18} className="animate-spin mr-1.5"/> Kaydediliyor...</> : <><CheckCircle size={18} className="mr-1.5"/> Kaydet</>}
                </button>
            </div>
        </form>
    );
};

const DiagnosisQuickSelectModal = ({ isOpen, onClose, diagnoses, onSelectDiagnosis, setNotification }) => {
    const [filterText, setFilterText] = useState('');
    const filteredDiagnoses = diagnoses.filter(d => 
        d.name.toLowerCase().includes(filterText.toLowerCase())
    );

    return (
        <Modal isOpen={isOpen} onClose={onClose} title="Teşhis Seç" size="md" zIndex="z-[100]">
            <input
                type="text"
                placeholder="Teşhis ara..."
                className={inputClasses + " mb-4"}
                value={filterText}
                onChange={(e) => setFilterText(e.target.value)}
                autoComplete="off"
            />
            {filteredDiagnoses.length === 0 ? (
                <p className="text-center text-slate-500 py-4">Teşhis bulunamadı.</p>
            ) : (
                <div className="max-h-60 overflow-y-auto space-y-2">
                    {filteredDiagnoses.map(d => (
                        <div 
                            key={d.id} 
                            className="p-3 bg-slate-50 hover:bg-slate-100 rounded-md cursor-pointer flex justify-between items-center"
                            onClick={() => { onSelectDiagnosis(d.name); onClose(); }}
                        >
                            <span className="font-medium text-slate-800">{d.name}</span>
                            <span className="text-xs text-slate-500">{d.species}</span>
                        </div>
                    ))}
                </div>
            )}
            <div className="flex justify-end mt-4 pb-1">
                <button type="button" onClick={onClose} className={secondaryButtonClasses}>Kapat</button>
            </div>
        </Modal>
    );
};


const VisitForm = ({ patient, visit, onSave, onCancel, inventoryItems, onGenerateDiagnosisSuggestion, onGeneratePrescription, uniqueDiagnoses, addDiagnosisToQuickList, setNotification, openAISuggestionModal, isSaving }) => {
    const isDogOrCat = patient.species === 'Köpek' || patient.species === 'Kedi';
    const inventoryDrugs = useMemo(() => inventoryItems.filter(i => i.itemType === 'İlaç'), [inventoryItems]);

    const [formData, setFormData] = useState({
        visitDate: new Date().toISOString().split('T')[0], 
        anamnesis: '', 
        diagnosis: '', 
        procedures: '', 
        visitCost: 0,
        paymentAmount: 0,
        notes: '', 
        labResults: '',
        bodyWeight: '',
        temperature: '',
        heartRate: '',
        respiratoryRate: '',
        medicationsPrescribed: '',
        nextRevisitDate: ''
    });
    // Stoktaki ürünler için
    const [usedStockItems, setUsedStockItems] = useState([]);
    // Stok dışı ürünler için
    const [nonStockItemsUsed, setNonStockItemsUsed] = useState([]);
    
    const [remainingDebt, setRemainingDebt] = useState(0);
    const [stockItemsSubtotal, setStockItemsSubtotal] = useState(0);
    const [nonStockItemsSubtotal, setNonStockItemsSubtotal] = useState(0); 
    const [isDiagnosisSelectModalOpen, setIsDiagnosisSelectModalOpen] = useState(false);
    
    useEffect(() => {
        if (visit) {
            setFormData({
                visitDate: visit.visitDate?.toDate ? visit.visitDate.toDate().toISOString().split('T')[0] : new Date().toISOString().split('T')[0],
                anamnesis: visit.anamnesis || '', 
                diagnosis: visit.diagnosis || '',
                procedures: visit.procedures || '', 
                visitCost: Number(visit.visitCost) || 0, // NaN Fix
                paymentAmount: Number(visit.paymentAmount) || 0, // NaN Fix
                notes: visit.notes || '', 
                labResults: visit.labResults || '',
                bodyWeight: visit.bodyWeight || '',
                temperature: visit.temperature || '',
                heartRate: visit.heartRate || '',
                respiratoryRate: visit.respiratoryRate || '',
                medicationsPrescribed: visit.medicationsPrescribed || '',
                nextRevisitDate: visit.nextRevisitDate?.toDate ? visit.nextRevisitDate.toDate().toISOString().split('T')[0] : ''
            });
            
            // Yüklü ürünleri stoklu ve stok dışı olarak ayır
            const loadedUsedStockItems = [];
            const loadedNonStockItems = [];

            (visit.usedStockItems || []).forEach(usedItem => {
                const quantityUsed = Number(usedItem.quantityUsed) || 0;
                const unitPrice = Number(usedItem.unitPrice) || 0;
                
                if (usedItem.isStock) {
                     const correspondingInventoryItem = inventoryItems.find(invItem => invItem.id === usedItem.inventoryItemId);
                     loadedUsedStockItems.push({
                        ...usedItem,
                        itemName: correspondingInventoryItem ? correspondingInventoryItem.itemName : usedItem.itemName,
                        unitPrice: unitPrice,
                        isStock: true,
                        quantityInStock: correspondingInventoryItem?.quantityInStock || 0, 
                        unit: correspondingInventoryItem?.unit || 'Adet',
                        inventoryItemId: usedItem.inventoryItemId,
                        quantityUsed: quantityUsed,
                    });
                } else {
                    loadedNonStockItems.push({
                        ...usedItem,
                        itemName: usedItem.itemName || 'Stok Dışı Ürün',
                        quantityUsed: quantityUsed,
                        unitPrice: unitPrice,
                        isStock: false,
                        unit: usedItem.unit || 'Adet',
                        mlVolume: usedItem.mlVolume || 0,
                    });
                }
            });

            setUsedStockItems(loadedUsedStockItems);
            setNonStockItemsUsed(loadedNonStockItems);

        } else {
            setFormData({ 
                visitDate: new Date().toISOString().split('T')[0], anamnesis: '', diagnosis: '', procedures: '', 
                visitCost: 0, paymentAmount: 0, notes: '', labResults: '',
                bodyWeight: patient.weight || '',
                temperature: '', heartRate: '', respiratoryRate: '', medicationsPrescribed: '', nextRevisitDate: ''
            });
            setUsedStockItems([]);
            setNonStockItemsUsed([]);
        }
    }, [visit, inventoryItems, patient]);

    useEffect(() => { 
        const cost = Number(formData.visitCost) || 0;
        const paid = Number(formData.paymentAmount) || 0;
        const remainingDebt = Math.round((cost - paid) * 100) / 100;
        setRemainingDebt(remainingDebt);
    }, [formData.visitCost, formData.paymentAmount]);

    useEffect(() => {
        const subtotal = usedStockItems.reduce((sum, item) => {
            const quantity = Number(item.quantityUsed) || 0;
            const price = Number(item.unitPrice) || 0;
            return sum + (quantity * price);
        }, 0);
        setStockItemsSubtotal(subtotal);
    }, [usedStockItems]);
    
    // Stok dışı ürünler için alt toplam hesaplaması
    useEffect(() => {
        const subtotal = nonStockItemsUsed.reduce((sum, item) => {
            const quantity = Number(item.quantityUsed) || 0;
            const price = Number(item.unitPrice) || 0;
            return sum + (quantity * price);
        }, 0);
        setNonStockItemsSubtotal(subtotal);
    }, [nonStockItemsUsed]);


    const handleChange = (e) => setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
    
    // Stoklu Ürün İşlemleri
    const handleAddStockItem = () => {
        setUsedStockItems([...usedStockItems, { inventoryItemId: '', quantityUsed: 1, itemName: '', unitPrice: 0, isStock: true, quantityInStock: 0, unit: 'Adet' }]);
    };

    const handleStockItemChange = (index, field, value) => {
        const newItems = [...usedStockItems];
        if (field === 'inventoryItemId') {
            const selectedItem = inventoryItems.find(item => item.id === value);
            newItems[index] = { 
                ...newItems[index],
                inventoryItemId: value,
                itemName: selectedItem ? selectedItem.itemName : '',
                unitPrice: selectedItem ? (Number(selectedItem.unitPrice) || 0) : 0, // NaN Fix
                quantityInStock: selectedItem ? Number(selectedItem.quantityInStock) || 0 : 0,
                unit: selectedItem ? selectedItem.unit : 'Adet',
                isStock: true
            };
        } else if (field === 'quantityUsed') {
            newItems[index].quantityUsed = Number(value) > 0 ? Number(value) : 1;
        } else {
            newItems[index][field] = value;
        }
        setUsedStockItems(newItems);
    };

    const handleRemoveStockItem = (index) => setUsedStockItems(usedStockItems.filter((_, i) => i !== index));
    
    // Stok Dışı Ürün İşlemleri
    const handleAddNonStockItem = () => {
        setNonStockItemsUsed([...nonStockItemsUsed, { itemName: '', quantityUsed: 1, unitPrice: 0, mlVolume: 0, isStock: false, unit: 'Adet' }]);
    };
    
    const handleNonStockItemChange = (index, field, value) => {
        const newItems = [...nonStockItemsUsed];
        const currentItem = newItems[index];
        const inventoryDrugs = inventoryItems.filter(i => i.itemType === 'İlaç');

        if (field === 'itemName' && value) {
            // İlaç seçiliyorsa otomatik ml/fiyat hesaplama
            const selectedItem = inventoryDrugs.find(item => item.itemName === value && (Number(item.bottleML) || 0) > 0 && (Number(item.unitPrice) || 0) > 0);
            if (selectedItem) {
                currentItem.itemName = selectedItem.itemName;
                currentItem.unit = 'ml';
                currentItem.mlVolume = Number(selectedItem.bottleML);
                // Birim fiyatı şişe fiyatı / şişe hacmi olarak ayarla
                currentItem.unitPrice = ((Number(selectedItem.unitPrice) || 0) / (Number(selectedItem.bottleML) || 1)) || 0;
            } else {
                 currentItem.itemName = value;
                 currentItem.unit = 'Adet';
                 currentItem.mlVolume = 0;
                 currentItem.unitPrice = 0; // Eğer eşleşme yoksa sıfırla
            }
        } else if (field === 'itemName') {
            currentItem.itemName = value;
            currentItem.unit = 'Adet';
            currentItem.mlVolume = 0;
            currentItem.unitPrice = 0;
        } else if (field === 'quantityUsed') {
            currentItem.quantityUsed = Number(value) > 0 ? Number(value) : 1;
        } else if (field === 'unitPrice') {
             currentItem.unitPrice = Number(value) > 0 ? Number(value) : 0;
        } else if (field === 'unit') {
             currentItem.unit = value;
        }
        setNonStockItemsUsed(newItems);
    };

    const handleRemoveNonStockItem = (index) => setNonStockItemsUsed(nonStockItemsUsed.filter((_, i) => i !== index));

    const handleSubmit = (e) => {
        e.preventDefault();
        
        const totalSubtotal = stockItemsSubtotal + nonStockItemsSubtotal;
        
        // Formdaki ana tutar sıfırsa ve ürün eklenmemişse uyarı ver
        if (Number(formData.visitCost) <= 0 && totalSubtotal === 0) { 
            setNotification("Lütfen ziyaretin toplam tutarını giriniz veya kullanılan stok/stok dışı ürün ekleyiniz.");
            return;
        }
        
        // Stok kontrolü
        for (const item of usedStockItems) {
            const selectedItemInfo = inventoryItems.find(invItem => invItem.id === item.inventoryItemId);
            if (selectedItemInfo && Number(item.quantityUsed) > Number(selectedItemInfo.quantityInStock)) {
                setNotification(`Hata: ${selectedItemInfo.itemName} için yeterli stok yok. Mevcut: ${selectedItemInfo.quantityInStock}, İstenen: ${item.quantityUsed}`);
                return;
            }
        }

        const dataToSave = { 
            ...formData, 
            visitCost: Number(formData.visitCost) || 0,
            paymentAmount: Number(formData.paymentAmount) || 0,
            bodyWeight: Number(formData.bodyWeight) || null, // NaN fix
            temperature: formData.temperature.trim() || null,
            heartRate: formData.heartRate.trim() || null,
            respiratoryRate: formData.respiratoryRate.trim() || null,
        };
        
        // Yalnızca stoklu ürünleri (stoktan düşülecekleri) ayır
        const onlyStockItemsToDeduct = usedStockItems.filter(item => item.inventoryItemId && Number(item.quantityUsed) > 0);
        
        // Ziyaret toplam tutarını, eğer girilmemişse, otomatik olarak alt toplamdan ata
        if (dataToSave.visitCost === 0) {
             dataToSave.visitCost = totalSubtotal;
             if (dataToSave.paymentAmount > dataToSave.visitCost) {
                  dataToSave.paymentAmount = dataToSave.visitCost;
             }
        }
        
        onSave(dataToSave, onlyStockItemsToDeduct, nonStockItemsUsed);
    };

    const getCalculatedDosage = (item) => {
        const patientWeight = Number(formData.bodyWeight) || Number(patient.weight) || 0;
        const inventoryItem = inventoryItems.find(inv => inv.id === item.inventoryItemId);
        if (!inventoryItem || patientWeight <= 0 || !patient.species) return null;

        const dosageInfo = inventoryItem.dosages?.[patient.species];
        if (!dosageInfo || Number(dosageInfo.dosagePerKg) <= 0 || Number(dosageInfo.concentration) <= 0) return null;

        const doseInUnits = (patientWeight * Number(dosageInfo.dosagePerKg)) / Number(dosageInfo.concentration);
        // NaN Fix: Sonucun NaN olup olmadığını kontrol et
        if (isNaN(doseInUnits) || doseInUnits <= 0) return null; 
        
        return `${doseInUnits.toFixed(2)} ${dosageInfo.dosageUnit || 'birim'}`;
    };

    const handleAddDosageToPrescription = (item) => {
        const calculatedDosage = getCalculatedDosage(item);
        if (calculatedDosage) {
            const inventoryItem = inventoryItems.find(inv => inv.id === item.inventoryItemId);
            const prescriptionText = `${inventoryItem.itemName} (${item.unit}): Dozaj Önerisi: ${calculatedDosage}`;
            setFormData(prev => ({
                ...prev,
                notes: prev.notes
                    ? `${prev.notes}\n- ${prescriptionText}` 
                    : `- ${prescriptionText}`
            }));
            setNotification("Hesaplanan doz reçete notlarına eklendi.");
        } else {
            setNotification("Bu hayvan türü, kilo veya ilaç için hesaplanacak dozaj bilgisi bulunamadı.");
        }
    };

    const handleAddNoteToPrescription = (item) => {
        const inventoryItem = inventoryItems.find(inv => inv.id === item.inventoryItemId);
        if (!inventoryItem || !patient.species) return;

        const dosageInfo = inventoryItem.dosages?.[patient.species];
        if (dosageInfo && dosageInfo.notes) {
             setFormData(prev => ({
                ...prev,
                notes: prev.notes 
                    ? `${prev.notes}\n- ${item.itemName} Not: ${dosageInfo.notes}` 
                    : `- ${item.itemName} Not: ${dosageInfo.notes}`
            }));
            setNotification("İlaç notu reçete notlarına eklendi.");
        } else {
            setNotification("Bu ilaç için kaydedilmiş bir not bulunmuyor.");
        }
    };

    // İlaç adlarını benzersiz liste olarak alma (Stok dışı ürünler için)
    const uniqueDrugNames = useMemo(() => {
        return [...new Set(inventoryItems.filter(i => i.itemType === 'İlaç').map(i => i.itemName))];
    }, [inventoryItems]);


    return (
        <form onSubmit={handleSubmit} className="space-y-3">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                <div><label htmlFor="visitDate" className={labelClasses}><CalendarDays size={14} className="inline mr-1"/>Ziyaret Tarihi*</label><input type="date" name="visitDate" id="visitDate" value={formData.visitDate} onChange={handleChange} className={inputClasses} required /></div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-3 items-end">
                <div><label htmlFor="visitCost" className={labelClasses}><DollarSign size={14} className="inline mr-1"/>Ziyaret Toplam Tutarı* (TL)</label><input type="number" name="visitCost" id="visitCost" value={formData.visitCost} onChange={handleChange} className={inputClasses} placeholder="350.00" step="0.01" required autoComplete="off"/></div>
                <div><label htmlFor="paymentAmount" className={labelClasses}><CreditCard size={14} className="inline mr-1"/>Alınan Ücret (TL)</label><input type="number" name="paymentAmount" id="paymentAmount" value={formData.paymentAmount} onChange={handleChange} className={inputClasses} placeholder="300.00" step="0.01" autoComplete="off"/></div>
                <div>
                    <label className={labelClasses}>Kalan Borç (TL)</label>
                    <input type="text" value={formatCurrency(remainingDebt)} className={`${inputClasses} bg-slate-100 ${remainingDebt > 0 ? 'text-red-600 font-semibold' : remainingDebt < 0 ? 'text-blue-600 font-semibold' : 'text-green-600 font-semibold'}`} readOnly />
                </div>
            </div>

            <div>
                <label htmlFor="anamnesis" className={labelClasses}><FileText size={14} className="inline mr-1"/>Anamnez</label>
                <textarea name="anamnesis" id="anamnesis" value={formData.anamnesis} onChange={handleChange} className={textareaClasses} rows="4" autoComplete="off"></textarea>
                <button 
                    type="button" 
                    onClick={() => {
                        if (patient && patient.species && formData.anamnesis) {
                            // Vital bulguları da gönder
                            const vitalSigns = { 
                                temperature: formData.temperature, 
                                heartRate: formData.heartRate, 
                                respiratoryRate: formData.respiratoryRate 
                            };
                            onGenerateDiagnosisSuggestion(formData.anamnesis, patient.species, vitalSigns);
                            openAISuggestionModal("Teşhis ve Tedavi Önerisi", "diagnosis");
                        } else {
                            setNotification("Lütfen önce hayvan türünü ve anamnez bilgilerini girin.");
                        }
                    }} 
                    className={`${infoButtonClasses} text-xs mt-2 py-1 px-2 w-full sm:w-auto`}
                    disabled={!formData.anamnesis.trim()}
                >
                    <Sparkles size={14} className="mr-1.5"/>
                    ✨ Teşhis ve Tedavi Önerisi Al
                </button>
            </div>

            <div>
                <label htmlFor="diagnosis" className={labelClasses}><Stethoscope size={14} className="inline mr-1"/>Teşhis</label>
                <div className="flex items-center space-x-2">
                    <input
                        type="text"
                        name="diagnosis"
                        id="diagnosis"
                        value={formData.diagnosis}
                        onChange={handleChange}
                        className={inputClasses}
                        autoComplete="off"
                    />
                    <button type="button" onClick={() => setIsDiagnosisSelectModalOpen(true)} className={`${infoButtonClasses} text-xs py-1.5 px-2.5 whitespace-nowrap`}>
                        <ListChecks size={14} className="mr-1"/> Hızlı Seçim
                    </button>
                </div>
                <div className="mt-2">
                    <button type="button" onClick={() => addDiagnosisToQuickList(formData.diagnosis, patient?.species)} className={`${secondaryButtonClasses} text-xs py-1 px-2`}
                    disabled={!formData.diagnosis.trim() || !patient?.species}
                    >
                        <PlusCircle size={14} className="mr-1"/> Hızlı Seçime Ekle
                    </button>
                </div>
            </div>

            <div><label htmlFor="procedures" className={labelClasses}><ClipboardPlus size={14} className="inline mr-1"/>Uygulanan İşlemler</label><textarea name="procedures" id="procedures" value={formData.procedures} onChange={handleChange} className={textareaClasses} placeholder="Her satıra bir işlem" autoComplete="off"></textarea></div>
            
            {/* Vital Bulgular Sadece Kedi ve Köpek için görünür */}
            {isDogOrCat && (
                <div className="border-t pt-3 mt-3">
                    <h4 className="text-md font-semibold text-slate-700 mb-2 flex items-center"><ClipboardList size={16} className="mr-2 text-purple-500"/>Vital Bulgular</h4>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-3">
                        <div><label htmlFor="bodyWeight" className={labelClasses}><Weight size={14} className="inline mr-1"/>Vücut Ağırlığı (kg)</label><input type="number" step="0.1" name="bodyWeight" id="bodyWeight" value={formData.bodyWeight} onChange={handleChange} className={inputClasses} placeholder="Örn: 15.5" autoComplete="off"/></div>
                        <div><label htmlFor="temperature" className={labelClasses}><Thermometer size={14} className="inline mr-1"/>Sıcaklık (°C)</label><input type="number" step="0.1" name="temperature" id="temperature" value={formData.temperature} onChange={handleChange} className={inputClasses} placeholder="Örn: 38.5" autoComplete="off"/></div>
                        <div><label htmlFor="heartRate" className={labelClasses}><Heart size={14} className="inline mr-1"/>Kalp Atım Hızı (bpm)</label><input type="number" name="heartRate" id="heartRate" value={formData.heartRate} onChange={handleChange} className={inputClasses} placeholder="Örn: 120" autoComplete="off"/></div>
                        <div><label htmlFor="respiratoryRate" className={labelClasses}>Solunum Sayısı (rpm)</label><input type="number" name="respiratoryRate" id="respiratoryRate" value={formData.respiratoryRate} onChange={handleChange} className={inputClasses} placeholder="Örn: 25" autoComplete="off"/></div>
                    </div>
                </div>
            )}
            
            {/* Reçete Notları ve AI Reçete Oluşturma */}
            <div className="border-t pt-3 mt-3">
                <h4 className="text-md font-semibold text-slate-700 mb-2 flex items-center"><BookOpenText size={16} className="mr-2 text-blue-500"/>Ziyaret Notları (Detaylı Bilgiler ve Reçete)</h4>
                <textarea 
                    name="notes" 
                    id="notes" 
                    value={formData.notes} 
                    onChange={handleChange} 
                    className={textareaClasses} 
                    rows="4" 
                    placeholder="Detaylı notlar, Reçete (Manuel), Lab sonuçları..." 
                    autoComplete="off"
                ></textarea>
                 <button 
                    type="button" 
                    onClick={() => {
                        const currentPatientWeight = Number(formData.bodyWeight) || Number(patient.weight) || 0;
                        const vitalSigns = { 
                            temperature: formData.temperature, 
                            heartRate: formData.heartRate, 
                            respiratoryRate: formData.respiratoryRate 
                        };

                        onGeneratePrescription(formData.diagnosis, patient?.species, currentPatientWeight, formData.anamnesis, vitalSigns, inventoryItems); 
                        openAISuggestionModal("Reçete Oluşturma", "notes"); // Reçeteyi doğrudan notes alanına yazar
                    }} 
                    className={`${infoButtonClasses} text-xs py-1 px-2 mt-2`}
                    disabled={!patient?.species || (!formData.bodyWeight && !patient.weight) || !formData.diagnosis.trim()}
                >
                    <Sparkles size={14} className="mr-1.5"/>
                    ✨ Reçete Oluştur (AI)
                </button>
            </div>


            <div>
                <label htmlFor="nextRevisitDate" className={labelClasses}><CalendarDays size={14} className="inline mr-1"/>Sonraki Kontrol Tarihi (Opsiyonel)</label>
                <input type="date" name="nextRevisitDate" id="nextRevisitDate" value={formData.nextRevisitDate} onChange={handleChange} className={inputClasses}/>
            </div>

            <div className="border-t pt-3 mt-3">
                <div className="flex justify-between items-center mb-2">
                    <h4 className="text-md font-semibold text-slate-700 flex items-center"><Pill size={16} className="mr-2 text-green-500"/>Kullanılan Stok Ürünleri (Stoktan Düşülür)</h4>
                    <button type="button" onClick={handleAddStockItem} className={`${infoButtonClasses} text-xs py-1 px-2`}><PackagePlus size={14} className="mr-1"/>Stoktan Ürün Ekle</button>
                </div>
                {usedStockItems.map((item, index) => {
                    const selectedItemInfo = inventoryItems.find(invItem => invItem.id === item.inventoryItemId);
                    const currentStock = selectedItemInfo ? Number(selectedItemInfo.quantityInStock) : 0;
                    const displayUnitPrice = selectedItemInfo ? (Number(selectedItemInfo.unitPrice) || 0) : (Number(item.unitPrice) || 0);
                    const isQuantityInvalid = Number(item.quantityUsed) > currentStock;
                    const calculatedDosage = getCalculatedDosage(item);
                    const dosageNoteExists = selectedItemInfo?.dosages?.[patient.species]?.notes;

                    return (
                        <div key={`stock-${index}`} className="p-2 mb-2 border rounded-md bg-slate-50">
                            <div className="grid grid-cols-1 sm:grid-cols-[2fr_1fr_auto] gap-2 items-end">
                                <div>
                                    <label htmlFor={`stockItem-${index}`} className="text-xs text-slate-600">Ürün</label>
                                    <select id={`stockItem-${index}`} value={item.inventoryItemId} onChange={(e) => handleStockItemChange(index, 'inventoryItemId', e.target.value)} className={inputClasses + " text-sm py-1"}>
                                        <option value="">Seçiniz...</option>
                                        {inventoryItems.map(invItem => (
                                            <option key={invItem.id} value={invItem.id}>
                                                {invItem.itemName} (Stok: {Number(invItem.quantityInStock) || 0} {invItem.unit})
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div>
                                    <label htmlFor={`quantityUsed-${index}`} className="text-xs text-slate-600">Miktar</label>
                                    <input 
                                        type="number" 
                                        id={`quantityUsed-${index}`} 
                                        value={item.quantityUsed} 
                                        onChange={(e) => handleStockItemChange(index, 'quantityUsed', e.target.value)} 
                                        className={inputClasses + ` text-sm py-1 ${isQuantityInvalid ? 'border-red-500' : ''}`} 
                                        min="1"
                                        step="0.1" // Ondalık miktara izin ver
                                        autoComplete="off"
                                    />
                                    <p className="text-xs text-slate-500 mt-1">Birim Fiyat: {formatCurrency(displayUnitPrice)} TL</p>
                                </div>
                                <button type="button" onClick={() => handleRemoveStockItem(index)} className={`${dangerButtonClasses} text-xs p-1.5 self-end mb-1`} title="Bu ürünü kaldır"><Trash2 size={14}/></button>
                            </div>
                             {isQuantityInvalid && (
                                <p className="text-red-500 text-xs mt-1">Yetersiz stok! Mevcut: {currentStock}</p>
                            )}
                            {(calculatedDosage || dosageNoteExists) && (
                                <div className="flex items-center gap-2 mt-2 text-xs">
                                    {calculatedDosage && (
                                        <button type="button" onClick={() => handleAddDosageToPrescription(item)} className={`${purpleButtonClasses} py-1 px-2`}>
                                            <Calculator size={12} className="mr-1"/> Doz Ekle ({calculatedDosage})
                                        </button>
                                    )}
                                    {dosageNoteExists && (
                                         <button type="button" onClick={() => handleAddNoteToPrescription(item)} className={`${infoButtonClasses} py-1 px-2`}>
                                            <Info size={12} className="mr-1"/> Notu Ekle
                                        </button>
                                    )}
                                </div>
                            )}
                        </div>
                    );
                })}
                {usedStockItems.length === 0 && <p className="text-xs text-slate-500 text-center">Henüz stok ürünü eklenmedi.</p>}
                {usedStockItems.length > 0 && (
                    <div className="text-right text-sm font-semibold mt-3 pt-2 border-t border-slate-200">
                        <p>Stok Ürünleri Alt Toplamı: {formatCurrency(stockItemsSubtotal)} TL</p>
                    </div>
                )}
            </div>
            
            {/* Stok Dışı Ürünler */}
            <div className="border-t pt-3 mt-3">
                <div className="flex justify-between items-center mb-2">
                    <h4 className="text-md font-semibold text-slate-700 flex items-center"><Pill size={16} className="mr-2 text-orange-500"/>Stok Dışı Ürünler/İlaçlar (Stoktan Düşülmez)</h4>
                    <button type="button" onClick={handleAddNonStockItem} className={`${warningButtonClasses} text-xs py-1 px-2`}><PlusCircle size={14} className="mr-1"/>Ürün Ekle</button>
                </div>
                {nonStockItemsUsed.map((item, index) => {
                    const priceCalculated = (Number(item.quantityUsed) || 0) * (Number(item.unitPrice) || 0);
                    return (
                        <div key={`nonstock-${index}`} className="p-2 mb-2 border rounded-md bg-orange-50">
                            <div className="grid grid-cols-1 sm:grid-cols-4 md:grid-cols-[1fr_1fr_1fr_auto_auto] gap-2 items-end">
                                <div>
                                    <label htmlFor={`nonStockItemName-${index}`} className="text-xs text-slate-600">Ürün Adı / İlaç</label>
                                    <input list={`drug-list-${index}`} id={`nonStockItemName-${index}`} value={item.itemName} onChange={(e) => handleNonStockItemChange(index, 'itemName', e.target.value)} className={inputClasses + " text-sm py-1"} placeholder="İlaç veya Ürün Adı" required />
                                    <datalist id={`drug-list-${index}`}>
                                        {uniqueDrugNames.map(name => <option key={name} value={name} />)}
                                    </datalist>
                                    {item.mlVolume > 0 && <p className="text-xs text-slate-500 mt-1">Birim Fiyat ml/TL: {formatCurrency(item.unitPrice)} TL</p>}
                                </div>
                                <div>
                                    <label htmlFor={`nonStockUnit-${index}`} className="text-xs text-slate-600">Birim</label>
                                    <input 
                                        type="text" 
                                        id={`nonStockUnit-${index}`} 
                                        value={item.unit} 
                                        onChange={(e) => handleNonStockItemChange(index, 'unit', e.target.value)} 
                                        className={inputClasses + " text-sm py-1"} 
                                        autoComplete="off"
                                        placeholder="Adet, ml"
                                    />
                                </div>
                                <div>
                                    <label htmlFor={`nonStockQuantityUsed-${index}`} className="text-xs text-slate-600">Miktar</label>
                                    <input 
                                        type="number" 
                                        step={item.unit === 'ml' ? "0.1" : "1"}
                                        id={`nonStockQuantityUsed-${index}`} 
                                        value={item.quantityUsed} 
                                        onChange={(e) => handleNonStockItemChange(index, 'quantityUsed', e.target.value)} 
                                        className={inputClasses + " text-sm py-1"} 
                                        min="0"
                                        autoComplete="off"
                                        placeholder={item.unit === 'ml' ? 'Örn: 5.5' : 'Örn: 1'}
                                    />
                                </div>
                                <div>
                                    <label htmlFor={`nonStockUnitPrice-${index}`} className="text-xs text-slate-600">Birim Fiyat (TL)</label>
                                    <input 
                                        type="number" 
                                        step="0.01"
                                        id={`nonStockUnitPrice-${index}`} 
                                        value={item.unitPrice} 
                                        onChange={(e) => handleNonStockItemChange(index, 'unitPrice', e.target.value)} 
                                        className={inputClasses + " text-sm py-1"} 
                                        min="0"
                                        autoComplete="off"
                                    />
                                    <p className="text-xs text-slate-500 mt-1">Toplam: {formatCurrency(priceCalculated)} TL</p>
                                </div>
                                <button type="button" onClick={() => handleRemoveNonStockItem(index)} className={`${dangerButtonClasses} text-xs p-1.5 self-end mb-1`} title="Bu ürünü kaldır"><Trash2 size={14}/></button>
                            </div>
                        </div>
                    );
                })}
                {nonStockItemsUsed.length === 0 && <p className="text-xs text-slate-500 text-center">Henüz stok dışı ürün eklenmedi.</p>}
                {nonStockItemsUsed.length > 0 && (
                    <div className="text-right text-sm font-semibold mt-3 pt-2 border-t border-slate-200">
                        <p>Stok Dışı Ürünler Alt Toplamı: {formatCurrency(nonStockItemsSubtotal)} TL</p>
                    </div>
                )}
            </div>

            <div className="flex justify-end space-x-3 pt-3 border-t mt-4 pb-1">
                <button type="button" onClick={onCancel} className={secondaryButtonClasses}>İptal</button>
                <button type="submit" className={primaryButtonClasses} disabled={isSaving}>
                    {isSaving ? (
                        <><Loader2 size={18} className="animate-spin mr-1.5"/> Kaydediliyor...</>
                    ) : (
                        <><CheckCircle size={18} className="mr-1.5"/> Ziyareti Kaydet</>
                    )}
                </button>
            </div>
            
            <DiagnosisQuickSelectModal
                isOpen={isDiagnosisSelectModalOpen}
                onClose={() => setIsDiagnosisSelectModalOpen(false)}
                diagnoses={uniqueDiagnoses.filter(d => d.species === patient?.species)}
                onSelectDiagnosis={(selectedDiagnosis) => {
                    setFormData(prev => ({ ...prev, diagnosis: selectedDiagnosis }));
                    setIsDiagnosisSelectModalOpen(false);
                }}
                setNotification={setNotification}
            />
        </form>
    );
};



const PatientDetailView = ({ patient, visits, onAddVisit, onEditVisit, onDeleteVisit, onAddReminder, onEditPatient, allVisits, allCreditSales, isReadOnly = false, reminders = [], openPaymentCollectionModal }) => {
    const [activeTab, setActiveTab] = useState('visits');
    
    // Filtreleme yaparken NaN kontrolü eklendi
    const clinicalVisits = visits.filter(v => !v.isCreditSale && !v.isPrescriptionOnly && !v.isPaymentRecord);
    const financialTransactions = visits.filter(v => v.isCreditSale || v.isPaymentRecord);
    const prescriptionHistory = visits.filter(v => v.isPrescriptionOnly);

    // Bu hayvana özel borç hesaplaması (Visit üzerinden)
    const patientTotalDebt = useMemo(() => {
        const patientVisits = allVisits.filter(v => v.patientId === patient.id);
        const debt = patientVisits.reduce((sum, visit) => {
            // NaN Fix: Number() ile kontrol
            const debt = (Number(visit.visitCost) || 0) - (Number(visit.paymentAmount) || 0);
            return sum + debt;
        }, 0);
        return Math.round(debt * 100) / 100;
    }, [patient.id, allVisits]);


    const birthDate = patient.birthDate?.toDate ? patient.birthDate.toDate() : null;
    const boardingStartDate = patient.boardingStartDate?.toDate ? patient.boardingStartDate.toDate() : null;
    const boardingEndDate = patient.boardingEndDate?.toDate ? patient.boardingEndDate.toDate() : null;

    const renderVisitList = (visitList) => {
        if (visitList.length === 0) {
            return <p className="text-slate-500 text-center py-3 text-sm">Bu kategoride kayıt bulunmamaktadır.</p>;
        }
        return (
            <div className="space-y-3 max-h-[40vh] overflow-y-auto pr-1.5">
                {visitList.map(v => {
                    const visitDate = v.visitDate?.toDate ? v.visitDate.toDate() : null;
                    const debt = Number(v.remainingDebt) || 0;
                    let title = "Klinik Ziyareti";
                    if (v.isCreditSale && v.isPaymentRecord) title = "Tahsilat İşlemi";
                    else if (v.isCreditSale) title = "İlaç Satış"; 
                    else if (v.isPrescriptionOnly) title = "Reçete Kaydı";
                    
                    const detailedNotes = v.notes;


                    return (
                        <div key={`visit-${v.id}`} className="p-3 bg-white rounded-lg shadow border border-slate-200">
                            <div className="flex justify-between items-start mb-2">
                                <h5 className="font-semibold text-sm text-slate-800">
                                    {title}: {visitDate ? visitDate.toLocaleDateString('tr-TR') : 'Belirsiz'}
                                </h5>
                                {!isReadOnly && (
                                    <div className="flex space-x-1">
                                        {/* Finansal hareketler düzenlenemez, sadece silinebilir */}
                                        {!v.isCreditSale && !v.isPrescriptionOnly && <button onClick={() => onEditVisit(v)} className={`${secondaryButtonClasses} p-1 text-xs`} title="Düzenle"><Edit3 size={12}/></button>}
                                        <button onClick={() => onDeleteVisit(v.id)} className={`${dangerButtonClasses} p-1 text-xs`} title="Sil"><Trash2 size={12}/></button>
                                    </div>
                                )}
                            </div>
                            <div className="flex flex-col md:flex-row gap-x-4 gap-y-2 text-xs">
                                <div className="md:w-1/3 space-y-1 md:pr-3 md:border-r md:border-slate-200">
                                    {typeof v.visitCost !== 'undefined' && Number(v.visitCost) > 0 && <p><strong className="text-slate-600">Tutar:</strong> {formatCurrency(v.visitCost)} TL</p>}
                                    {typeof v.paymentAmount !== 'undefined' && <p><strong className="text-slate-600">Ödenen:</strong> {formatCurrency(v.paymentAmount)} TL</p>}
                                    {typeof v.remainingDebt !== 'undefined' && <p className={`font-semibold ${debt > 0 ? 'text-red-600' : debt < 0 ? 'text-blue-600' : 'text-green-600' }`}><strong className="text-slate-600">Bakiye:</strong> {formatCurrency(debt)} TL</p>}
                                </div>
                                <div className={"md:w-2/3 space-y-1 mt-2 md:mt-0"}>
                                    {v.diagnosis && <p className="font-semibold text-slate-700">Teşhis: {v.diagnosis}</p>}
                                    {v.procedures && <p><strong className="text-slate-600">İşlemler:</strong> {v.procedures.replace(/\n/g, ', ')}</p>}
                                    {detailedNotes && <p><strong className="text-slate-600">Detay/Not:</strong> <span className="whitespace-pre-wrap">{detailedNotes}</span></p>}
                                    {v.usedStockItems && v.usedStockItems.length > 0 && 
                                        <p><strong className="text-slate-600">Kullanılan Ürünler:</strong> {v.usedStockItems.map(item => `${item.itemName} (x${Number(item.quantityUsed) || 0} ${item.unit || ''}${item.isStock ? '' : ' - STOK DIŞI'})`).join(', ')}</p>
                                    }
                                    {v.performedBy && !isReadOnly && <p className="mt-1 pt-1 border-t border-slate-100"><strong className="text-slate-600">İşlemi Yapan:</strong> {v.performedBy}</p>}
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        );
    };
const renderRemindersList = (remindersList) => {
        if (!remindersList || remindersList.length === 0) {
             return <p className="text-slate-500 text-center py-3 text-sm">Bu hayvan için planlanmış veya geçmiş bir hatırlatma bulunmamaktadır.</p>;
        }
        
        const upcoming = remindersList.filter(r => r.status === 'pending').sort((a,b) => (a.reminderDate?.toDate() || 0) - (b.reminderDate?.toDate() || 0));
        const past = remindersList.filter(r => r.status !== 'pending').sort((a,b) => (b.reminderDate?.toDate() || 0) - (a.reminderDate?.toDate() || 0));

        return (
             <div className="space-y-4 max-h-[40vh] overflow-y-auto pr-1.5">
                {upcoming.length > 0 && (
                    <div>
                        <h3 className="text-md font-semibold text-blue-600 mb-2">Yaklaşan Hatırlatmalar</h3>
                        {upcoming.map(r => (
                             <div key={r.id} className="p-3 bg-blue-50 rounded-lg border border-blue-200 text-sm">
                                <p><strong>Tarih:</strong> {r.reminderDate?.toDate().toLocaleDateString('tr-TR')}</p>
                                <p><strong>Konu:</strong> {r.description}</p>
                             </div>
                        ))}
                    </div>
                )}
                {past.length > 0 && (
                    <div>
                         <h3 className="text-md font-semibold text-slate-600 mb-2">Geçmiş Hatırlatmalar</h3>
                         {past.map(r => (
                             <div key={r.id} className="p-3 bg-slate-50 rounded-lg border border-slate-200 text-sm opacity-80">
                                <p><strong>Tarih:</strong> {r.reminderDate?.toDate().toLocaleDateString('tr-TR')}</p>
                                <p><strong>Konu:</strong> {r.description}</p>
                                <p><strong>Durum:</strong> {r.status === 'sent' ? 'Gönderildi' : 'Tamamlandı/Diğer'}</p>
                             </div>
                         ))}
                    </div>
                )}
             </div>
        )
    };


    return (
        <div className="space-y-4">
            <section className="p-3 bg-slate-50 rounded-lg shadow">
                <div className="flex justify-between items-center mb-2">
                    <h4 className="text-md font-semibold text-blue-700 flex items-center"><User className="mr-1.5"/>Hasta Bilgileri</h4>
                    {!isReadOnly && <button onClick={onEditPatient} className={`${secondaryButtonClasses} text-xs py-1 px-2`}><Edit3 size={12} className="mr-1"/>Düzenle</button>}
                </div>
                <div className="grid grid-cols-2 sm:grid-cols-3 gap-x-3 gap-y-1.5 text-xs sm:text-sm">
                    <p><strong className="text-slate-600">Adı:</strong> {patient.name}</p>
                    <p><strong className="text-slate-600">Türü:</strong> {patient.species}</p>
                    <p><strong className="text-slate-600">Cinsi:</strong> {patient.breed}</p>
                    {birthDate && <p><strong className="text-slate-600">Doğum:</strong> {birthDate.toLocaleDateString('tr-TR')}</p>}
                    {patient.chipNumber && <p><strong className="text-slate-600">Çip No:</strong> {patient.chipNumber}</p>}
                    <p><strong className="text-slate-600">Sahip:</strong> {patient.ownerName}</p>
                    <p><strong className="text-slate-600">Telefon:</strong> {patient.ownerPhone}</p>
                    {patient.allergies && <p className="col-span-full"><strong className="text-slate-600">Alerjiler:</strong> {patient.allergies}</p>}
                    {patient.weight && <p><strong className="text-slate-600">Kilo:</strong> {patient.weight} kg</p>}
                    {patient.publicId && <p className="col-span-full font-mono"><strong className="text-slate-600">Portal ID:</strong> {patient.publicId}</p>}
                    {patient.ownerAddress && <p className="col-span-full"><strong className="text-slate-600">Adres:</strong> {patient.ownerAddress}</p>}
                </div>
                {patient.notes && <p className="mt-1.5 text-xs sm:text-sm"><strong className="text-slate-600">Genel Notlar:</strong> {patient.notes}</p>}
                
                {patient.isBoarding && ( 
                    <div className="mt-2 pt-2 border-t border-slate-200">
                        <h5 className="text-sm font-semibold text-indigo-600 flex items-center"><Hospital size={14} className="mr-1.5"/>Konaklamada</h5>
                        {boardingStartDate && <p className="text-xs"><strong className="text-slate-600">Başlangıç:</strong> {boardingStartDate.toLocaleDateString('tr-TR')}</p>}
                        {boardingEndDate && <p className="text-xs"><strong className="text-slate-600">Bitiş (Tahmini):</strong> {boardingEndDate.toLocaleDateString('tr-TR')}</p>}
                        {patient.boardingNotes && <p className="text-xs"><strong className="text-slate-600">Notlar:</strong> {patient.boardingNotes}</p>}
                    </div>
                )}
                {!isReadOnly && (
                    <div className="mt-2 pt-2 border-t border-slate-200 flex justify-between items-center">
                        <h5 className={`text-sm font-semibold flex items-center ${patientTotalDebt > 0.01 ? 'text-red-600' : 'text-green-600'}`}>
                                <AlertTriangle size={14} className={`mr-1.5 ${patientTotalDebt > 0.01 ? '' : 'hidden'}`}/> Bu Hayvanın Toplam Borcu: {formatCurrency(patientTotalDebt)} TL
                        </h5>
                        {patientTotalDebt > 0.01 && (
                            <button 
                                onClick={() => openPaymentCollectionModal(patient.ownerName)} 
                                className={`${warningButtonClasses} text-xs py-1 px-2`}
                                title="Tahsilat Yap (Sahibin Tüm Borçları Dahil)"
                            >
                                <Wallet size={14} className="mr-1"/> Tahsilat
                            </button>
                        )}
                    </div>
                )}
            </section>

            <section>
                <div className="flex justify-between items-center mb-2.5">
                    <div className="border-b border-slate-200">
                        <nav className="-mb-px flex space-x-4" aria-label="Tabs">
                            <button onClick={() => setActiveTab('visits')} className={`${activeTab === 'visits' ? 'border-blue-500 text-blue-600' : 'border-transparent text-slate-500 hover:text-slate-700 hover:border-slate-300'} whitespace-nowrap py-2 px-1 border-b-2 font-medium text-sm`}>
                                Klinik Ziyaretleri ({clinicalVisits.length})
                            </button>
                            <button onClick={() => setActiveTab('reminders')} className={`${activeTab === 'reminders' ? 'border-blue-500 text-blue-600' : 'border-transparent text-slate-500 hover:text-slate-700 hover:border-slate-300'} whitespace-nowrap py-2 px-1 border-b-2 font-medium text-sm`}>
                                Hatırlatmalar ({reminders.length})
                            </button>
                             <button onClick={() => setActiveTab('prescriptions')} className={`${activeTab === 'prescriptions' ? 'border-blue-500 text-blue-600' : 'border-transparent text-slate-500 hover:text-slate-700 hover:border-slate-300'} whitespace-nowrap py-2 px-1 border-b-2 font-medium text-sm`}>
                                Reçeteler ({prescriptionHistory.length})
                            </button>
                            {!isReadOnly && (
                                <button onClick={() => setActiveTab('financial')} className={`${activeTab === 'financial' ? 'border-blue-500 text-blue-600' : 'border-transparent text-slate-500 hover:text-slate-700 hover:border-slate-300'} whitespace-nowrap py-2 px-1 border-b-2 font-medium text-sm`}>
                                    Finansal Hareketler ({financialTransactions.length})
                                </button>
                            )}
                        </nav>
                    </div>
                    {!isReadOnly && (
                        <div className="space-x-1.5">
                            <button onClick={onAddReminder} className={`${warningButtonClasses} text-xs py-1 px-2`}><Bell size={12} className="mr-1"/> Hatırlatma</button>
                            <button onClick={onAddVisit} className={`${primaryButtonClasses} text-xs py-1 px-2`}><PlusCircle size={12} className="mr-1"/> Yeni Ziyaret</button>
                        </div>
                    )}
                </div>
                
                {activeTab === 'visits' && renderVisitList(clinicalVisits)}
                {activeTab === 'reminders' && renderRemindersList(reminders)}
                {activeTab === 'prescriptions' && renderVisitList(prescriptionHistory)}
                {activeTab === 'financial' && renderVisitList(financialTransactions)}

            </section>
        </div>
    );
};

const CalendarDisplay = ({ reminders, patients, onDateClick }) => {
    const [currentDate, setCurrentDate] = useState(new Date());
    const today = new Date(); today.setHours(0,0,0,0);
    const monthNames = ["Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran", "Temmuz", "Ağustos", "Eylül", "Ekim", "Kasım", "Aralık"];
    const dayNames = ["Pzt", "Sal", "Çrş", "Prş", "Cm", "Cts", "Paz"];

    const currentMonth = currentDate.getMonth();
    const currentYear = currentDate.getFullYear();

    const daysInMonth = new Date(currentYear, currentMonth + 1, 0).getDate();
    const firstDayOfMonth = new Date(currentYear, currentMonth, 1).getDay();
    const startingDay = (firstDayOfMonth === 0) ? 6 : firstDayOfMonth - 1;

    const handlePrevMonth = () => setCurrentDate(new Date(currentYear, currentMonth - 1, 1));
    const handleNextMonth = () => setCurrentDate(new Date(currentYear, currentMonth + 1, 1));
    
    const renderCalendarDays = () => {
        const blanks = Array(startingDay).fill(null);
        const daysArray = Array.from({ length: daysInMonth }, (_, i) => i + 1);
        
        return [...blanks, ...daysArray].map((day, index) => {
            if (!day) return <div key={`b-${index}`} className="border border-slate-200 p-1 h-16 sm:h-20"></div>;
            const date = new Date(currentYear, currentMonth, day); date.setHours(0,0,0,0);
            const isToday = date.getTime() === today.getTime();
            
            const remindersForDay = reminders.filter(r => {
                const rDate = r.reminderDate?.toDate();
                return rDate && rDate.getFullYear() === currentYear && rDate.getMonth() === currentMonth && rDate.getDate() === day && r.status === 'pending';
            });
            const boardingsForDay = patients.filter(p => {
                if (!p.isBoarding || !p.boardingStartDate?.toDate) return false;
                const startDate = p.boardingStartDate.toDate(); startDate.setHours(0,0,0,0);
                const endDate = p.boardingEndDate?.toDate ? p.boardingEndDate.toDate() : new Date(startDate.getTime() + 24*60*60*1000*30);
                endDate.setHours(23,59,59,999);
                return date >= startDate && date <= endDate;
            });

            return (
                <div key={day} className={`border border-slate-200 p-1 h-16 sm:h-20 overflow-y-auto text-xs ${isToday ? 'bg-blue-50 font-semibold' : 'bg-white'} hover:bg-sky-50 cursor-pointer`} onClick={() => onDateClick && onDateClick(date)}>
                    <span className={`text-[10px] sm:text-xs ${isToday ? 'text-blue-600' : 'text-slate-700'}`}>{day}</span>
                    {remindersForDay.length > 0 && remindersForDay.slice(0,1).map(r => <div key={`rem-${r.id}`} className="mt-0.5 text-[8px] sm:text-[10px] bg-yellow-400 text-white p-0.5 rounded-sm truncate" title={`${r.patientName} - ${r.reminderType}`}><Bell size={8} className="inline"/> {r.patientName.split(' ')[0]}</div>)}
                    {boardingsForDay.length > 0 && boardingsForDay.slice(0,1).map(p => <div key={`brd-${p.id}`} className="mt-0.5 text-[8px] sm:text-[10px] bg-indigo-400 text-white p-0.5 rounded-sm truncate" title={`${p.name} - Konaklama`}><Hospital size={8} className="inline"/> {p.name.split(' ')[0]}</div>)}
                    {(remindersForDay.length + boardingsForDay.length) > 1 && <div className="text-[8px] text-slate-500 text-center">+{(remindersForDay.length + boardingsForDay.length)-1}</div>}
                </div>
            );
        });
    };
    
    return (
        <section className="p-3 sm:p-4 bg-white/80 backdrop-blur-md rounded-xl shadow-lg">
            <div className="flex justify-between items-center mb-3"><button onClick={handlePrevMonth} className={`${secondaryButtonClasses} p-1.5 text-xs`}><ChevronLeft size={18}/></button><h3 className="text-md sm:text-lg font-semibold text-slate-700">{monthNames[currentMonth]} {currentYear}</h3><button onClick={handleNextMonth} className={`${secondaryButtonClasses} p-1.5 text-xs`}><ChevronRight size={18}/></button></div>
            <div className="grid grid-cols-7 gap-px bg-slate-200 border border-slate-200 text-[10px] sm:text-xs">{dayNames.map(d => <div key={d} className="text-center py-1.5 bg-slate-100 font-medium text-slate-600">{d}</div>)}{renderCalendarDays()}</div>
        </section>
    );
};

const DateDetailView = ({ date, reminders, boardingPatients, allPatients, onPatientDetailOpen, onDeleteReminder, setNotification }) => {
    const handleWhatsAppClick = (phoneNumber, messageText) => {
        if (!phoneNumber) {
            setNotification("Hastanın telefon numarası kayıtlı değil.");
            return;
        }
        let phone = phoneNumber.replace(/\D/g, '');
        if (phone.length === 10 && !phone.startsWith('90')) { 
            phone = '90' + phone;
        } else if (phone.length === 11 && phone.startsWith('0')) { 
            phone = '90' + phone.substring(1);
        }
        const message = encodeURIComponent(messageText || `Merhaba, ${date.toLocaleDateString('tr-TR')} tarihindeki hatırlatmanız hakkında.`);
        const whatsappUrl = `https://wa.me/${phone}?text=${message}`;
        window.open(whatsappUrl, '_blank');
    };

    return (
        <div className="space-y-4">
            {reminders.length === 0 && boardingPatients.length === 0 && (
                <p className="text-slate-500 text-center">Bu tarih için kayıtlı hatırlatma veya konaklama bulunmamaktadır.</p>
            )}
            {reminders.length > 0 && (
                <section>
                    <h4 className="text-md font-semibold text-yellow-700 mb-2 flex items-center"><Bell size={18} className="mr-2"/> Hatırlatmalar</h4>
                    <div className="space-y-2 max-h-48 overflow-y-auto">
                        {reminders.map(r => {
                            const patientForReminder = allPatients.find(p => p.id === r.patientId);
                            const species = patientForReminder?.species;
                            const scheduleForSpecies = species ? window.treatmentSchedules[species] : [];
                            const treatmentInfo = scheduleForSpecies?.find(v => v.id === r.treatmentId);
                            let displayName = r.description || r.reminderType; 
                            if (r.reminderType === 'Aşı' || r.reminderType === 'Parazit Tedavisi' || r.reminderType === 'Sürü Takibi') {
                                displayName = r.treatmentId === "Diger" ? r.customTreatmentName : (treatmentInfo?.name || r.treatmentId || r.reminderType);
                                if (r.description && (treatmentInfo?.name && !treatmentInfo.name.includes(r.description))) { 
                                    displayName += ` - ${r.description}`;
                                } else if (r.description && r.treatmentId === "Diger") {
                                    displayName += ` - ${r.description}`;
                                }
                            }

                            return (
                                <div key={r.id} className="p-2 border rounded-md bg-yellow-50 border-yellow-300">
                                    <p className="text-sm font-medium text-slate-800">{r.patientName} - {displayName}</p>
                                    <div className="flex space-x-2 mt-1">
                                        <button 
                                            onClick={() => {
                                                if(patientForReminder) onPatientDetailOpen(patientForReminder); 
                                                else console.warn("DateDetailView: Hatırlatma için hasta bulunamadı", r.patientId);
                                            }} 
                                            className="text-xs text-blue-600 hover:underline"
                                        >
                                            Hasta Detayına Git
                                        </button>
                                        {patientForReminder?.ownerPhone && (
                                            <button 
                                                onClick={() => handleWhatsAppClick(patientForReminder.ownerPhone, displayName)}
                                                className="text-xs text-green-600 hover:underline flex items-center"
                                            >
                                                <ExternalLink size={12} className="mr-0.5"/> WhatsApp
                                            </button>
                                        )}
                                        <button onClick={() => onDeleteReminder(r.id)} className="text-xs text-red-600 hover:underline">Sil</button>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </section>
            )}
            {boardingPatients.length > 0 && (
                <section>
                    <h4 className="text-md font-semibold text-indigo-700 mb-2 flex items-center"><Hospital size={18} className="mr-2"/> Konaklamalar</h4>
                    <div className="space-y-2 max-h-48 overflow-y-auto">
                        {boardingPatients.map(p => (
                            <div key={p.id} className="p-2 border rounded-md bg-indigo-50 border-indigo-300">
                                <p className="text-sm font-medium text-slate-800">{p.name} ({p.species})</p>
                                {p.boardingStartDate?.toDate && <p className="text-xs text-slate-600">Başlangıç: {p.boardingStartDate.toDate().toLocaleDateString('tr-TR')}</p>}
                                {p.boardingEndDate?.toDate && <p className="text-xs text-slate-600">Bitiş: {p.boardingEndDate.toDate().toLocaleDateString('tr-TR')}</p>}
                                {p.boardingNotes && <p className="text-xs text-slate-600">Not: {p.boardingNotes}</p>}
                                <button 
                                    onClick={() => onPatientDetailOpen(p)} 
                                    className="text-xs text-blue-600 hover:underline mt-1"
                                >
                                    Hasta Detayına Git
                                </button>
                            </div>
                        ))}
                    </div>
                </section>
            )}
        </div>
    );
};

const InventoryView = ({ items, onAddItem, onEditItem, onDeleteItem, searchTerm, setSearchTerm, setNotification }) => {
    const formatCurrency = (value) => {
        const number = Number(value) || 0;
        if (isNaN(number)) return '0.00'; 
        return number.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    };

    return (
        <div className="space-y-3">
            <div className="flex flex-col sm:flex-row justify-between items-center">
                <h3 className="text-lg font-semibold text-slate-800 mb-2 sm:mb-0">Stok Ürünleri ({items.length})</h3>
                <button onClick={onAddItem} className={`${primaryButtonClasses} text-sm py-1.5 px-2.5`}><PackagePlus size={16} className="mr-1.5"/> Yeni Ürün Ekle</button>
            </div>
            <input type="text" placeholder="Ürün adı veya türüne göre ara..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} className={`${inputClasses} text-sm`} autoComplete="off"/>
            {items.length === 0 && <p className="text-center text-slate-500 py-3"> {searchTerm ? 'Arama sonucu yok.' : 'Stokta ürün yok.'}</p>}
            <div className="overflow-x-auto max-h-96">
                <table className="min-w-full divide-y divide-slate-200 text-sm">
                    <thead className="bg-slate-50 sticky top-0"><tr>{["Ürün Adı", "Türü", "Stok", "Birim Fiyat", "Son Kul. Tarihi", "İşlemler"].map(h=><th key={h} className="px-3 py-2 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">{h}</th>)}</tr></thead>
                    <tbody className="bg-white divide-y divide-slate-200">
                        {items.map(item => {
                            const expiryDate = item.expiryDate?.toDate ? item.expiryDate.toDate() : null;
                            const isExpired = expiryDate && expiryDate < new Date();
                            const isLowStock = Number(item.quantityInStock) < (Number(item.lowStockThreshold) || 5);
                            return (
                            <tr key={item.id} className={`${isExpired ? 'bg-red-50' : isLowStock ? 'bg-yellow-50' : 'hover:bg-slate-50'}`}>
                                <td className="px-3 py-2 whitespace-nowrap font-medium">{item.itemName}</td>
                                <td className="px-3 py-2 whitespace-nowrap">{item.itemType}</td>
                                <td className={`px-3 py-2 whitespace-nowrap font-semibold ${isLowStock && !isExpired ? 'text-yellow-600' : ''}`}>{Number(item.quantityInStock) || 0} {item.unit}</td>
                                <td className="px-3 py-2 whitespace-nowrap">{item.unitPrice ? `${formatCurrency(item.unitPrice)} TL` : '-'}</td>
                                <td className={`px-3 py-2 whitespace-nowrap ${isExpired ? 'text-red-600 font-semibold' : ''}`}>{expiryDate ? expiryDate.toLocaleDateString('tr-TR') : '-'}</td>
                                <td className="px-3 py-2 whitespace-nowrap"><div className="flex space-x-1">
                                    <button onClick={() => onEditItem(item)} className={`${secondaryButtonClasses} p-1 text-xs`} title="Düzenle"><Edit3 size={12}/></button>
                                    <button onClick={() => onDeleteItem(item.id)} className={`${dangerButtonClasses} p-1 text-xs`} title="Sil"><Trash2 size={12}/></button>
                                </div></td>
                            </tr>
                            )})}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

// 3- Muhasebe Özeti - Hastalık Sıklığı Grafiği Eklendi
const AccountingView = ({ isOpen, userId, db, patientsMap, setNotification, onChartClick }) => { 
    const [localAllVisits, setLocalAllVisits] = useState([]);
    const [isLoading, setIsLoading] = useState(true); 
    const [timeRange, setTimeRange] = useState('all'); // Varsayılanı tüm zamanlara çekildi
    const [customStartDate, setCustomStartDate] = useState('');
    const [customEndDate, setCustomEndDate] = useState('');
    
    const formatCurrency = (value) => {
        const number = Number(value) || 0;
        if (isNaN(number)) return '0.00'; 
        return number.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    };
    
    const isMounted = useRef(false);
    useEffect(() => {
        isMounted.current = true;
        return () => { isMounted.current = false; };
    }, []);

    useEffect(() => {
        if (isOpen && userId && db) {
            const fetchAllData = async () => {
                if (isMounted.current) setIsLoading(true);
                try {
                    const visitsQuery = query(collectionGroup(db, 'visits'), where('userId', '==', userId));
                    const visitsSnapshot = await getDocs(visitsQuery);
                    
                    if (!isMounted.current) return;

                    const aggregatedVisits = visitsSnapshot.docs.map(doc => {
                        const visitData = doc.data();
                        const patient = patientsMap.get(visitData.patientId);

                        return {
                            id: doc.id,
                            ...visitData,
                            // NaN Fix: Gelen veriyi güvenli hale getir
                            visitCost: Number(visitData.visitCost) || 0,
                            paymentAmount: Number(visitData.paymentAmount) || 0,
                            remainingDebt: Number(visitData.remainingDebt) || 0,
                            patientName: patient?.name || 'Bilinmeyen Hasta',
                            ownerName: patient?.ownerName || 'Bilinmeyen Sahip',
                            patientSpecies: patient?.species || 'Diğer',
                            type: 'visit',
                        };
                    });
                    
                    if (isMounted.current) {
                        setLocalAllVisits(aggregatedVisits);
                    }
                } catch (error) {
                    if (isMounted.current) setNotification(`Muhasebe verileri çekilemedi: ${error.message}.`);
                } finally {
                    if (isMounted.current) setIsLoading(false);
                }
            };
            fetchAllData();
        }
    }, [isOpen, userId, db, patientsMap, setNotification]);


    const filteredTransactions = useMemo(() => {
        if (!localAllVisits) return [];
        const now = new Date();
        const todayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate()); 
        const todayEnd = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59, 999); 
        
        const currentDayOfWeek = todayStart.getDay();
        const daysSinceMonday = (currentDayOfWeek === 0 ? 6 : currentDayOfWeek - 1);
        const weekStart = new Date(todayStart);
        weekStart.setDate(todayStart.getDate() - daysSinceMonday);

        const monthStart = new Date(now.getFullYear(), now.getMonth(), 1);
        const monthEnd = new Date(now.getFullYear(), now.getMonth() + 1, 0, 23, 59, 59, 999);

        return localAllVisits.filter(transaction => {
            const transactionDate = transaction.visitDate?.toDate();
            if (!transactionDate) return false;
            if (timeRange === 'today') return transactionDate >= todayStart && transactionDate <= todayEnd;
            if (timeRange === 'thisWeek') return transactionDate >= weekStart && transactionDate <= todayEnd;
            if (timeRange === 'thisMonth') return transactionDate >= monthStart && transactionDate <= monthEnd;
            if (timeRange === 'custom' && customStartDate && customEndDate) {
                const start = new Date(customStartDate); start.setHours(0,0,0,0);
                const end = new Date(customEndDate); end.setHours(23,59,59,999);
                return transactionDate >= start && transactionDate <= end;
            }
            return timeRange === 'all';
        }).sort((a,b) => (b.visitDate.toDate()) - (a.visitDate.toDate()));
    }, [localAllVisits, timeRange, customStartDate, customEndDate]);

    const summary = useMemo(() => {
        return filteredTransactions.reduce((acc, t) => {
            // NaN Fix: Number() ile kontrol
            acc.totalFee += Number(t.visitCost) || 0;
            acc.totalCollected += Number(t.paymentAmount) || 0;
            return acc;
        }, { totalFee: 0, totalCollected: 0 });
    }, [filteredTransactions]);
    
    const totalRemainingDebt = summary.totalFee - summary.totalCollected;
    const totalVisitsCount = filteredTransactions.length;

    // Gelirin Teşhis Dağılımı (Top 10)
    const diagnosisRevenueData = useMemo(() => {
        const revenueMap = filteredTransactions.reduce((acc, visit) => {
            const diagnosis = visit.diagnosis && visit.diagnosis.trim() !== '' ? visit.diagnosis.trim() : null;
            if (diagnosis && !visit.isCreditSale && !visit.isPrescriptionOnly && diagnosis !== 'Finansal Hareket (Tahsilat)') {
               acc[diagnosis] = (acc[diagnosis] || 0) + (Number(visit.visitCost) || 0);
            }
            return acc;
        }, {});
        return Object.entries(revenueMap).map(([name, value]) => ({ name, value: Math.round(value * 100) / 100 })).sort((a,b) => b.value - a.value).slice(0, 10);
    }, [filteredTransactions]);
    
    // 3- Hastalık Sıklığı Grafiği (Aylık)
    const monthlyDiseaseFrequencyData = useMemo(() => {
        const diseaseFrequencyMap = {};
        const monthOrder = [];

        // 1. Teşhislerin Sıklığını Hesapla ve Aylara Göre Grupla
        filteredTransactions.forEach(v => {
            const diagnosis = v.diagnosis?.trim();
            const visitDate = v.visitDate?.toDate();

            if (diagnosis && visitDate && !v.isCreditSale && !v.isPrescriptionOnly && diagnosis !== 'Reçete' && diagnosis !== 'Finansal Hareket (Tahsilat)') {
                const monthKey = `${visitDate.getFullYear()}-${String(visitDate.getMonth() + 1).padStart(2, '0')}`;
                
                if (!monthOrder.includes(monthKey)) monthOrder.push(monthKey);

                if (!diseaseFrequencyMap[diagnosis]) {
                    diseaseFrequencyMap[diagnosis] = {};
                }
                diseaseFrequencyMap[diagnosis][monthKey] = (diseaseFrequencyMap[diagnosis][monthKey] || 0) + 1;
            }
        });
        
        // 2. En Sık Görülen Top 5 Hastalığı Bul
        const totalFrequency = Object.entries(diseaseFrequencyMap).map(([name, months]) => ({
            name,
            total: Object.values(months).reduce((a, b) => a + b, 0)
        })).sort((a, b) => b.total - a.total).slice(0, 5).map(d => d.name);

        if (totalFrequency.length === 0) return [];

        // 3. Grafik Verisini Topla
        const finalData = [];
        monthOrder.sort().forEach(monthKey => {
            const [year, month] = monthKey.split('-');
            const monthName = new Date(year, month - 1, 1).toLocaleDateString('tr-TR', { year: 'numeric', month: 'short' });
            
            const monthData = { name: monthName };
            let totalCases = 0;

            totalFrequency.forEach(diseaseName => {
                const count = diseaseFrequencyMap[diseaseName]?.[monthKey] || 0;
                monthData[diseaseName] = count;
                totalCases += count;
            });
            
            if (totalCases > 0) {
                 finalData.push(monthData);
            }
        });
        
        // Grafikte sadece en sık görülen 5 hastalığın ismini tut
        finalData.diseaseNames = totalFrequency;
        
        return finalData;
    }, [filteredTransactions]);


    const timeSeriesData = useMemo(() => {
        if (filteredTransactions.length === 0) return [];
        let formatKey;
        const start = new Date(customStartDate || filteredTransactions[filteredTransactions.length - 1].visitDate.toDate());
        const end = new Date(customEndDate || filteredTransactions[0].visitDate.toDate());
        const timeDiffDays = (end - start) / (1000 * 60 * 60 * 24);

        if (timeDiffDays <= 60 && timeRange !== 'all') { // Günlük veya 2 aylık periyotlar için günlük gösterim
            formatKey = (date) => date.toISOString().split('T')[0];
        } else { // Daha uzun periyotlar için aylık gösterim
            formatKey = (date) => `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`;
        }
        
        const groupedData = filteredTransactions.reduce((acc, visit) => {
            const visitDate = visit.visitDate?.toDate();
            if (!visitDate) return acc;
            const key = formatKey(visitDate);
            if (!acc[key]) acc[key] = { income: 0, visits: 0 };
            acc[key].income += Number(visit.visitCost) || 0;
            if (!visit.isCreditSale && !visit.isPrescriptionOnly && !visit.isPaymentRecord) acc[key].visits += 1;
            return acc;
        }, {});
        
        // Recharts'te NaN/0 değer hatalarını önlemek için değerleri kontrol et
        return Object.entries(groupedData).map(([date, values]) => ({ 
            date, 
            income: Math.round(values.income * 100) / 100, // Yuvarla
            visits: values.visits
        })).sort((a, b) => new Date(a.date) - new Date(b.date));
    }, [filteredTransactions, timeRange, customStartDate, customEndDate]);

    if (isLoading) {
        return <div className="flex flex-col items-center justify-center p-10"><Loader2 className="h-12 w-12 animate-spin text-blue-500" /><p className="mt-4 text-lg text-slate-600">Muhasebe verileri yükleniyor...</p></div>;
    }

    // Pie Chart için özel etiket
    const RADIAN = Math.PI / 180;
    const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index, name, value }) => {
        if (percent < 0.05) return null; // Küçük dilimleri gösterme
        const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
        const x = cx + radius * Math.cos(-midAngle * RADIAN);
        const y = cy + radius * Math.sin(-midAngle * RADIAN);
        return (
            <text x={x} y={y} fill="white" textAnchor="middle" dominantBaseline="central" fontSize="12px" fontWeight="bold">
                {`${(percent * 100).toFixed(0)}%`}
            </text>
        );
    };

    const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#A28DFF', '#FF69B4', '#17becf', '#f97316', '#84cc16', '#e879f9', '#8b5cf6', '#d946ef'];


    return (
        <div className="space-y-4">
            <div className="flex flex-wrap gap-2 items-end p-3 bg-slate-50 rounded-md">
                <div className="flex-grow">
                    <label htmlFor="timeRange" className={labelClasses}>Zaman Aralığı</label>
                    <select name="timeRange" value={timeRange} onChange={(e) => setTimeRange(e.target.value)} className={inputClasses + " text-sm"}>
                        <option value="today">Bugün</option>
                        <option value="thisWeek">Bu Hafta</option>
                        <option value="thisMonth">Bu Ay</option>
                        <option value="all">Tüm Zamanlar</option>
                        <option value="custom">Özel Tarih Aralığı</option>
                    </select>
                </div>
                {timeRange === 'custom' && (<><div className="flex-grow"><label className={labelClasses}>Başlangıç</label><input type="date" value={customStartDate} onChange={e => setCustomStartDate(e.target.value)} className={inputClasses + " text-sm"}/></div><div className="flex-grow"><label className={labelClasses}>Bitiş</label><input type="date" value={customEndDate} onChange={e => setCustomEndDate(e.target.value)} className={inputClasses + " text-sm"}/></div></>)}
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 text-center">
                <div className="p-3 bg-blue-100 rounded-lg shadow"><p className="text-xs text-blue-700 font-medium flex items-center justify-center"><Layers size={14} className="mr-1"/>TOPLAM CİRO</p><p className="text-xl font-bold text-blue-800">{formatCurrency(summary.totalFee)} TL</p></div>
                <div className="p-3 bg-green-100 rounded-lg shadow"><p className="text-xs text-green-700 font-medium flex items-center justify-center"><TrendingUp size={14} className="mr-1"/>TOPLAM TAHSİLAT</p><p className="text-xl font-bold text-green-800">{formatCurrency(summary.totalCollected)} TL</p></div>
                <div className="p-3 bg-red-100 rounded-lg shadow"><p className="text-xs text-red-700 font-medium flex items-center justify-center"><TrendingDown size={14} className="mr-1"/>TOPLAM VERESİYE</p><p className="text-xl font-bold text-red-800">{formatCurrency(totalRemainingDebt)} TL</p></div>
                <div className="p-3 bg-indigo-100 rounded-lg shadow"><p className="text-xs text-indigo-700 font-medium">TOPLAM İŞLEM</p><p className="text-xl font-bold text-indigo-800">{totalVisitsCount}</p></div>
            </div>
            
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mt-4">
                {timeSeriesData.length > 1 && (
                     <div className="bg-white p-4 rounded-lg shadow-lg cursor-pointer hover:shadow-xl transition-shadow" onClick={() => onChartClick({
                        title: 'Gelir ve Vaka Zaman Serisi',
                        data: timeSeriesData,
                        chart: <LineChart data={timeSeriesData}><CartesianGrid strokeDasharray="3 3" /><XAxis dataKey="date" /><YAxis yAxisId="left" stroke="#8884d8" /><YAxis yAxisId="right" orientation="right" stroke="#82ca9d" /><Tooltip formatter={(value, name) => name === 'Ciro (TL)' ? `${formatCurrency(value)} TL` : value} /><Legend /><Line yAxisId="left" type="monotone" dataKey="income" stroke="#8884d8" name="Ciro (TL)" strokeWidth={2} /><Line yAxisId="right" type="monotone" dataKey="visits" stroke="#82ca9d" name="Klinik Vaka Sayısı" strokeWidth={2} /></LineChart>
                    })}>
                        <h4 className="text-md font-semibold text-slate-700 mb-3 text-center">Gelir ve Vaka Zaman Serisi</h4>
                        <ResponsiveContainer width="100%" height={300}>
                            <LineChart data={timeSeriesData} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}><CartesianGrid strokeDasharray="3 3" /><XAxis dataKey="date" /><YAxis yAxisId="left" stroke="#8884d8" /><YAxis yAxisId="right" orientation="right" stroke="#82ca9d" /><Tooltip formatter={(value, name) => name === 'Ciro (TL)' ? `${formatCurrency(value)} TL` : value} /><Legend /><Line yAxisId="left" type="monotone" dataKey="income" stroke="#8884d8" name="Ciro (TL)" strokeWidth={2} /><Line yAxisId="right" type="monotone" dataKey="visits" stroke="#82ca9d" name="Klinik Vaka Sayısı" strokeWidth={2} /></LineChart>
                        </ResponsiveContainer>
                    </div>
                )}
                {diagnosisRevenueData.length > 0 && (
                    <div className="bg-white p-4 rounded-lg shadow-lg cursor-pointer hover:shadow-xl transition-shadow" onClick={() => onChartClick({
                        title: 'Gelirin Teşhis Dağılımı (Top 10)',
                        data: diagnosisRevenueData,
                        chart: <BarChart data={diagnosisRevenueData} layout="vertical"><CartesianGrid strokeDasharray="3 3" /><XAxis type="number" tickFormatter={(value) => `${formatCurrency(value)}`} /><YAxis type="category" dataKey="name" width={120} interval={0} /><Tooltip formatter={(value) => [`${formatCurrency(value)} TL`, 'Gelir']} /><Legend /><Bar dataKey="value" fill="#8884d8" name="Gelir (TL)" /></BarChart>
                    })}>
                        <h4 className="text-md font-semibold text-slate-700 mb-3 text-center">Gelirin Teşhis Dağılımı (Top 10)</h4>
                        <ResponsiveContainer width="100%" height={300}><BarChart data={diagnosisRevenueData} layout="vertical" margin={{ top: 5, right: 30, left: 20, bottom: 5 }}><CartesianGrid strokeDasharray="3 3" /><XAxis type="number" tickFormatter={(value) => `${formatCurrency(value)}`} /><YAxis type="category" dataKey="name" width={120} interval={0} /><Tooltip formatter={(value) => [`${formatCurrency(value)} TL`, 'Gelir']} /><Legend /><Bar dataKey="value" fill="#8884d8" name="Gelir (TL)" /></BarChart></ResponsiveContainer>
                    </div>
                )}
                 {/* 3- Hastalık Sıklığı Grafiği */}
                 {monthlyDiseaseFrequencyData.length > 0 && (
                    <div className="lg:col-span-2 bg-white p-4 rounded-lg shadow-lg cursor-pointer hover:shadow-xl transition-shadow" onClick={() => onChartClick({
                        title: `Aylık En Sık ${monthlyDiseaseFrequencyData.diseaseNames.length} Hastalık Sıklığı`,
                        data: monthlyDiseaseFrequencyData,
                        chart: <BarChart data={monthlyDiseaseFrequencyData} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
                                    <CartesianGrid strokeDasharray="3 3" />
                                    <XAxis dataKey="name" />
                                    <YAxis allowDecimals={false} label={{ value: 'Vaka Sayısı', angle: -90, position: 'insideLeft' }}/>
                                    <Tooltip />
                                    <Legend wrapperStyle={{fontSize: '10px'}}/>
                                    {monthlyDiseaseFrequencyData.diseaseNames.map((name, index) => (
                                        <Bar key={name} dataKey={name} stackId="a" fill={COLORS[index % COLORS.length]} />
                                    ))}
                                </BarChart>,
                        chartId: 'monthlyDiseaseFrequency'
                    })}>
                        <h4 className="text-md font-semibold text-slate-700 mb-3 text-center">Aylık En Sık 5 Hastalık Sıklığı</h4>
                        <ResponsiveContainer width="100%" height={300}>
                            <BarChart data={monthlyDiseaseFrequencyData} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
                                <CartesianGrid strokeDasharray="3 3" />
                                <XAxis dataKey="name" />
                                <YAxis allowDecimals={false}/>
                                <Tooltip />
                                <Legend wrapperStyle={{fontSize: '10px'}}/>
                                {monthlyDiseaseFrequencyData.diseaseNames.map((name, index) => (
                                    <Bar key={name} dataKey={name} stackId="a" fill={COLORS[index % COLORS.length]} />
                                ))}
                            </BarChart>
                        </ResponsiveContainer>
                    </div>
                )}
            </div>

            <div className="mt-6">
                <h3 className="text-lg font-semibold text-slate-800 mb-3">İşlem Detayları</h3>
                <div className="overflow-x-auto max-h-[40vh] bg-white rounded-lg shadow">
                    <table className="min-w-full divide-y divide-slate-200 text-sm">
                        <thead className="bg-slate-50 sticky top-0"><tr>{["Tarih", "Hasta", "Sahip", "Açıklama", "Tutar", "Ödenen", "Bakiye"].map(h=><th key={h} className="px-3 py-2 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">{h}</th>)}</tr></thead>
                        <tbody className="divide-y divide-slate-200">
                            {filteredTransactions.length === 0 ? (
                                <tr><td colSpan="7" className="text-center py-6 text-slate-500">Bu zaman aralığında işlem bulunamadı.</td></tr>
                            ) : (
                                filteredTransactions.map(t => {
                                    const debt = (Number(t.visitCost) || 0) - (Number(t.paymentAmount) || 0);
                                    return (
                                        <tr key={t.id} className="hover:bg-slate-50">
                                            <td className="px-3 py-2 whitespace-nowrap">{t.visitDate?.toDate().toLocaleDateString('tr-TR')}</td>
                                            <td className="px-3 py-2 whitespace-nowrap font-medium">{t.patientName}</td>
                                            <td className="px-3 py-2 whitespace-nowrap">{t.ownerName}</td>
                                            <td className="px-3 py-2 whitespace-nowrap truncate max-w-xs" title={t.procedures || t.notes}>{t.procedures || t.notes || (t.isCreditSale ? "İlaç Satış İşlemi" : "Klinik Ziyareti")}</td>
                                            <td className="px-3 py-2 whitespace-nowrap text-right">{formatCurrency(t.visitCost)}</td>
                                            <td className="px-3 py-2 whitespace-nowrap text-right text-green-600">{formatCurrency(t.paymentAmount)}</td>
                                            <td className={`px-3 py-2 whitespace-nowrap text-right font-semibold ${debt > 0 ? 'text-red-600' : ''}`}>{formatCurrency(debt)}</td>
                                        </tr>
                                    )
                                })
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

const ChartModal = ({ isOpen, onClose, chartInfo }) => {
    const [zoom, setZoom] = useState(1);

    if (!isOpen || !chartInfo) return null;

    const { chart } = chartInfo;

    return (
        <Modal isOpen={isOpen} onClose={onClose} title={chartInfo.title} size="5xl" zIndex="z-[120]">
            <div className="relative w-full h-[75vh] bg-white rounded-lg p-4">
                <div className="absolute top-2 right-14 flex space-x-2 z-10">
                    <button onClick={() => setZoom(z => z + 0.1)} className={secondaryButtonClasses + " p-2"}><ZoomIn size={18}/></button>
                    <button onClick={() => setZoom(z => Math.max(0.2, z - 0.1))} className={secondaryButtonClasses + " p-2"}><ZoomOut size={18}/></button>
                </div>
                <div style={{ transform: `scale(${zoom})`, transformOrigin: 'center center', height: '100%', width: '100%', transition: 'transform 0.2s ease-out' }}>
                    <ResponsiveContainer width="100%" height="100%">
                        {chart ? React.cloneElement(chart, { data: chartInfo.data, margin: { top: 20, right: 30, left: 120, bottom: 80 } }) : <p>Grafik yüklenemedi.</p>}
                    </ResponsiveContainer>
                </div>
            </div>
        </Modal>
    );
};

const OwnerListView = ({ patients, onOwnerSelect, onOpenOwnerCreditSales, onOpenOwnerReport, onOpenPaymentCollection, allVisits, allCreditSales, setNotification, openPatientModal }) => {
    const [ownersData, setOwnersData] = useState([]);
    const [isLoadingOwners, setIsLoadingOwners] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');
    
    const formatCurrency = (value) => {
        const number = Number(value) || 0;
        if (isNaN(number)) return '0.00'; 
        return number.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    };

    // 4- Hasta sahipleri listesi: Ekrana oturtmak için max-h-modal-content eklendi.
    useEffect(() => {
        const calculateOwnerData = () => {
            setIsLoadingOwners(true);
            try {
                const ownerMap = {};
                
                // 1. Hasta Sahiplerini ve Temel Bilgileri Topla
                patients.forEach(patient => {
                    const ownerName = patient.ownerName;
                    if (ownerName) {
                        if (!ownerMap[ownerName]) {
                            ownerMap[ownerName] = {
                                name: ownerName,
                                phone: patient.ownerPhone || '-',
                                patientIds: new Set(),
                                totalDebt: 0,
                                publicId: patient.publicId || 'N/A',
                                lastPaymentDate: null, 
                            };
                        }
                        ownerMap[ownerName].patientIds.add(patient.id);
                        if (patient.publicId) {
                            ownerMap[ownerName].publicId = patient.publicId;
                        }
                    }
                });
                
                // 2. Borç ve Son Tahsilat Tarihini Hesapla
                allVisits.forEach(visit => {
                    const patient = patients.find(p => p.id === visit.patientId);
                    if (patient && ownerMap[patient.ownerName]) {
                         // NaN Fix: Number() ile kontrol
                         const debtFromVisit = (Number(visit.visitCost) || 0) - (Number(visit.paymentAmount) || 0);
                         ownerMap[patient.ownerName].totalDebt += debtFromVisit;
                         
                         // Son Tahsilat Tarihini Bul
                         if (visit.isPaymentRecord && Number(visit.paymentAmount) > 0) {
                            const visitDate = visit.visitDate?.toDate();
                            if (visitDate) {
                                const currentLastPayment = ownerMap[patient.ownerName].lastPaymentDate;
                                if (!currentLastPayment || visitDate > currentLastPayment) {
                                    ownerMap[patient.ownerName].lastPaymentDate = visitDate;
                                }
                            }
                         }
                    }
                });
                
                const resolvedOwners = Object.values(ownerMap).map(owner => ({
                    ...owner,
                    patientCount: owner.patientIds.size,
                    totalDebt: Math.round(owner.totalDebt * 100) / 100 // Yuvarlama
                })).sort((a, b) => a.name.localeCompare(b.name, 'tr', { sensitivity: 'base' }));

                setOwnersData(resolvedOwners);

            } catch (error) {
                setNotification(`Sahip verileri çekilemedi: ${error.message}`);
            } finally {
                setIsLoadingOwners(false);
            }
        };

        // allVisits veya patients değiştiğinde tetikle
        calculateOwnerData();
    }, [patients, allVisits, allCreditSales, setNotification]);


    const filteredOwners = useMemo(() => ownersData.filter(owner =>
        owner.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        owner.phone.includes(searchTerm) ||
        owner.publicId.toLowerCase().includes(searchTerm.toLowerCase())
    ), [ownersData, searchTerm]);

    if (isLoadingOwners) {
        return (
            <div className="flex flex-col items-center justify-center p-10">
                <Loader2 className="h-10 w-10 animate-spin text-blue-500" />
                <p className="mt-3 text-slate-600">Sahip bilgileri ve borçları yükleniyor...</p>
            </div>
        );
    }

    return (
        <div className="space-y-3">
             <div className="flex flex-col sm:flex-row justify-between gap-3 mb-3">
                 <input 
                     type="text" 
                     placeholder="Sahip adı, telefon veya ID ile ara..." 
                     value={searchTerm} 
                     onChange={(e) => setSearchTerm(e.target.value)} 
                     className={inputClasses + " text-sm w-full sm:w-auto flex-grow"}
                     autoComplete="off"
                 />
                 <button onClick={() => openPatientModal()} className={`${primaryButtonClasses} text-sm py-2 px-3 w-full sm:w-auto`}>
                     <UserPlus size={16} className="mr-1.5"/> Yeni Hasta Ekle
                 </button>
             </div>
            {filteredOwners.length === 0 && !isLoadingOwners && <p className="text-center text-slate-500 py-3">{searchTerm ? "Arama kriterlerine uygun sahip bulunamadı." : "Kayıtlı hasta sahibi bulunmamaktadır."}</p>}
            
            {/* Ekrana oturma için max-h-modal-content eklendi */}
            <div className="overflow-x-auto overflow-y-auto max-h-modal-content rounded-lg shadow-md"> 
                <table className="min-w-full divide-y divide-slate-200 text-sm">
                    <thead className="bg-slate-50 sticky top-0">
                        <tr>
                            <th className="px-3 py-2 text-left text-xs font-medium text-slate-500 uppercase tracking-wider whitespace-nowrap">Sahip Adı</th>
                            <th className="px-3 py-2 text-left text-xs font-medium text-slate-500 uppercase tracking-wider whitespace-nowrap">Telefon</th>
                            <th className="px-3 py-2 text-center text-xs font-medium text-slate-500 uppercase tracking-wider whitespace-nowrap">Hayvan Sayısı</th>
                            <th className="px-3 py-2 text-right text-xs font-medium text-slate-500 uppercase tracking-wider whitespace-nowrap">Son Tahsilat</th>
                            <th className="px-3 py-2 text-right text-xs font-medium text-slate-500 uppercase tracking-wider whitespace-nowrap">Toplam Borç (TL)</th>
                            <th className="px-3 py-2 text-center text-xs font-medium text-slate-500 uppercase tracking-wider whitespace-nowrap">İşlemler</th>
                        </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-slate-200">
                        {filteredOwners.map(owner => (
                            <tr key={owner.publicId} className="hover:bg-slate-50">
                                <td className="px-3 py-2 whitespace-nowrap font-medium">{owner.name}</td>
                                <td className="px-3 py-2 whitespace-nowrap">{owner.phone}</td>
                                <td className="px-3 py-2 whitespace-nowrap text-center">{owner.patientCount}</td>
                                <td className="px-3 py-2 whitespace-nowrap text-right text-xs text-slate-600">
                                    {owner.lastPaymentDate ? owner.lastPaymentDate.toLocaleDateString('tr-TR') : 'Yok'}
                                </td>
                                <td className={`px-3 py-2 whitespace-nowrap text-right font-semibold ${parseFloat(owner.totalDebt) > 0.01 ? 'text-red-600' : 'text-green-600'}`}>
                                    {formatCurrency(owner.totalDebt)}
                                </td>
                                <td className="px-3 py-2 whitespace-nowrap">
                                    <div className="flex items-center space-x-1 justify-center">
                                        <button 
                                            onClick={() => onOwnerSelect(owner.name)} 
                                            className={`${infoButtonClasses} text-xs py-1 px-2`}
                                        >
                                            <Eye size={14} className="mr-1"/> Hayvanlar
                                        </button>
                                        <button 
                                            onClick={() => onOpenOwnerCreditSales(owner.name)} 
                                            className={`${warningButtonClasses} text-xs py-1 px-2`}
                                        >
                                            <Pill size={14} className="mr-1"/> Satışlar
                                        </button>
                                         <button 
                                            onClick={() => onOpenPaymentCollection(owner.name)} 
                                            className={`${successButtonClasses} bg-teal-600 hover:bg-teal-700 text-xs py-1 px-2`}
                                            title="Borç Tahsilat"
                                        >
                                            <Wallet size={14} className="mr-1"/> Tahsilat
                                        </button>
                                        <button 
                                            onClick={() => onOpenOwnerReport(owner.name)} 
                                            className={`${dangerButtonClasses} bg-purple-600 hover:bg-purple-700 text-xs py-1 px-2`}
                                            title="Finansal Özet Raporu"
                                        >
                                            <FileText size={14} className="mr-1"/> Rapor
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

// 2- (+) butonu eklendi
const OwnerPatientsView = ({ ownerName, patients, onPatientDetailOpen, allVisits, allCreditSales, openNewPatientModal }) => {
    const formatCurrency = (value) => {
        const number = Number(value) || 0;
        if (isNaN(number)) return '0.00'; 
        return number.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    };

    const patientDebts = useMemo(() => {
        const debts = {};
        patients.forEach(patient => {
            const patientVisits = allVisits.filter(v => v.patientId === patient.id);
            const debt = patientVisits.reduce((sum, visit) => {
                return sum + ((Number(visit.visitCost) || 0) - (Number(visit.paymentAmount) || 0));
            }, 0);
            debts[patient.id] = Math.round(debt * 100) / 100;
        });
        return debts;
    }, [patients, allVisits]);

    return (
        <div className="space-y-3">
            <div className="flex justify-between items-center mb-4">
                 <h4 className="text-lg font-semibold text-slate-800">{ownerName} Adlı Sahibin Hayvanları ({patients.length})</h4>
                 <button 
                    onClick={openNewPatientModal} 
                    className={`${primaryButtonClasses} text-sm py-1.5 px-3`}
                    title="Yeni Hasta Ekle"
                 >
                     <PlusCircle size={16} className="mr-1.5"/> Yeni Hasta
                 </button>
            </div>
            {patients.length === 0 && <p className="text-center text-slate-500 py-3">{ownerName} adına kayıtlı hayvan bulunmamaktadır.</p>}
            <div className="overflow-x-auto max-h-96">
                <table className="min-w-full divide-y divide-slate-200 text-sm">
                    <thead className="bg-slate-50 sticky top-0">
                        <tr>
                            <th className="px-3 py-2 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">Hayvan Adı</th>
                            <th className="px-3 py-2 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">Türü</th>
                            <th className="px-3 py-2 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">Cinsi</th>
                            <th className="px-3 py-2 text-right text-xs font-medium text-slate-500 uppercase tracking-wider">Toplam Borç (TL)</th>
                            <th className="px-3 py-2 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">İşlemler</th>
                        </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-slate-200">
                        {patients.map(patient => {
                            const debt = patientDebts[patient.id] || 0;
                            return (
                                <tr key={patient.id} className="hover:bg-slate-50">
                                    <td className="px-3 py-2 whitespace-nowrap font-medium">{patient.name}</td>
                                    <td className="px-3 py-2 whitespace-nowrap">{patient.species}</td>
                                    <td className="px-3 py-2 whitespace-nowrap">{patient.breed}</td>
                                    <td className={`px-3 py-2 whitespace-nowrap text-right font-semibold ${debt > 0.01 ? 'text-red-600' : 'text-green-600'}`}>
                                        {formatCurrency(debt)}
                                    </td>
                                    <td className="px-3 py-2 whitespace-nowrap">
                                        <button 
                                            onClick={() => onPatientDetailOpen(patient)}
                                            className={`${primaryButtonClasses} text-xs py-1 px-2`}
                                        >
                                            <Eye size={14} className="mr-1"/> Detayları Gör
                                        </button>
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

// Hasta Sahibi Finansal Özet Raporu Bileşeni
const OwnerFinancialReport = ({ ownerName, patients, allVisits, creditSales, patientsMap, onOpenCreditSales, onOpenPaymentCollection, allPatients }) => {
    
    const formatCurrency = (value) => {
        const number = Number(value) || 0;
        if (isNaN(number)) return '0.00'; 
        return number.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    };

    // 1. Tüm Finansal Hareketleri Topla (Ziyaretler + Tahsilatlar)
    const ownerPatientIds = useMemo(() => new Set(patients.map(p => p.id)), [patients]);

    const allOwnerTransactions = useMemo(() => {
        // Tüm ziyaret kayıtları (teşhis/tedavi ve finansal hareketler)
        const visitsTransactions = allVisits
            .filter(v => ownerPatientIds.has(v.patientId))
            .map(v => {
                const type = v.isCreditSale && v.isPaymentRecord ? 'TAHSİLAT' : v.isCreditSale ? 'İLAÇ SATIŞ' : v.isPrescriptionOnly ? 'REÇETE (Ücretsiz)' : 'ZİYARET';
                // NaN Fix
                const debt = (Number(v.visitCost) || 0) - (Number(v.paymentAmount) || 0);
                
                let description = v.procedures || v.diagnosis;
                
                if (type === 'İLAÇ SATIŞ' && v.usedStockItems) {
                    description = v.usedStockItems.map(item => `${item.itemName} (x${Number(item.quantityUsed) || 0} ${item.unit || 'Adet'})`).join(', ');
                    description = `Ürünler: ${description}`;
                } else if (type === 'TAHSİLAT') {
                     description = v.notes;
                }

                return {
                    id: v.id,
                    date: v.visitDate?.toDate(),
                    type: type,
                    description: description,
                    patientName: patientsMap.get(v.patientId)?.name || 'Bilinmeyen',
                    debtChange: debt, 
                    totalAmount: Number(v.visitCost) || 0,
                    paidAmount: Number(v.paymentAmount) || 0,
                    isDebt: debt > 0.01,
                    isPayment: debt < -0.01,
                };
            });
        
        return visitsTransactions.sort((a, b) => (b.date || 0) - (a.date || 0)); // Tarihe göre azalan
    }, [allVisits, ownerPatientIds, patientsMap]);
    
    // 2. Finansal Özet ve Rapor Verisi Hesaplama
    const financialSummary = useMemo(() => {
        let totalDebt = 0;
        let totalVisitCost = 0;
        let totalPayment = 0;

        allOwnerTransactions.forEach(t => {
            totalDebt += t.debtChange;
            totalVisitCost += t.totalAmount;
            totalPayment += t.paidAmount;
        });

        // Borç yuvarlaması
        totalDebt = Math.round(totalDebt * 100) / 100;
        
        const ownerCreditSales = creditSales.filter(cs => cs.ownerName === ownerName);

        const generateReportHtml = (isPortalView) => {
            let html = `
                <div style="font-family: Arial, sans-serif; padding: 20px;">
                    <h1 style="color: #4A90E2; border-bottom: 2px solid #ddd; padding-bottom: 10px;">${ownerName} Finansal Özet Raporu</h1>
                    <p style="margin-bottom: 20px;">Rapor Tarihi: ${new Date().toLocaleDateString('tr-TR')}</p>
            `;
            
            if (isPortalView) {
                 const debtClass = totalDebt > 0.01 ? 'color: red;' : 'color: green;';
                 html += `
                    <div style="padding: 15px; border: 1px solid #ffcccc; background-color: #ffeaea; border-radius: 5px; text-align: center;">
                        <h2 style="font-size: 16pt; margin: 0; color: #444;">Toplam Cari Bakiye</h2>
                        <p style="font-size: 24pt; font-weight: bold; margin: 10px 0; ${debtClass}">
                            ${formatCurrency(totalDebt)} TL
                        </p>
                        ${totalDebt > 0.01 ? '<p style="color: red; font-weight: bold;">Ödenmemiş borcunuz bulunmaktadır. Lütfen kliniğinizle iletişime geçin.</p>' : '<p style="color: green; font-weight: bold;">Ödenmemiş borcunuz bulunmamaktadır.</p>'}
                    </div>
                `;
            } else {
                 // Klinik Görünümü (Tüm detaylar)
                 html += `
                    <h2 style="color: #333; margin-top: 20px;">Genel Özet</h2>
                    <table class="summary-table" style="width: 100%; max-width: 400px; border-collapse: collapse; margin-bottom: 20px; font-size: 10pt;">
                        <tr><td style="border: 1px solid #ddd; padding: 8px;">Toplam Ziyaret/Satış Tutarı</td><td style="border: 1px solid #ddd; padding: 8px; text-align: right;">${formatCurrency(totalVisitCost)} TL</td></tr>
                        <tr><td style="border: 1px solid #ddd; padding: 8px;">Toplam Tahsilat</td><td style="border: 1px solid #ddd; padding: 8px; text-align: right; color: green; font-weight: bold;">${formatCurrency(totalPayment)} TL</td></tr>
                        <tr><td style="border: 1px solid #ddd; padding: 8px;"><strong>Cari Hesap Bakiyesi</strong></td><td style="border: 1px solid #ddd; padding: 8px; text-align: right; font-size: 11pt; font-weight: bold; ${totalDebt > 0.01 ? 'color: red;' : 'color: green;'}">${formatCurrency(totalDebt)} TL</td></tr>
                    </table>

                    <h2 style="color: #333; margin-top: 30px;">Tüm Finansal Hareketler (Ziyaretler, İlaç Satışları, Tahsilatlar)</h2>
                    <table style="width: 100%; border-collapse: collapse; font-size: 9pt;">
                        <thead>
                            <tr style="background-color: #f2f2f2;">
                                <th style="border: 1px solid #ddd; padding: 8px;">Tarih</th>
                                <th style="border: 1px solid #ddd; padding: 8px;">Hasta</th>
                                <th style="border: 1px solid #ddd; padding: 8px;">İşlem Türü</th>
                                <th style="border: 1px solid #ddd; padding: 8px;">Açıklama</th>
                                <th style="border: 1px solid #ddd; padding: 8px; text-align: right;">Borç (+) / Ödeme (-)</th>
                                <th style="border: 1px solid #ddd; padding: 8px; text-align: right;">Cari Bakiye</th>
                            </tr>
                        </thead>
                        <tbody>
                `;
                
                let cumulativeDebt = 0;
                allOwnerTransactions.sort((a, b) => (a.date || 0) - (b.date || 0)).forEach(t => { // Tarihe göre artan
                    cumulativeDebt += t.debtChange;
                    const debtClass = t.debtChange > 0.01 ? 'color: red;' : t.debtChange < -0.01 ? 'color: green;' : '';
                    
                    html += `
                        <tr>
                            <td style="border: 1px solid #ddd; padding: 8px;">${t.date ? t.date.toLocaleDateString('tr-TR') : '-'}</td>
                            <td style="border: 1px solid #ddd; padding: 8px;">${t.patientName}</td>
                            <td style="border: 1px solid #ddd; padding: 8px;">${t.type}</td>
                            <td style="border: 1px solid #ddd; padding: 8px;">${t.description}</td>
                            <td style="border: 1px solid #ddd; padding: 8px; text-align: right; font-weight: bold; ${debtClass}">${formatCurrency(t.debtChange)} TL</td>
                            <td style="border: 1px solid #ddd; padding: 8px; text-align: right; font-weight: bold;">${formatCurrency(cumulativeDebt)} TL</td>
                        </tr>
                    `;
                });
                 
                 html += `
                        </tbody>
                    </table>
                 `;
            }

            html += `</div>`;
            return html;
        };


        return {
            totalDebt: totalDebt,
            reportHtml: generateReportHtml(false),
            portalReportHtml: generateReportHtml(true),
            ownerCreditSales
        };
    }, [allOwnerTransactions, ownerName, creditSales]);

    // Raporu DOCX olarak indirme
    const handleDownloadReport = () => {
        const docHtml = financialSummary.reportHtml;
        const filename = `${ownerName}_Finansal_Ozet_${new Date().toISOString().split('T')[0]}.doc`;
        
        const header = `<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'><head><meta charset='utf-8'><title>Finansal Rapor</title></head><body>`;
        const footer = "</body></html>";
        const sourceHTML = header + docHtml + footer;
        const source = 'data:application/vnd.ms-word;charset=utf-8,' + encodeURIComponent(sourceHTML);
        const fileDownload = document.createElement("a");
        document.body.appendChild(fileDownload);
        fileDownload.href = source;
        fileDownload.download = filename;
        fileDownload.click();
        document.body.removeChild(fileDownload);
    };

    return (
        <div className="space-y-6">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 text-center p-4 bg-white rounded-lg shadow-md">
                <div className="p-3 bg-blue-50 rounded-lg"><p className="text-sm font-semibold text-blue-800">Toplam Ziyaret/Satış</p><p className="text-xl font-bold text-blue-900">{formatCurrency(financialSummary.totalVisitCost)} TL</p></div>
                <div className="p-3 bg-green-50 rounded-lg"><p className="text-sm font-semibold text-green-800">Toplam Tahsilat</p><p className="text-xl font-bold text-green-900">{formatCurrency(financialSummary.totalPayment)} TL</p></div>
                <div className="p-3 rounded-lg" style={{backgroundColor: financialSummary.totalDebt > 0.01 ? '#fee2e2' : '#d1fae5'}}><p className={`text-sm font-semibold ${financialSummary.totalDebt > 0.01 ? 'text-red-800' : 'text-green-800'}`}>Cari Hesap Bakiyesi</p><p className={`text-2xl font-bold ${financialSummary.totalDebt > 0.01 ? 'text-red-900' : 'text-green-900'}`}>{formatCurrency(financialSummary.totalDebt)} TL</p></div>
            </div>

            <div className="flex justify-between items-center pb-2 border-b">
                 <h3 className="text-lg font-semibold text-slate-700">Detaylı Finansal Hareketler ({allOwnerTransactions.length})</h3>
                 <div className="flex space-x-2">
                    {financialSummary.totalDebt > 0.01 && (
                         <button onClick={() => onOpenPaymentCollection(ownerName)} className={`${successButtonClasses} bg-teal-600 hover:bg-teal-700 text-sm py-1.5 px-3`}>
                             <Wallet size={16} className="mr-1.5"/> Borç Tahsilat
                         </button>
                    )}
                    <button onClick={handleDownloadReport} className={`${infoButtonClasses} text-sm py-1.5 px-3`}>
                        <Download size={16} className="mr-1.5"/> Raporu İndir (.doc)
                    </button>
                    <button onClick={() => onOpenCreditSales(ownerName)} className={`${warningButtonClasses} text-sm py-1.5 px-3`}>
                        <Pill size={16} className="mr-1.5"/> İlaç Satış Detayları
                    </button>
                 </div>
            </div>
            
            <div className="overflow-y-auto max-h-[50vh] overflow-x-auto">
                <table className="min-w-full divide-y divide-slate-200 text-sm">
                    <thead className="bg-slate-50 sticky top-0">
                        <tr>
                            <th className="px-3 py-2 text-left text-xs font-medium text-slate-500 uppercase tracking-wider whitespace-nowrap">Tarih</th>
                            <th className="px-3 py-2 text-left text-xs font-medium text-slate-500 uppercase tracking-wider whitespace-nowrap">Hasta</th>
                            <th className="px-3 py-2 text-left text-xs font-medium text-slate-500 uppercase tracking-wider min-w-[200px]">Açıklama</th>
                            <th className="px-3 py-2 text-right text-xs font-medium text-slate-500 uppercase tracking-wider whitespace-nowrap">Borç (+) / Ödeme (-)</th>
                        </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-slate-200">
                        {allOwnerTransactions.length === 0 ? (
                            <tr><td colSpan="5" className="text-center py-4 text-slate-500">Bu sahibi için finansal hareket bulunamadı.</td></tr>
                        ) : (
                            allOwnerTransactions.map(t => (
                                <tr key={t.id} className={`hover:bg-slate-50 ${t.isPayment ? 'bg-green-50' : t.isDebt ? 'bg-red-50' : ''}`}>
                                    <td className="px-3 py-2 whitespace-nowrap">{t.date?.toLocaleDateString('tr-TR')}</td>
                                    <td className="px-3 py-2 whitespace-nowrap font-medium">{t.patientName}</td>
                                    <td className="px-3 py-2 max-w-sm truncate" title={t.description}>{t.description}</td>
                                    <td className={`px-3 py-2 whitespace-nowrap text-right font-semibold ${t.debtChange > 0.01 ? 'text-red-600' : t.debtChange < -0.01 ? 'text-green-600' : 'text-slate-600'}`}>
                                        {formatCurrency(t.debtChange)} TL
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>

             <div className="mt-4 p-4 bg-slate-50 rounded-lg text-sm">
                <p><strong>Bilgilendirme:</strong> "Borç (+) / Ödeme (-)" sütunu, bakiyedeki net değişimi gösterir. Pozitif değerler borcun arttığını (yeni masraf), negatif değerler ise ödeme yapıldığını (borcun azaldığını) gösterir. Cari bakiye bu hareketlerin toplamıdır.</p>
            </div>
        </div>
    );
};


// Sürü Yönetimi Bileşeni
const HerdManagementView = ({ patients, onAddReminder, onOpenPatientDetail, onSaveEvent, isSaving, setNotification, userId, db, appId, treatmentSchedules }) => {
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedPatient, setSelectedPatient] = useState(null); 
    const [herdEvents, setHerdEvents] = useState([]);
    const [isEventsLoading, setIsEventsLoading] = useState(false);
    
    // Takvim verisi için state 
    const [calendarEvents, setCalendarEvents] = useState({});
    const [currentCalendarDate, setCurrentCalendarDate] = useState(new Date());

    const initialEventForm = useMemo(() => ({
        eventType: 'Suni Tohumlama',
        eventDate: new Date().toISOString().split('T')[0],
        notes: '',
        followUps: [], 
    }), []);
    
    const [eventForm, setEventForm] = useState(initialEventForm);
    
    // Suni Tohumlama için otomatik takip önerilerini hesaplar
    const calculateDefaultFollowUps = useCallback((baseDateStr, eventType) => {
        const baseDate = new Date(baseDateStr);
        const schedule = treatmentSchedules["Sürü"].find(t => t.name === eventType);
        
        if (!schedule || !schedule.defaultFollowUpDays) return [];

        return schedule.defaultFollowUpDays.map((days, index) => {
             const followUpDate = new Date(baseDate);
             followUpDate.setDate(baseDate.getDate() + days);
             return {
                 name: schedule.defaultFollowUpNames[index],
                 days: days,
                 date: followUpDate.toISOString().split('T')[0],
                 checked: true, // Varsayılan olarak seçili
             };
        });
    }, [treatmentSchedules]);

    useEffect(() => {
        // Olay türü değiştiğinde veya başlangıçta varsayılan takipleri ayarla
        if (!isSaving) {
            setEventForm(prev => ({
                ...prev,
                followUps: calculateDefaultFollowUps(prev.eventDate, prev.eventType)
            }));
        }
    }, [eventForm.eventType, eventForm.eventDate, calculateDefaultFollowUps, isSaving]);


    // Sadece Sığır türündeki hastalar
    const herdPatients = useMemo(() => {
        return patients.filter(p => p.species === 'Sığır' && p.name.toLowerCase().includes(searchTerm.toLowerCase()));
    }, [patients, searchTerm]);

    const handlePatientSelection = (patient) => {
        if (selectedPatient && selectedPatient.id === patient.id) {
            setSelectedPatient(null);
            setHerdEvents([]);
            setCalendarEvents({});
            setEventForm(initialEventForm);
        } else {
            setSelectedPatient(patient);
            setHerdEvents([]); 
            setCalendarEvents({});
            setEventForm(initialEventForm);
        }
    };
    
    const handleEventFormChange = (e) => {
        const { name, value } = e.target;
        setEventForm(prev => ({ ...prev, [name]: value }));
    };
    
    const handleFollowUpChange = (index, isChecked) => {
         setEventForm(prev => ({
             ...prev,
             followUps: prev.followUps.map((fu, i) => i === index ? { ...fu, checked: isChecked } : fu)
         }));
    };
    
    const handleFollowUpDaysChange = (index, newDays) => {
         setEventForm(prev => ({
             ...prev,
             followUps: prev.followUps.map((fu, i) => {
                 if (i === index) {
                      const baseDate = new Date(prev.eventDate);
                      const followUpDate = new Date(baseDate);
                      followUpDate.setDate(baseDate.getDate() + Number(newDays));
                     return { ...fu, days: Number(newDays), date: followUpDate.toISOString().split('T')[0] };
                 }
                 return fu;
             })
         }));
    };


    const handleEventSubmit = (e) => {
        e.preventDefault();
        if (!selectedPatient) {
            setNotification("Lütfen önce bir hayvan seçin.");
            return;
        }
        if (!eventForm.eventType || !eventForm.eventDate) {
            setNotification("Lütfen olay türünü ve tarihi girin.");
            return;
        }
        
        const activeFollowUps = eventForm.followUps.filter(fu => fu.checked && Number(fu.days) > 0);
        
        onSaveEvent({
            patientId: selectedPatient.id,
            eventType: eventForm.eventType,
            eventDate: eventForm.eventDate,
            notes: eventForm.notes,
            followUps: activeFollowUps
        });
        // Formu temizle ve yeni olayın takibini otomatik ayarla
        const newInitialEventForm = {
            ...initialEventForm,
            eventDate: new Date().toISOString().split('T')[0],
            followUps: calculateDefaultFollowUps(new Date().toISOString().split('T')[0], initialEventForm.eventType)
        };
        setEventForm(newInitialEventForm);

    };

    // Olayları çekme (Her hasta değiştiğinde çalışır)
    useEffect(() => {
        if (!selectedPatient || !userId || !db) {
            setHerdEvents([]);
            return;
        }
        setIsEventsLoading(true);
        
        const eventsColPath = `artifacts/${appId}/users/${userId}/patients/${selectedPatient.id}/herdEvents`;
        const q = query(collection(db, eventsColPath), orderBy("eventDate", "desc"));
        
        const unsubscribe = onSnapshot(q, (snapshot) => {
            const eventsData = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
            setHerdEvents(eventsData);
            setIsEventsLoading(false);
        }, (error) => {
            setNotification("Sürü etkinlikleri yüklenemedi.");
            setIsEventsLoading(false);
        });

        return () => unsubscribe();
    }, [selectedPatient, userId, db, appId, setNotification]);
    
    // Hatırlatmaları takvime yerleştirme 
    const { reminders } = window.AppProps || {}; // App'ten gelen tüm hatırlatmaları varsay

    useEffect(() => {
        if (!selectedPatient) {
            setCalendarEvents({});
            return;
        }
        
        const events = {};
        
        // 1. Kayıtlı Sürü Olayları
        herdEvents.forEach(e => {
            const dateStr = e.eventDate.toDate().toISOString().split('T')[0];
            if (!events[dateStr]) events[dateStr] = [];
            events[dateStr].push({ name: `[Olay] ${e.eventType}`, type: 'event' });
        });
        
        // 2. Hasta için planlanmış ilgili Hatırlatmalar (Sürü Takibi tipinde olanlar)
        const selectedPatientReminders = reminders?.filter(r => r.patientId === selectedPatient.id) || [];

        selectedPatientReminders.filter(r => r.reminderType === 'Sürü Takibi' && r.status === 'pending').forEach(r => {
             const dateStr = r.reminderDate.toDate().toISOString().split('T')[0];
             if (!events[dateStr]) events[dateStr] = [];
             events[dateStr].push({ name: `[Takip] ${r.description}`, type: 'reminder' });
        });
        
        setCalendarEvents(events);
    }, [herdEvents, selectedPatient, reminders]);


    const getNextFollowUp = (eventsList) => {
        const lastStEvent = eventsList.find(e => e.eventType === 'Suni Tohumlama');
        if (!lastStEvent) return null;
        
        const baseDate = lastStEvent.eventDate.toDate();
        const schedule = treatmentSchedules["Sürü"].find(t => t.id === 'suni_tohumlama');

        if (!schedule) return null;
        
        const today = new Date(); today.setHours(0,0,0,0);
        
        let nextEvent = null;

        schedule.defaultFollowUpDays.forEach((days, index) => {
             const followUpDate = new Date(baseDate);
             followUpDate.setDate(baseDate.getDate() + days);
             followUpDate.setHours(0,0,0,0);
             
             if (followUpDate > today) {
                  if (!nextEvent || followUpDate < nextEvent.date) {
                      nextEvent = { name: schedule.defaultFollowUpNames[index], date: followUpDate };
                  }
             }
        });
        
        return nextEvent;
    };
    
    // Sürü Yönetimi Takvim Bileşeni
    const HerdCalendar = ({ events, currentDate, setCurrentDate }) => {
        const today = new Date(); today.setHours(0,0,0,0);
        const monthNames = ["Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran", "Temmuz", "Ağustos", "Eylül", "Ekim", "Kasım", "Aralık"];
        const dayNames = ["Pzt", "Sal", "Çrş", "Prş", "Cm", "Cts", "Paz"];

        const currentMonth = currentDate.getMonth();
        const currentYear = currentDate.getFullYear();

        const daysInMonth = new Date(currentYear, currentMonth + 1, 0).getDate();
        const firstDayOfMonth = new Date(currentYear, currentMonth, 1).getDay();
        const startingDay = (firstDayOfMonth === 0) ? 6 : firstDayOfMonth - 1;

        const handlePrevMonth = () => setCurrentDate(new Date(currentYear, currentMonth - 1, 1));
        const handleNextMonth = () => setCurrentDate(new Date(currentYear, currentMonth + 1, 1));
        
        const renderCalendarDays = () => {
            const blanks = Array(startingDay).fill(null);
            const daysArray = Array.from({ length: daysInMonth }, (_, i) => i + 1);
            
            return [...blanks, ...daysArray].map((day, index) => {
                if (!day) return <div key={`b-${index}`} className="border border-slate-200 p-1 h-16 sm:h-20"></div>;
                
                const date = new Date(currentYear, currentMonth, day); date.setHours(0,0,0,0);
                const dateStr = date.toISOString().split('T')[0];
                const isToday = date.getTime() === today.getTime();
                
                const dayEvents = events[dateStr] || [];

                return (
                    <div key={day} className={`border border-slate-200 p-1 h-16 overflow-y-hidden text-xs ${isToday ? 'bg-blue-100 font-semibold border-blue-500' : 'bg-white'} hover:bg-sky-50`}>
                        <span className={`text-[10px] sm:text-xs ${isToday ? 'text-blue-700' : 'text-slate-700'}`}>{day}</span>
                        {dayEvents.slice(0,2).map((event, i) => (
                            <div key={i} className={`mt-0.5 text-[8px] sm:text-[10px] p-0.5 rounded-sm truncate ${event.type === 'event' ? 'bg-teal-400 text-white' : 'bg-red-400 text-white'}`} title={event.name}>
                                {event.type === 'event' ? <Activity size={8} className="inline"/> : <Bell size={8} className="inline"/>} {event.name.split(' ')[0]}
                            </div>
                        ))}
                        {dayEvents.length > 2 && <div className="text-[8px] text-slate-500 text-center">+{dayEvents.length - 2}</div>}
                    </div>
                );
            });
        };
        
        return (
            <section className="p-3 bg-white/80 rounded-xl shadow-lg border">
                <div className="flex justify-between items-center mb-3">
                    <button type="button" onClick={handlePrevMonth} className={`${secondaryButtonClasses} p-1.5 text-xs`}><ChevronLeft size={18}/></button>
                    <h3 className="text-md sm:text-lg font-semibold text-slate-700">{monthNames[currentMonth]} {currentYear}</h3>
                    <button type="button" onClick={handleNextMonth} className={`${secondaryButtonClasses} p-1.5 text-xs`}><ChevronRight size={18}/></button>
                </div>
                <div className="grid grid-cols-7 gap-px bg-slate-200 border border-slate-200 text-[10px] sm:text-xs">
                    {dayNames.map(d => <div key={d} className="text-center py-1.5 bg-slate-100 font-medium text-slate-600">{d}</div>)}
                    {renderCalendarDays()}
                </div>
            </section>
        );
    };

    
    // Hasta Seçim Listesi (Sol Taraf)
    const renderPatientList = () => (
        <div className="bg-white p-4 rounded-xl shadow-lg h-full flex flex-col">
            <h4 className="font-bold text-lg text-slate-800 mb-3 flex items-center"><PawPrint size={20} className="mr-2"/> Sürü Hayvanları ({herdPatients.length})</h4>
            <input 
                type="text" 
                placeholder="Hayvan ara..." 
                value={searchTerm} 
                onChange={(e) => setSearchTerm(e.target.value)} 
                className={inputClasses + " mb-3"} 
            />
            <div className="overflow-y-auto space-y-2 flex-grow">
                {herdPatients.map(p => (
                    <div 
                        key={p.id} 
                        onClick={() => handlePatientSelection(p)}
                        className={`p-3 rounded-lg cursor-pointer transition-colors border ${selectedPatient?.id === p.id ? 'bg-blue-100 border-blue-400' : 'bg-slate-50 hover:bg-slate-100'}`}
                    >
                        <p className="font-semibold text-slate-800">{p.name}</p>
                        <p className="text-xs text-slate-600">Sahip: {p.ownerName}</p>
                    </div>
                ))}
                {herdPatients.length === 0 && <p className="text-sm text-slate-500 text-center py-4">Kayıtlı Sığır türünde hasta yok.</p>}
            </div>
        </div>
    );
    
    // Olay Yönetimi ve Takip (Sağ Taraf)
    const renderEventManagement = () => {
        if (!selectedPatient) {
            return (
                <div className="bg-white p-6 rounded-xl shadow-lg h-full flex items-center justify-center">
                    <p className="text-lg text-slate-600">Lütfen soldan bir sürü hayvanı seçin.</p>
                </div>
            );
        }
        
        const lastInsemination = herdEvents.find(e => e.eventType === 'Suni Tohumlama');
        const nextFollowUp = getNextFollowUp(herdEvents);
        
        return (
            <div className="bg-white p-4 rounded-xl shadow-lg h-full overflow-y-auto space-y-4">
                <div className="flex justify-between items-center">
                    <h4 className="font-bold text-xl text-blue-700 border-b pb-2 mb-3">
                        <Target size={20} className="inline mr-2"/> {selectedPatient.name} - Sürü Takip
                    </h4>
                    <button 
                        onClick={() => onOpenPatientDetail(selectedPatient)}
                        className={`${secondaryButtonClasses} text-xs py-1 px-2`}
                    >
                        <Eye size={14} className="mr-1"/> Detaylara Git
                    </button>
                </div>
                
                {/* Son Olay Özeti */}
                <div className="p-3 bg-indigo-50 border-l-4 border-indigo-400 rounded-md">
                    <p className="text-sm font-semibold text-indigo-800 flex items-center"><Activity size={16} className="mr-2"/> Son Kayıtlı Olay: {herdEvents[0]?.eventType || 'Yok'}</p>
                    {lastInsemination && (
                        <div className="mt-2 text-sm">
                            <p className="font-medium text-slate-700">Son Suni Tohumlama: {lastInsemination.eventDate.toDate().toLocaleDateString('tr-TR')}</p>
                            {nextFollowUp && (
                                <p className="text-red-600 font-bold mt-1">
                                    <CalendarClock size={16} className="inline mr-1"/> SONRAKİ TAKİP: {nextFollowUp.name} ({nextFollowUp.date.toLocaleDateString('tr-TR')})
                                </p>
                            )}
                        </div>
                    )}
                </div>

                {/* Yeni Olay Ekleme Formu */}
                <form onSubmit={handleEventSubmit} className="space-y-3 p-3 border rounded-lg bg-slate-50">
                    <h5 className="font-semibold text-md text-slate-700">Yeni Olay Kaydet</h5>
                    <div className="grid grid-cols-2 gap-3">
                        <div>
                            <label htmlFor="eventType" className={labelClasses}>Olay Türü*</label>
                            <select name="eventType" id="eventType" value={eventForm.eventType} onChange={handleEventFormChange} className={inputClasses} required>
                                {(treatmentSchedules["Sürü"] || []).map(t => (
                                    <option key={t.id} value={t.name}>{t.name}</option>
                                ))}
                            </select>
                        </div>
                        <div>
                            <label htmlFor="eventDate" className={labelClasses}>Tarih*</label>
                            <input type="date" name="eventDate" id="eventDate" value={eventForm.eventDate} onChange={handleEventFormChange} className={inputClasses} required />
                        </div>
                    </div>
                    
                    {/* Özel Takip Ayarları */}
                    {eventForm.followUps.length > 0 && (
                        <div className="p-3 border rounded-md bg-blue-100 space-y-2">
                             <h6 className="font-semibold text-blue-800 text-sm">Otomatik Takip Ayarları (Gün)</h6>
                             {eventForm.followUps.map((fu, index) => (
                                 <div key={index} className="flex items-center gap-3">
                                     <input 
                                         type="checkbox" 
                                         checked={fu.checked} 
                                         onChange={(e) => handleFollowUpChange(index, e.target.checked)}
                                         className="h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                                     />
                                     <input 
                                         type="number" 
                                         value={fu.days} 
                                         onChange={(e) => handleFollowUpDaysChange(index, e.target.value)}
                                         className={inputClasses + " w-16 text-sm py-1"}
                                         min="1"
                                         disabled={!fu.checked}
                                     />
                                     <label className="text-sm text-slate-700 flex-grow">{fu.name} <span className="text-xs text-slate-500">({fu.date})</span></label>
                                 </div>
                             ))}
                        </div>
                    )}
                    
                    <div>
                        <label htmlFor="notes" className={labelClasses}>Notlar</label>
                        <textarea name="notes" id="notes" value={eventForm.notes} onChange={handleEventFormChange} className={textareaClasses} rows="2" placeholder="Olayla ilgili detaylar (Örn: Tohumlanan boğa, zor doğum vb.)"></textarea>
                    </div>
                    
                    <button type="submit" className={primaryButtonClasses} disabled={isSaving}>
                        {isSaving ? <Loader2 size={18} className="animate-spin mr-1.5"/> : <Save size={18} className="mr-1.5"/>}
                        Olayı Kaydet
                    </button>
                    {eventForm.followUps.filter(fu => fu.checked).length > 0 && (
                        <p className="text-xs text-blue-600 mt-2">Seçili takip günleri için otomatik hatırlatmalar oluşturulacaktır.</p>
                    )}
                </form>
                
                {/* Olay Takvimi */}
                <h5 className="font-semibold text-md text-slate-700 pt-3 border-t">Takip Takvimi</h5>
                <HerdCalendar events={calendarEvents} currentDate={currentCalendarDate} setCurrentDate={setCurrentCalendarDate} />


                {/* Geçmiş Olay Listesi */}
                <h5 className="font-semibold text-md text-slate-700 pt-3 border-t">Geçmiş Olaylar</h5>
                {isEventsLoading ? (
                    <div className="flex justify-center p-4"><Loader2 className="animate-spin"/></div>
                ) : herdEvents.length > 0 ? (
                    <div className="space-y-2 max-h-48 overflow-y-auto">
                        {herdEvents.map(e => (
                            <div key={e.id} className={`p-3 rounded-md border text-sm ${e.eventType.includes('Tohumlama') ? 'bg-teal-50 border-teal-300' : 'bg-slate-50'}`}>
                                <p className="font-semibold text-slate-800">{e.eventType} - {e.eventDate.toDate().toLocaleDateString('tr-TR')}</p>
                                {e.notes && <p className="text-xs text-slate-600">Not: {e.notes}</p>}
                            </div>
                        ))}
                    </div>
                ) : (
                    <p className="text-sm text-slate-500">Bu hayvan için kayıtlı sürü olayı bulunmamaktadır.</p>
                )}
            </div>
        );
    };

    return (
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 h-[70vh]">
            <div className="md:col-span-1">{renderPatientList()}</div>
            <div className="md:col-span-2">{renderEventManagement()}</div>
        </div>
    );
};


// Tahsilat Alanı
const PaymentCollectionModal = ({ ownerName, allVisits, allCreditSales, patients, onProcessPayment, isProcessing, setNotification }) => {
    
    const formatCurrency = (value) => {
        const number = Number(value) || 0;
        if (isNaN(number)) return '0.00'; 
        return number.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    };

    // 1. Sahibe ait tüm finansal hareketleri topla (Ziyaret borçları + Veresiye borçları)
    const owner = useMemo(() => {
        const ownerPatients = patients.filter(p => p.ownerName === ownerName);
        const ownerIds = new Set(ownerPatients.map(p => p.id));
        const ownerPublicId = ownerPatients[0]?.ownerId;

        // Hesaplama 1: Ziyaretlerden gelen borç
        const visitDebt = allVisits.filter(v => ownerIds.has(v.patientId)).reduce((sum, v) => {
            // Borç/Alacak = Tutar - Ödenen. Negatif bakiye ödeme demektir.
            const debt = (Number(v.visitCost) || 0) - (Number(v.paymentAmount) || 0);
            return sum + debt;
        }, 0);
        
        // Hesaplama 2: Kalan Veresiye bakiyesi (Detaylı liste)
        const creditSaleDebtDetails = allCreditSales
            .filter(cs => cs.ownerName === ownerName && cs.status !== 'paid')
            .map(cs => {
                const remaining = (Number(cs.totalAmount) || 0) - (Number(cs.paidAmount) || 0);
                const itemsDescription = cs.items.map(i => `${i.itemName} (x${Number(i.quantity) || 0} ${i.unit})`).join(', ');
                return {
                    id: cs.id,
                    saleDate: cs.saleDate?.toDate(),
                    totalAmount: cs.totalAmount,
                    paidAmount: cs.paidAmount,
                    remainingDebt: remaining,
                    description: itemsDescription,
                    patientName: cs.patientName,
                    patientId: cs.patientId
                };
            }).sort((a,b) => (a.saleDate || 0) - (b.saleDate || 0));

        // Genel olarak toplam borç (Tek Borç Hesabı prensibi)
        const totalDebt = Math.round(visitDebt * 100) / 100;

        return {
            name: ownerName,
            publicId: ownerPublicId,
            totalDebt,
            creditSaleDebtDetails,
        };
    }, [ownerName, patients, allVisits, allCreditSales]);
    
    // Tahsilat Form State'leri
    const [amountToCollect, setAmountToCollect] = useState(0);
    const [paymentMethod, setPaymentMethod] = useState('Nakit');

    useEffect(() => {
        // Modal açıldığında tüm borcu tahsilat alanına otomatik doldur
        setAmountToCollect(Math.max(0, owner.totalDebt));
    }, [owner.totalDebt]);

    const handlePaymentSubmit = (e) => {
        e.preventDefault();
        const amount = parseFloat(amountToCollect) || 0;
        
        if (amount <= 0) {
            setNotification("Tahsil edilecek tutar sıfırdan büyük olmalıdır.");
            return;
        }
        if (amount > owner.totalDebt + 0.01) { // 1 kuruşluk farka izin ver
             setNotification(`Tahsilat tutarı (${formatCurrency(amount)} TL) toplam borçtan (${formatCurrency(owner.totalDebt)} TL) fazla olamaz.`);
            return;
        }

        // Tahsilat işlemi ownerId üzerinden toplu olarak gerçekleşir.
        onProcessPayment(owner.publicId, amount, paymentMethod);
    };


    return (
        <div className="space-y-4">
            <div className="p-4 rounded-lg shadow-md" style={{backgroundColor: owner.totalDebt > 0.01 ? '#fef3f7' : '#f0fff4'}}>
                <h4 className="text-md font-semibold text-slate-700 mb-2">Hasta Sahibi: <span className="font-bold text-blue-700">{ownerName}</span></h4>
                <div className="text-center p-3 rounded-md" style={{backgroundColor: owner.totalDebt > 0.01 ? '#fee2e2' : '#d1fae5'}}>
                    <p className={`text-xl font-bold ${owner.totalDebt > 0.01 ? 'text-red-900' : 'text-green-900'}`}>
                        Toplam Kalan Borç: {formatCurrency(owner.totalDebt)} TL
                    </p>
                </div>
                {owner.totalDebt <= 0.01 && <p className="text-center text-sm text-green-700 mt-2">Bu sahibi için ödenmemiş borç bulunmamaktadır.</p>}
            </div>

            {owner.totalDebt > 0.01 && (
                <form onSubmit={handlePaymentSubmit} className="space-y-4 p-4 border rounded-lg bg-white shadow-inner">
                    <h5 className="font-bold text-lg text-teal-700 flex items-center"><HandCoins size={18} className="mr-2"/> Tahsilat İşlemi</h5>
                    
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div>
                            <label htmlFor="amountToCollect" className={labelClasses}>Tahsil Edilecek Tutar (TL)*</label>
                            <input
                                type="number"
                                id="amountToCollect"
                                value={amountToCollect}
                                onChange={(e) => setAmountToCollect(e.target.value)}
                                className={inputClasses + " text-lg font-bold"}
                                step="0.01"
                                min="0.01"
                                max={Math.ceil(owner.totalDebt * 100) / 100} // Maksimum borcu yuvarlayarak aşmasını engelle
                                required
                            />
                        </div>
                        <div>
                            <label htmlFor="paymentMethod" className={labelClasses}>Ödeme Yöntemi*</label>
                            <select
                                id="paymentMethod"
                                value={paymentMethod}
                                onChange={(e) => setPaymentMethod(e.target.value)}
                                className={inputClasses}
                                required
                            >
                                <option value="Nakit">Nakit</option>
                                <option value="Kart">Kredi/Banka Kartı</option>
                                <option value="Havale/EFT">Havale/EFT</option>
                                <option value="Diğer">Diğer</option>
                            </select>
                        </div>
                    </div>

                    <button type="submit" className={successButtonClasses + " w-full py-3"} disabled={isProcessing || amountToCollect <= 0 || amountToCollect > owner.totalDebt + 0.01}>
                        {isProcessing ? <Loader2 className="animate-spin h-5 w-5 mr-2"/> : <CheckCircle size={20} className="mr-2"/>}
                        {isProcessing ? "Tahsilat Yapılıyor..." : `${formatCurrency(amountToCollect)} TL Tahsil Et`}
                    </button>
                    
                    {amountToCollect > owner.totalDebt + 0.01 && (
                         <p className="text-red-500 text-sm text-center">Tahsilat tutarı borçtan fazla olamaz.</p>
                    )}
                </form>
            )}

            <div className="border-t pt-4">
                <h5 className="font-bold text-lg text-slate-700 mb-3">Ödenmemiş İlaç Satış Detayları ({owner.creditSaleDebtDetails.length})</h5>
                <p className="text-xs text-slate-500 mb-2">Bu borçlar, tahsilat yapıldığında otomatik olarak en eski kayıttan başlayarak kapatılacaktır.</p>
                {owner.creditSaleDebtDetails.length > 0 ? (
                    <div className="overflow-y-auto max-h-56 space-y-3">
                        {owner.creditSaleDebtDetails.map(cs => (
                            <div key={cs.id} className="p-3 border rounded-md bg-red-50 border-red-200 text-sm">
                                <p className="font-semibold text-red-800 flex justify-between items-center">
                                    <span>{cs.saleDate?.toLocaleDateString('tr-TR')} - {cs.patientName}</span>
                                    <span className="text-lg font-bold">{formatCurrency(cs.remainingDebt)} TL</span>
                                </p>
                                <p className="text-xs text-slate-600 mt-1 truncate" title={cs.description}>
                                    Ürünler: {cs.description}
                                </p>
                            </div>
                        ))}
                    </div>
                ) : (
                    <p className="text-sm text-slate-500">Kayıtlı ödenmemiş ilaç satışı bulunmamaktadır (Ancak genel ziyaret borcu olabilir).</p>
                )}
            </div>
        </div>
    );
};

const ReportSelectionModal = ({ isOpen, onClose, patients, allVisits, inventoryItems, setNotification }) => {
    const [reportType, setReportType] = useState('');
    const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
    const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1);
    const [isGeneratingReport, setIsGeneratingReport] = useState(false);
    
    const formatCurrency = (value) => {
        const number = Number(value) || 0;
        if (isNaN(number)) return '0.00'; 
        return number.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    };


    const years = Array.from({ length: 10 }, (_, i) => new Date().getFullYear() - i);
    const months = [ { value: 1, label: 'Ocak' }, { value: 2, label: 'Şubat' }, { value: 3, label: 'Mart' }, { value: 4, label: 'Nisan' }, { value: 5, label: 'Mayıs' }, { value: 6, label: 'Haziran' }, { value: 7, label: 'Temmuz' }, { value: 8, label: 'Ağustos' }, { value: 9, label: 'Eylül' }, { value: 10, label: 'Ekim' }, { value: 11, label: 'Kasım' }, { value: 12, label: 'Aralık' } ];

    const downloadHtmlAsDoc = (htmlContent, filename) => {
        const header = `<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'><head><meta charset='utf-8'><title>Rapor</title></head><body>`;
        const footer = "</body></html>";
        const sourceHTML = header + htmlContent + footer;
        const source = 'data:application/vnd.ms-word;charset=utf-8,' + encodeURIComponent(sourceHTML);
        const fileDownload = document.createElement("a");
        document.body.appendChild(fileDownload);
        fileDownload.href = source;
        fileDownload.download = filename;
        fileDownload.click();
        document.body.removeChild(fileDownload);
    };
    
    const generateReportHtml = (title, transactions, reportScope, allPatients, allClinicVisits) => {
        let html = `<h1>${title}</h1><p>Rapor Tarihi: ${new Date().toLocaleDateString('tr-TR')}</p>`;
        let totalOverallDebt = 0;
        
        // Genel Borç Raporu için özet
        if (reportScope === 'debt_report') {
            const ownerDebtMap = {};
             allClinicVisits.forEach(visit => {
                const patient = allPatients.find(p => p.id === visit.patientId);
                 if (patient && patient.ownerName) {
                    if (!ownerDebtMap[patient.ownerName]) {
                        ownerDebtMap[patient.ownerName] = { totalDebt: 0 };
                    }
                    // NaN Fix
                    const debt = (Number(visit.visitCost) || 0) - (Number(visit.paymentAmount) || 0);
                    ownerDebtMap[patient.ownerName].totalDebt += debt;
                }
            });
            totalOverallDebt = Object.values(ownerDebtMap).reduce((sum, owner) => sum + owner.totalDebt, 0);

            html += `<h2>Finansal Özet</h2>
                     <table class="summary-table" style="width:50%; margin-bottom: 20px;">
                        <tr><td>Tüm Klinik Toplam Borcu</td><td style="text-align:right; color: red; font-weight: bold;">${formatCurrency(totalOverallDebt)} TL</td></tr>
                     </table>`;
        } else { // Diğer raporlar için özet
            const summary = transactions.reduce((acc, t) => {
                // NaN Fix
                acc.totalRevenue += Number(t.visitCost) || 0;
                acc.totalCollection += Number(t.paymentAmount) || 0;
                return acc;
            }, { totalRevenue: 0, totalCollection: 0 });

            const totalCredit = summary.totalRevenue - summary.totalCollection;

            html += `<h2>Finansal Özet</h2>
                     <table class="summary-table" style="width: 100%; max-width: 400px; border-collapse: collapse; margin-bottom: 20px; font-size: 10pt;">
                        <tr><td style="border: 1px solid #ddd; padding: 8px;">Toplam Ciro</td><td style="border: 1px solid #ddd; padding: 8px; text-align: right;">${formatCurrency(summary.totalRevenue)} TL</td></tr>
                        <tr><td style="border: 1px solid #ddd; padding: 8px;">Toplam Tahsilat</td><td style="border: 1px solid #ddd; padding: 8px; text-align: right; color: green; font-weight: bold;">${formatCurrency(summary.totalCollection)} TL</td></tr>
                        <tr><td style="border: 1px solid #ddd; padding: 8px;">Oluşturulan/Kalan Veresiye</td><td style="border: 1px solid #ddd; padding: 8px; text-align: right;">${formatCurrency(totalCredit)} TL</td></tr>
                        <tr><td style="border: 1px solid #ddd; padding: 8px;">Toplam İşlem Sayısı</td><td style="border: 1px solid #ddd; padding: 8px; text-align: right;">${transactions.length}</td></tr>
                     </table>`;
        }

        // Yıllık rapor hariç, işlem detayları
        if (transactions.length > 0 && reportScope !== 'yearly') {
            html += `<h2>İşlem Detayları</h2>
                     <table>
                        <thead><tr><th>Tarih</th><th>Hasta</th><th>Sahip</th><th>İşlem/Not</th><th>Tutar</th><th>Ödenen</th><th>Bakiye</th></tr></thead>
                        <tbody>`;
            
            transactions.sort((a,b) => (a.visitDate?.toDate() || 0) - (b.visitDate?.toDate() || 0)).forEach(t => {
                const date = t.visitDate?.toDate();
                const cost = Number(t.visitCost) || 0;
                const paid = Number(t.paymentAmount) || 0;
                const debt = cost - paid;
                const description = t.procedures || t.notes || (t.isCreditSale ? "İlaç Satış İşlemi" : "Klinik Ziyareti");
                // Hata düzeltmesi: Hasta adı yoksa sahip adını göster
                const patientName = t.patientName || `(${t.ownerName})`;
                html += `<tr>
                            <td>${date ? date.toLocaleDateString('tr-TR') : '-'}</td>
                            <td>${patientName}</td>
                            <td>${t.ownerName}</td>
                            <td>${description}</td>
                            <td style="text-align:right;">${formatCurrency(cost)}</td>
                            <td style="text-align:right;">${formatCurrency(paid)}</td>
                            <td style="text-align:right;">${formatCurrency(debt)}</td>
                         </tr>`;
            });
            html += `</tbody></table>`;
        }
        
        if(reportScope === 'daily') {
            const patientsSeen = [...new Set(transactions.map(t => t.ownerName))];
            html += `<h2>Günün Özeti</h2><p>Bugün toplam <strong>${patientsSeen.length}</strong> hasta sahibine hizmet verildi.</p>`;
        }
       
        if (reportScope === 'debt_report') {
            const ownerDebtMap = {};
            allClinicVisits.forEach(visit => {
                const patient = allPatients.find(p => p.id === visit.patientId);
                if (patient && patient.ownerName) {
                    if (!ownerDebtMap[patient.ownerName]) {
                        ownerDebtMap[patient.ownerName] = { name: patient.ownerName, phone: patient.ownerPhone || '-', totalDebt: 0, patients: {} };
                    }
                    const debt = (Number(visit.visitCost) || 0) - (Number(visit.paymentAmount) || 0);
                    ownerDebtMap[patient.ownerName].totalDebt += debt;
    
                    if (!ownerDebtMap[patient.ownerName].patients[patient.name]) {
                        ownerDebtMap[patient.ownerName].patients[patient.name] = 0;
                    }
                    ownerDebtMap[patient.ownerName].patients[patient.name] += debt;
                }
            });
    
            const ownersWithDebt = Object.values(ownerDebtMap).filter(o => o.totalDebt > 0.01).sort((a,b) => b.totalDebt - a.totalDebt);
            // NaN Fix: Toplam borcu tekrar hesapla
            const totalOverallDebt = ownersWithDebt.reduce((sum, o) => sum + o.totalDebt, 0);

            if (ownersWithDebt.length > 0) {
                 html += `<h2>Genel Borç Durumu Detayları</h2>
                         <table>
                            <thead><tr><th>Sahip Adı</th><th>Telefon</th><th>Toplam Borç (TL)</th><th>Borç Detayları (Hasta Bazında)</th></tr></thead>
                            <tbody>`;
                
                ownersWithDebt.forEach(owner => {
                    const patientDebtsHtml = Object.entries(owner.patients)
                        .filter(([_, debt]) => debt > 0.01)
                        .map(([patientName, debt]) => `<strong>${patientName}:</strong> ${formatCurrency(debt)} TL`)
                        .join('<br/>');
    
                    html += `<tr>
                                <td>${owner.name}</td>
                                <td>${owner.phone}</td>
                                <td style="text-align:right;">${formatCurrency(owner.totalDebt)}</td>
                                <td>${patientDebtsHtml}</td>
                             </tr>`;
                });
                html += `</tbody><tfoot><tr><td colspan="2"><strong>TOPLAM</strong></td><td style="text-align:right;"><strong>${formatCurrency(totalOverallDebt)} TL</strong></td><td></td></tr></tfoot></table>`;
            } else {
                 html += `<h2>Genel Borç Durumu</h2><p>Tebrikler, kliniğinize ait ödenmemiş borç bulunmamaktadır!</p>`;
            }
        }
       
        return `<!DOCTYPE html><html lang="tr"><head><meta charset="UTF-8"><title>${title}</title><style>body{font-family:Arial,sans-serif;margin:20px}h1,h2{color:#333}table{width:100%;border-collapse:collapse;margin-top:15px;font-size:10pt;}th,td{border:1px solid #ddd;padding:6px;text-align:left;vertical-align:top;}th{background-color:#f2f2f2}tr:nth-child(even){background-color:#f9f9f9}tfoot td{font-weight:bold;background-color:#e8e8e8}</style></head><body>${html}</body></html>`;
    };

    const handleDownload = async () => {
        if (!reportType) {
            setNotification("Lütfen bir rapor türü seçin.");
            return;
        }
        setIsGeneratingReport(true);
        setNotification("Rapor verileri hazırlanıyor...");

        try {
            const patientsDataMap = new Map(patients.map(p => [p.id, {name: p.name, ownerName: p.ownerName, ownerPhone: p.ownerPhone}]));
            const visitsWithPatientInfo = allVisits.map(visit => {
                const patientInfo = patientsDataMap.get(visit.patientId) || {};
                return { ...visit, patientName: patientInfo.name, ownerName: patientInfo.ownerName, ownerPhone: patientInfo.ownerPhone };
            });

            if (reportType === 'patient_debt') {
                const html = generateReportHtml("Genel Borç Durum Raporu", [], 'debt_report', patients, allVisits);
                downloadHtmlAsDoc(html, `genel_borc_raporu_${new Date().toISOString().split('T')[0]}.doc`);
            } else {
                let transactionsForReport, reportTitle, reportFileName, scope;
                const today = new Date();

                if (reportType === 'daily') {
                    const start = new Date(today.getFullYear(), today.getMonth(), today.getDate());
                    const end = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59, 999);
                    transactionsForReport = visitsWithPatientInfo.filter(v => v.visitDate?.toDate() >= start && v.visitDate?.toDate() <= end);
                    reportTitle = `Gün Sonu Raporu (${today.toLocaleDateString('tr-TR')})`;
                    reportFileName = `gun_sonu_${today.toISOString().split('T')[0]}.doc`;
                    scope = 'daily';
                } else if (reportType === 'monthly') {
                    const start = new Date(selectedYear, selectedMonth - 1, 1);
                    const end = new Date(selectedYear, selectedMonth, 0, 23, 59, 59, 999);
                    transactionsForReport = visitsWithPatientInfo.filter(v => v.visitDate?.toDate() >= start && v.visitDate?.toDate() <= end);
                    reportTitle = `${months.find(m => m.value === selectedMonth)?.label} ${selectedYear} Aylık Rapor`;
                    reportFileName = `aylik_rapor_${selectedYear}_${selectedMonth}.doc`;
                    scope = 'monthly';
                } else { // yearly
                    const start = new Date(selectedYear, 0, 1);
                    const end = new Date(selectedYear, 11, 31, 23, 59, 59, 999);
                    transactionsForReport = visitsWithPatientInfo.filter(v => v.visitDate?.toDate() >= start && v.visitDate?.toDate() <= end);
                    reportTitle = `${selectedYear} Yıllık Rapor`;
                    reportFileName = `yillik_rapor_${selectedYear}.doc`;
                    scope = 'yearly';
                }
                const html = generateReportHtml(reportTitle, transactionsForReport, scope, patients, allVisits);
                downloadHtmlAsDoc(html, reportFileName);
            }
            setNotification("Rapor başarıyla oluşturuldu ve indirildi.");
        } catch (error) {
            setNotification(`Rapor oluşturulurken hata: ${error.message}`);
        } finally {
            setIsGeneratingReport(false);
        }
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose} title="Rapor İndir" size="lg" zIndex="z-[70]">
            <div className="space-y-4">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <button onClick={() => setReportType('patient_debt')} className={`${reportType === 'patient_debt' ? primaryButtonClasses : secondaryButtonClasses} py-3`}>Genel Borç Raporu</button>
                    <button onClick={() => setReportType('daily')} className={`${reportType === 'daily' ? primaryButtonClasses : secondaryButtonClasses} py-3`}>Gün Sonu Raporu</button>
                    <button onClick={() => setReportType('monthly')} className={`${reportType === 'monthly' ? primaryButtonClasses : secondaryButtonClasses} py-3`}>Aylık Rapor</button>
                    <button onClick={() => setReportType('yearly')} className={`${reportType === 'yearly' ? primaryButtonClasses : secondaryButtonClasses} py-3`}>Yıllık Rapor</button>
                </div>
                {(reportType === 'monthly' || reportType === 'yearly') && (
                    <div className="mt-4 p-4 border rounded-md bg-slate-50 space-y-3">
                        <h4 className="font-semibold text-slate-700">Rapor Periyodu Seçin:</h4>
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                            {reportType === 'monthly' && (
                                <div>
                                    <label htmlFor="reportMonth" className={labelClasses}>Ay:</label>
                                    <select id="reportMonth" value={selectedMonth} onChange={(e) => setSelectedMonth(parseInt(e.target.value))} className={inputClasses}>
                                        {months.map(m => <option key={m.value} value={m.value}>{m.label}</option>)}
                                    </select>
                                </div>
                            )}
                            <div>
                                <label htmlFor="reportYear" className={labelClasses}>Yıl:</label>
                                <select id="reportYear" value={selectedYear} onChange={(e) => setSelectedYear(parseInt(e.target.value))} className={inputClasses}>
                                    {years.map(y => <option key={y} value={y}>{y}</option>)}
                                </select>
                            </div>
                        </div>
                    </div>
                )}
                {reportType && (
                    <div className="mt-6 flex justify-end pb-1">
                        <button onClick={handleDownload} className={`${successButtonClasses} py-2.5 px-5`} disabled={isGeneratingReport}>
                            {isGeneratingReport ? <Loader2 className="animate-spin h-5 w-5 mr-2"/> : <Download size={18} className="mr-2"/>}
                            {isGeneratingReport ? "Oluşturuluyor..." : "Seçili Raporu İndir"}
                        </button>
                    </div>
                )}
            </div>
        </Modal>
    );
};

const CreditSalesView = ({ creditSales, onAddNewSale, onEditSale, onOpenDetail, setNotification, isFilteredView = false }) => {
    const [filter, setFilter] = useState('unpaid');
    const [searchTerm, setSearchTerm] = useState('');
    
    const formatCurrency = (value) => {
        const number = Number(value) || 0;
        if (isNaN(number)) return '0.00'; 
        return number.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    };

    const filteredSales = useMemo(() => {
        return creditSales
            .filter(sale => {
                const statusMatch = filter === 'all' || 
                                    (filter === 'unpaid' && (sale.status === 'unpaid' || sale.status === 'partially-paid')) ||
                                    sale.status === filter;
                // Arama: Sahip Adı, Hasta Adı veya Ürün Adı
                const searchMatch = searchTerm === '' || 
                                    sale.ownerName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                                    sale.patientName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                                    (sale.items && sale.items.some(i => i.itemName.toLowerCase().includes(searchTerm.toLowerCase())));
                return statusMatch && searchMatch;
            })
            .sort((a, b) => (b.saleDate?.toDate() || 0) - (a.saleDate?.toDate() || 0));
    }, [creditSales, filter, searchTerm]);

    const getStatusChip = (status) => {
        switch (status) {
            case 'paid': return <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">Ödendi</span>;
            case 'partially-paid': return <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-yellow-100 text-yellow-800">Kısmi Ödendi</span>;
            case 'unpaid': return <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-red-100 text-red-800">Ödenmedi</span>;
            default: return <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-slate-100 text-slate-800">{status}</span>;
        }
    };

    return (
        <div className="space-y-4">
            <div className="flex flex-col sm:flex-row justify-between items-center gap-4 p-3 bg-slate-50 rounded-lg">
                <div className="flex items-center gap-2 flex-wrap">
                    <button onClick={() => setFilter('unpaid')} className={filter === 'unpaid' ? `${dangerButtonClasses} text-sm` : `${secondaryButtonClasses} text-sm`}>Ödenmemiş</button>
                    <button onClick={() => setFilter('paid')} className={filter === 'paid' ? `${successButtonClasses} text-sm` : `${secondaryButtonClasses} text-sm`}>Ödenmiş</button>
                    <button onClick={() => setFilter('all')} className={filter === 'all' ? `${primaryButtonClasses} text-sm` : `${secondaryButtonClasses} text-sm`}>Tümü</button>
                </div>
                <div className="relative w-full sm:w-auto">
                    <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-5 w-5 text-slate-400" />
                    <input 
                        type="text"
                        placeholder="Sahip, hasta veya ürün ara..."
                        value={searchTerm}
                        onChange={e => setSearchTerm(e.target.value)}
                        className={inputClasses + " pl-10 w-full"}
                    />
                </div>
                {!isFilteredView && (
                    <button onClick={onAddNewSale} className={`${primaryButtonClasses} text-sm w-full sm:w-auto`}>
                        <PlusCircle size={16} className="mr-1.5"/> Yeni İlaç Satış
                    </button>
                )}
            </div>
            
            <div className="overflow-x-auto max-h-[60vh] rounded-lg shadow-md">
                <table className="min-w-full divide-y divide-slate-200 text-sm">
                    <thead className="bg-slate-100 sticky top-0">
                        <tr>
                            {["Tarih", "Sahip Adı", "Hasta Ref.", "Toplam Tutar", "Ödenen Tutar", "Kalan Borç", "Durum", "İşlemler"].map(h => 
                                <th key={h} className="px-3 py-2 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">{h}</th>
                            )}
                        </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-slate-200">
                        {filteredSales.length === 0 ? (
                            <tr><td colSpan="8" className="text-center py-8 text-slate-500">Bu filtrede gösterilecek ilaç satış kaydı bulunamadı.</td></tr>
                        ) : (
                            filteredSales.map(sale => {
                                // NaN Fix
                                const totalAmount = Number(sale.totalAmount) || 0;
                                const paidAmount = Number(sale.paidAmount) || 0;
                                const remainingDebt = totalAmount - paidAmount;
                                
                                return (
                                    <tr key={sale.id} className="hover:bg-slate-50">
                                        <td className="px-3 py-2 whitespace-nowrap">{sale.saleDate?.toDate().toLocaleDateString('tr-TR')}</td>
                                        <td className="px-3 py-2 whitespace-nowrap font-medium">{sale.ownerName}</td>
                                        <td className="px-3 py-2 whitespace-nowrap text-xs text-slate-600">{sale.patientName || 'Silinen Hasta'}</td>
                                        <td className="px-3 py-2 whitespace-nowrap text-right">{formatCurrency(totalAmount)} TL</td>
                                        <td className="px-3 py-2 whitespace-nowrap text-right text-green-600">{formatCurrency(paidAmount)} TL</td>
                                        <td className={`px-3 py-2 whitespace-nowrap text-right font-semibold ${remainingDebt > 0.01 ? 'text-red-600' : ''}`}>{formatCurrency(remainingDebt)} TL</td>
                                        <td className="px-3 py-2 whitespace-nowrap">{getStatusChip(sale.status)}</td>
                                        <td className="px-3 py-2 whitespace-nowrap">
                                            <div className="flex items-center space-x-1">
                                                <button onClick={() => onOpenDetail(sale)} className={`${infoButtonClasses} text-xs py-1 px-2`}>Detay</button>
                                                {sale.status !== 'paid' && (
                                                    <button onClick={() => onEditSale(sale)} className={`${secondaryButtonClasses} text-xs py-1 px-2`}>Düzenle</button>
                                                )}
                                            </div>
                                        </td>
                                    </tr>
                                );
                            })
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

// 3- İlaç Satış Formu (Sadece Sahip Seçimi ve Hastayı Referans Alma)
const CreditSaleForm = ({ patients, inventoryItems, onSave, onCancel, isSaving, setNotification, editingSale }) => {
    // patientId artık sadece referans
    const [patientId, setPatientId] = useState('');
    const [saleDate, setSaleDate] = useState(new Date().toISOString().split('T')[0]);
    const [items, setItems] = useState([]);
    const [notes, setNotes] = useState('');
    const [sendWhatsApp, setSendWhatsApp] = useState(true);
    const [ownerSearchTerm, setOwnerSearchTerm] = useState('');
    const [selectedOwnerId, setSelectedOwnerId] = useState('');
    const [newSaleTotal, setNewSaleTotal] = useState(0);
    
    const formatCurrency = (value) => {
        const number = Number(value) || 0;
        if (isNaN(number)) return '0.00'; 
        return number.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    };

    const uniqueOwners = useMemo(() => {
         const ownerMap = {};
         patients.forEach(p => {
             if (p.ownerName && p.publicId) {
                 if (!ownerMap[p.publicId]) {
                      ownerMap[p.publicId] = { ownerName: p.ownerName, patients: [] };
                 }
                 ownerMap[p.publicId].patients.push({ id: p.id, name: p.name });
             }
         });
         return Object.values(ownerMap);
    }, [patients]);


    const filteredOwners = useMemo(() => {
        // Hem sahip adına hem de hasta adına göre filtreleme yap
        return uniqueOwners
            .filter(o => 
                o.ownerName?.toLowerCase().includes(ownerSearchTerm.toLowerCase()) ||
                o.patients.some(p => p.name.toLowerCase().includes(ownerSearchTerm.toLowerCase()))
            );
    }, [uniqueOwners, ownerSearchTerm]);


    useEffect(() => {
        if (editingSale) {
            setPatientId(editingSale.patientId); // Hastayı sadece referans olarak tut
            setSelectedOwnerId(editingSale.ownerId);
            setSaleDate(editingSale.saleDate?.toDate().toISOString().split('T')[0] || new Date().toISOString().split('T')[0]);
            setItems(editingSale.items.map(item => ({
                ...item,
                inventoryItem: item.isStockItem ? inventoryItems.find(i => i.id === item.inventoryItemId) : null
            })));
            setNotes(editingSale.notes || '');
            setOwnerSearchTerm(editingSale.ownerName || '');
            setNewSaleTotal(editingSale.totalAmount || 0);
        } else {
             setPatientId('');
             setSelectedOwnerId('');
             setSaleDate(new Date().toISOString().split('T')[0]);
             setItems([{ itemId: crypto.randomUUID(), inventoryItemId: '', quantity: 1, priceAtSale: 0, itemName: '', inventoryItem: null, paidQuantity: 0, isStockItem: true, unit: 'Adet' }]);
             setNotes('');
             setSendWhatsApp(true);
             setOwnerSearchTerm('');
             setNewSaleTotal(0);
        }
    }, [editingSale, inventoryItems, uniqueOwners]);

    // Toplam tutarı hesapla
    const totalAmount = useMemo(() => {
        const calculated = items.reduce((sum, item) => sum + (Number(item.quantity) * Number(item.priceAtSale)), 0);
        setNewSaleTotal(calculated); // State'i güncelle
        return calculated;
    }, [items]);
    
    // Anlık girilen borç (İlaç satışı yapıldığında bu satışın borcu)
    const instantDebt = totalAmount - items.reduce((sum, item) => sum + ((Number(item.paidQuantity) || 0) * (Number(item.priceAtSale) || 0)), 0);


    const handleItemChange = (index, field, value) => {
        const newItems = [...items];
        const currentItem = newItems[index];
        const inventoryDrugs = inventoryItems.filter(i => i.itemType === 'İlaç');

        if (field === 'type') {
            const isStock = value === 'stock';
            currentItem.isStockItem = isStock;
            currentItem.inventoryItemId = '';
            currentItem.itemName = '';
            currentItem.priceAtSale = 0;
            currentItem.quantity = 1;
            currentItem.mlVolume = 0;
            currentItem.unit = isStock ? 'Adet' : 'Adet'; 
            currentItem.inventoryItem = null;
        } 
        else if (field === 'inventoryItemId' && currentItem.isStockItem) {
            const selectedInventoryItem = inventoryItems.find(i => i.id === value);
            currentItem.inventoryItemId = value;
            currentItem.inventoryItem = selectedInventoryItem;
            currentItem.itemName = selectedInventoryItem?.itemName || '';
            currentItem.priceAtSale = Number(selectedInventoryItem?.unitPrice) || 0; // NaN Fix
            currentItem.unit = selectedInventoryItem?.unit || 'Adet';

        } 
        else if (field === 'itemName' && !currentItem.isStockItem && value) {
            // Stok dışı ilaç ml hesaplama
            const selectedItem = inventoryDrugs.find(i => i.itemName === value && (Number(i.bottleML) || 0) > 0 && (Number(i.unitPrice) || 0) > 0);
            if (selectedItem) {
                currentItem.itemName = selectedItem.itemName;
                currentItem.unit = 'ml';
                currentItem.mlVolume = Number(selectedItem.bottleML);
                currentItem.priceAtSale = ((Number(selectedItem.unitPrice) || 0) / (Number(selectedItem.bottleML) || 1)) || 0; 
            } else {
                 currentItem.itemName = value;
                 currentItem.unit = 'Adet';
                 currentItem.mlVolume = 0;
                 currentItem.priceAtSale = 0;
            }
        }
        else if (field === 'itemName') {
            currentItem.itemName = value;
        }
        else if (field === 'quantity') {
            currentItem.quantity = Number(value) > 0 ? Number(value) : 1;
        } else if (field === 'priceAtSale') {
            currentItem.priceAtSale = Number(value) > 0 ? Number(value) : 0;
        } else if (field === 'unit') {
            currentItem.unit = value;
        }
        setItems(newItems);
    };

    const handleAddItem = (isStockItem) => {
        setItems([...items, { 
            itemId: crypto.randomUUID(), 
            inventoryItemId: '', 
            quantity: 1, 
            priceAtSale: 0, 
            itemName: '', 
            inventoryItem: null, 
            paidQuantity: 0, 
            isStockItem: isStockItem,
            unit: isStockItem ? 'Adet' : 'Adet',
        }]);
    };

    const handleRemoveItem = (index) => {
        if (items.length > 0) {
            setItems(items.filter((_, i) => i !== index));
        } else {
            setNotification("En az bir ürün olmalıdır.");
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        
        // 3- Hasta seçme kalksın. Sadece sahip seçilsin
        if (!selectedOwnerId) {
            setNotification("Lütfen önce bir hasta sahibi seçin.");
            return;
        }
        if (!patientId) {
            setNotification("Lütfen ilacın ilişkilendirileceği hastayı seçin.");
            return;
        }
        if (!saleDate) {
            setNotification("Lütfen satış tarihini seçin.");
            return;
        }
        const validItems = items.filter(i => i.isStockItem ? (i.inventoryItemId && Number(i.quantity) > 0) : (i.itemName && Number(i.quantity) > 0));

        if (validItems.length === 0) {
            setNotification("Lütfen geçerli ürünler ve miktarlar girin.");
            return;
        }
        
        // Stok kontrolü (Sadece ekleme yapılıyorsa veya düzenlemede miktar artıyorsa karmaşık kontrol gerekir, şimdilik basit kontrol)
        if (!editingSale) {
            for (const item of validItems.filter(i => i.isStockItem)) {
                const selectedItemInfo = inventoryItems.find(invItem => invItem.id === item.inventoryItemId);
                if (selectedItemInfo && Number(item.quantity) > Number(selectedItemInfo.quantityInStock)) {
                    setNotification(`Hata: ${selectedItemInfo.itemName} için yeterli stok yok. Mevcut: ${selectedItemInfo.quantityInStock}, İstenen: ${item.quantity}`);
                    return;
                }
            }
        }
        
        // 3- Tahsilat ekranı geldiği için burada paymentAmount/paidQuantity her zaman 0 olacak. Tahsilat işlemi modalda yapılacak.
        const itemsWithZeroPaid = validItems.map(i => ({...i, paidQuantity: 0}));

        onSave({ patientId, saleDate, notes }, itemsWithZeroPaid, editingSale, sendWhatsApp);
    };

    const uniqueDrugNames = useMemo(() => [...new Set(inventoryItems.filter(i => i.itemType === 'İlaç').map(i => i.itemName))], [inventoryItems]);
    
    // Seçilen hastanın sahibi
    const selectedOwnerName = useMemo(() => {
        if (!selectedOwnerId) return null;
        return uniqueOwners.find(o => o.publicId === selectedOwnerId)?.ownerName;
    }, [selectedOwnerId, uniqueOwners]);
    
    // Seçilen sahibe ait hastalar
    const patientsOfSelectedOwner = useMemo(() => {
        if (!selectedOwnerId) return [];
        return uniqueOwners.find(o => o.publicId === selectedOwnerId)?.patients || [];
    }, [selectedOwnerId, uniqueOwners]);

    return (
        <form onSubmit={handleSubmit} className="space-y-4">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="md:col-span-2">
                    <label htmlFor="ownerSearch" className={labelClasses}>Hasta Sahibi İle Ara*</label>
                    <input 
                        type="text" 
                        id="ownerSearch" 
                        value={ownerSearchTerm} 
                        onChange={(e) => { 
                            setOwnerSearchTerm(e.target.value); 
                            setSelectedOwnerId(''); // Arama değiştiğinde sahibin seçimini kaldır
                            setPatientId('');
                        }} 
                        className={inputClasses + " mb-2"} 
                        placeholder="Sahip Adı veya Hayvan Adı ile ara..." 
                        disabled={!!editingSale}
                        required
                        autoComplete="off"
                    />
                </div>

                {/* Sahip Seçim Alanı */}
                <div className="md:col-span-2">
                    <label className={labelClasses}>Hasta Sahibi Seçin*</label>
                    <div className="max-h-24 overflow-y-auto border rounded-md p-2">
                         {filteredOwners.length === 0 && ownerSearchTerm ? (
                             <p className="text-sm text-slate-500">Arama sonucunda sahip bulunamadı.</p>
                         ) : (
                            filteredOwners.map(owner => (
                                <div 
                                    key={owner.publicId} 
                                    onClick={() => {
                                        setSelectedOwnerId(owner.publicId);
                                        setOwnerSearchTerm(owner.ownerName);
                                        // Tek bir hasta varsa otomatik seç
                                        if (owner.patients.length === 1) {
                                            setPatientId(owner.patients[0].id);
                                        } else if (owner.patients.length > 1) {
                                            setPatientId('');
                                        }
                                    }}
                                    className={`p-1.5 cursor-pointer rounded-md ${selectedOwnerId === owner.publicId ? 'bg-blue-200 font-semibold' : 'hover:bg-slate-100'}`}
                                >
                                    {owner.ownerName} ({owner.patients.length} Hayvan)
                                </div>
                            ))
                        )}
                    </div>
                </div>
                
                {/* Hasta Referans Seçim Alanı (Sahip seçildikten sonra) */}
                {selectedOwnerId && (
                     <div className="md:col-span-2">
                         <label htmlFor="patientRef" className={labelClasses}>İlacın İlişkilendirileceği Hasta (Referans)*</label>
                         <select 
                            id="patientRef"
                            value={patientId}
                            onChange={(e) => setPatientId(e.target.value)}
                            className={inputClasses}
                            required
                            disabled={!!editingSale}
                         >
                            <option value="">Hastayı Seçin...</option>
                            {patientsOfSelectedOwner.map(p => (
                                <option key={p.id} value={p.id}>{p.name}</option>
                            ))}
                         </select>
                         <p className="text-xs text-slate-500 mt-1">Bu sadece ziyaret geçmişine düşmek için kullanılan referanstır. Borç sahibinde birikir.</p>
                     </div>
                )}


                <div>
                    <label htmlFor="saleDate" className={labelClasses}>Satış Tarihi*</label>
                    <input type="date" name="saleDate" id="saleDate" value={saleDate} onChange={(e) => setSaleDate(e.target.value)} className={inputClasses} required />
                </div>
            </div>

            <div className="space-y-3 mt-4 border-t pt-4">
                <h4 className="text-md font-semibold text-slate-700">Satılan Ürünler</h4>
                {items.map((item, index) => {
                    const remainingToPay = (Number(item.quantity) || 0) - (Number(item.paidQuantity) || 0);
                    const isFullyPaid = remainingToPay <= 0.01 && remainingToPay >= -0.01; // Yuvarlama hatası için tolerans
                    const isQuantityInvalid = item.isStockItem && item.inventoryItem && Number(item.quantity) > Number(item.inventoryItem.quantityInStock);
                    
                    return (
                        <div key={item.itemId} className="p-3 border rounded-md bg-slate-50">
                            <div className="grid grid-cols-1 sm:grid-cols-4 md:grid-cols-[1fr_auto_1fr_auto_auto] gap-2 items-end">
                                {/* Ürün Tipi Seçimi */}
                                <div className="sm:col-span-2 md:col-span-1">
                                     <label className="text-xs font-medium text-slate-600">Tip</label>
                                     <select
                                        value={item.isStockItem ? 'stock' : 'non-stock'}
                                        onChange={(e) => handleItemChange(index, 'type', e.target.value)}
                                        className={inputClasses + " text-sm py-1.5"}
                                        disabled={isFullyPaid || !!editingSale}
                                    >
                                        <option value="stock">Stoktan</option>
                                        <option value="non-stock">Stok Dışı</option>
                                    </select>
                                </div>

                                {/* Stoklu Ürün Seçimi */}
                                {item.isStockItem ? (
                                    <div className="sm:col-span-2 md:col-span-2">
                                        <label className="text-xs font-medium text-slate-600">Stok Ürünü*</label>
                                        <select 
                                            value={item.inventoryItemId} 
                                            onChange={(e) => handleItemChange(index, 'inventoryItemId', e.target.value)} 
                                            className={inputClasses + " text-sm py-1.5"}
                                            required
                                            disabled={isFullyPaid}
                                        >
                                            <option value="">Ürün seçiniz...</option>
                                            {inventoryItems.map(invItem => (
                                                <option key={invItem.id} value={invItem.id}>
                                                    {invItem.itemName} (Stok: {Number(invItem.quantityInStock) || 0} {invItem.unit})
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                ) : (
                                    // Stok Dışı Ürün Girişi
                                     <div className="sm:col-span-2 md:col-span-2">
                                        <label className="text-xs font-medium text-slate-600">Ürün Adı / İlaç*</label>
                                        <input list={`drug-list-${item.itemId}`} type="text" value={item.itemName} onChange={(e) => handleItemChange(index, 'itemName', e.target.value)} className={inputClasses + " text-sm py-1.5"} placeholder="Ürün Adı" required disabled={isFullyPaid}/>
                                        <datalist id={`drug-list-${item.itemId}`}>
                                             {uniqueDrugNames.map(name => <option key={name} value={name} />)}
                                        </datalist>
                                        {item.mlVolume > 0 && <p className="text-xs text-slate-500 mt-1">Birim Fiyat ml/TL: {formatCurrency(item.priceAtSale)} TL</p>}
                                    </div>
                                )}
                                
                                {/* Miktar */}
                                <div>
                                    <label className="text-xs font-medium text-slate-600">Miktar ({item.unit})*</label>
                                    <input 
                                        type="number" 
                                        step={item.unit === 'ml' ? "0.1" : "1"}
                                        value={item.quantity} 
                                        onChange={(e) => handleItemChange(index, 'quantity', e.target.value)} 
                                        className={inputClasses + ` text-sm py-1.5 w-full ${isQuantityInvalid ? 'border-red-500' : ''}`} 
                                        min="1" 
                                        required
                                        disabled={isFullyPaid}
                                    />
                                    {isQuantityInvalid && <p className="text-red-500 text-xs">Stokta yeterli miktar yok.</p>}
                                </div>
                                
                                {/* Birim Fiyat */}
                                {!item.isStockItem || (item.isStockItem && item.inventoryItemId === '') ? (
                                    <div>
                                        <label className="text-xs font-medium text-slate-600">Birim Fiyat (TL)</label>
                                        <input 
                                            type="number" 
                                            value={item.priceAtSale} 
                                            onChange={(e) => handleItemChange(index, 'priceAtSale', e.target.value)} 
                                            className={inputClasses + " text-sm py-1.5 w-full"} 
                                            step="0.01"
                                            disabled={isFullyPaid}
                                        />
                                    </div>
                                ) : (
                                     <div>
                                        <label className="text-xs font-medium text-slate-600">Birim Fiyat (TL)</label>
                                        <p className="text-sm py-1.5 font-medium text-slate-700">{formatCurrency(item.priceAtSale)}</p>
                                    </div>
                                )}
                                
                                {/* Toplam Tutar ve Silme Butonu */}
                                <div className="text-right">
                                    <p className="text-sm font-semibold text-slate-800">{formatCurrency(Number(item.quantity) * Number(item.priceAtSale))} TL</p>
                                    <button type="button" onClick={() => handleRemoveItem(index)} className={dangerButtonClasses + " p-1 mt-1"} disabled={isFullyPaid || items.length <= 1}>
                                        <Trash2 size={16}/>
                                    </button>
                                </div>
                            </div>
                            {isFullyPaid && <p className="text-xs text-green-600 mt-2">Bu kalem tamamen ödenmiştir.</p>}
                        </div>
                    );
                })}
                <div className="flex space-x-2">
                    <button type="button" onClick={() => handleAddItem(true)} className={`${infoButtonClasses} text-sm py-1.5 px-3`}>
                        <PlusCircle size={16} className="mr-1.5"/> Stoktan Ürün Ekle
                    </button>
                    <button type="button" onClick={() => handleAddItem(false)} className={`${warningButtonClasses} text-sm py-1.5 px-3`}>
                        <PlusCircle size={16} className="mr-1.5"/> Stok Dışı Ürün Ekle
                    </button>
                </div>
            </div>
            
            <div>
                <label htmlFor="notes" className={labelClasses}>Satış Notu</label>
                <textarea 
                    name="notes" 
                    id="notes" 
                    value={notes} 
                    onChange={(e) => setNotes(e.target.value)} 
                    className={textareaClasses} 
                    rows="2" 
                    placeholder="Bu satışla ilgili özel notlar (örn: ödeme vadesi, özel istekler)..."
                ></textarea>
            </div>
            
            <div className="text-right text-lg font-bold mt-4 pt-4 border-t">
                 {/* 3- Anlık girilen ilac borcu ve toplam borcu tek ekranda görünsün. */}
                <p className="text-base font-medium text-slate-600">Yeni Satış Toplamı: {formatCurrency(totalAmount)} TL</p>
                <p className={`text-xl ${instantDebt > 0 ? 'text-red-600' : 'text-green-600'}`}>Satış Borcu (Anlık): {formatCurrency(instantDebt)} TL</p>
            </div>
            
            {!editingSale && (
                 <div className="flex items-center space-x-2 mt-4 p-3 bg-green-50 border border-green-200 rounded-md">
                    <input
                        type="checkbox"
                        id="sendWhatsApp"
                        checked={sendWhatsApp}
                        onChange={(e) => setSendWhatsApp(e.target.checked)}
                        className="h-4 w-4 text-green-600 border-gray-300 rounded focus:ring-green-500"
                    />
                    <label htmlFor="sendWhatsApp" className="text-sm font-medium text-green-800">
                        Satış sonrası bilgilendirme mesajı gönder
                    </label>
                </div>
            )}


            <div className="flex justify-end space-x-3 pt-3 pb-1">
                <button type="button" onClick={onCancel} className={secondaryButtonClasses}>İptal</button>
                <button type="submit" className={primaryButtonClasses} disabled={isSaving || !selectedOwnerId || !patientId}>
                    {isSaving ? <><Loader2 size={18} className="animate-spin mr-1.5"/> Kaydediliyor...</> : <><CheckCircle size={18} className="mr-1.5"/> Satışı Kaydet</>}
                </button>
            </div>
        </form>
    );
};

const CreditSaleDetailModal = ({ isOpen, onClose, sale, onProcessBulkPayment, isProcessing, setNotification, onSendDebtReminder }) => {
    const [confirmation, setConfirmation] = useState({ isOpen: false, message: '', action: null });
    const [amountToCollect, setAmountToCollect] = useState(0);
    const [paymentMethod, setPaymentMethod] = useState('Nakit');

    const formatCurrency = (value) => {
        const number = Number(value) || 0;
        if (isNaN(number)) return '0.00'; 
        return number.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    };

    const remainingDebt = (Number(sale?.totalAmount) || 0) - (Number(sale?.paidAmount) || 0);

    useEffect(() => {
        // Modal açıldığında kalan borcu tam olarak doldur
        setAmountToCollect(Math.max(0, remainingDebt));
    }, [sale, remainingDebt]);

    const handleCollectPayment = () => {
        const amount = parseFloat(amountToCollect) || 0;

        if (amount <= 0) {
            setNotification("Tahsil edilecek tutar sıfırdan büyük olmalıdır.");
            return;
        }
        if (amount > remainingDebt + 0.01) {
            setNotification(`Tahsilat tutarı (${formatCurrency(amount)} TL) kalan borçtan (${formatCurrency(remainingDebt)} TL) fazla olamaz.`);
            return;
        }
        
        setConfirmation({
            isOpen: true,
            message: `${sale.ownerName} sahibinden bu satış için ${formatCurrency(amount)} TL tahsil edilecek. Bu tahsilat, sahibin **tüm borcuna** dağıtılacaktır. Onaylıyor musunuz?`,
            action: () => {
                // Bulk Payment'a yönlendir (ownerId üzerinden tüm borcu düşmek için)
                onProcessBulkPayment(sale.ownerId, amount, paymentMethod);
                onClose();
            }
        });
    };

    if (!sale) return null;
    const unpaidItemsExist = remainingDebt > 0.01;
    
    // Veresiye ürünlerinin ödeme durumunu görselleştirme
    const renderPaymentStatus = (item) => {
        const paid = Number(item.paidQuantity) || 0;
        const total = Number(item.quantity) || 0;
        if (paid >= total) {
             return <span className="text-green-600 font-semibold text-xs"> (Ödendi)</span>;
        } else if (paid > 0) {
             return <span className="text-yellow-600 font-semibold text-xs"> ({paid.toFixed(1).replace(/\.0$/, '')}/{total.toFixed(1).replace(/\.0$/, '')} Kısmi Ödeme)</span>;
        }
         return <span className="text-red-600 font-semibold text-xs"> (Ödenmedi)</span>;
    };


    return (
        <>
            <Modal isOpen={isOpen} onClose={onClose} title={`İlaç Satış Detayları - ${sale.patientName}`} size="3xl" zIndex="z-[90]">
                <div className="space-y-4">
                    <div className="p-3 bg-slate-100 rounded-md text-sm flex flex-col sm:flex-row justify-between items-start sm:items-center gap-2">
                        <div>
                            <p><strong>Hasta:</strong> {sale.patientName}</p>
                            <p><strong>Sahip:</strong> {sale.ownerName}</p>
                            <p><strong>Tarih:</strong> {sale.saleDate?.toDate().toLocaleDateString('tr-TR')}</p>
                            {sale.notes && <p><strong>Not:</strong> {sale.notes}</p>}
                        </div>
                        <button 
                            onClick={() => onSendDebtReminder(sale)}
                            className={`${warningButtonClasses} text-sm`}
                            disabled={!unpaidItemsExist}
                        >
                            <Share2 size={16} className="mr-1.5"/>
                            Borç Hatırlat
                        </button>
                    </div>
                    
                    {unpaidItemsExist && (
                        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 p-2 bg-slate-100 border-l-4 border-teal-400 rounded-md">
                            <h5 className="font-semibold text-teal-800">Tahsilat Yap</h5>
                            <div className="flex flex-col sm:flex-row items-center gap-2">
                                <input
                                    type="number"
                                    value={amountToCollect}
                                    onChange={(e) => setAmountToCollect(e.target.value)}
                                    className={inputClasses + " text-sm py-1.5 w-24 text-right"}
                                    step="0.01"
                                    min="0.01"
                                    max={Math.ceil(remainingDebt * 100) / 100}
                                    disabled={isProcessing}
                                />
                                <select 
                                    value={paymentMethod}
                                    onChange={(e) => setPaymentMethod(e.target.value)}
                                    className={inputClasses + " text-sm py-1.5 w-32"}
                                >
                                     <option value="Nakit">Nakit</option>
                                     <option value="Kart">Kart</option>
                                     <option value="Havale/EFT">Havale/EFT</option>
                                </select>
                                <button 
                                    onClick={handleCollectPayment} 
                                    className={`${successButtonClasses} text-sm py-1.5 px-3 w-full sm:w-auto`}
                                    disabled={isProcessing || amountToCollect <= 0 || amountToCollect > remainingDebt + 0.01}
                                >
                                    <CheckCircle size={16} className="mr-1.5"/> Tahsil Et
                                </button>
                            </div>
                        </div>
                    )}

                    <div className="space-y-2 max-h-[45vh] overflow-y-auto pr-2">
                        {sale.items?.map(item => {
                            const remainingToPay = (Number(item.quantity) || 0) - (Number(item.paidQuantity) || 0);
                            const isFullyPaid = remainingToPay <= 0.01 && remainingToPay >= -0.01;

                            return (
                                <div key={item.itemId} className={`p-3 border rounded-md flex items-center gap-4 ${isFullyPaid ? 'bg-green-50 border-green-200' : 'bg-white'}`}>
                                    <div className="flex-grow">
                                        <p className="font-semibold">{item.itemName} ({item.unit}) {item.isStockItem ? '' : '(Stok Dışı)'} {renderPaymentStatus(item)}</p>
                                        <p className="text-xs text-slate-600 mt-1">
                                            {Number(item.quantity).toFixed(1).replace(/\.0$/, '')} adet x {formatCurrency(item.priceAtSale)} TL = <strong>{formatCurrency(Number(item.quantity) * Number(item.priceAtSale))} TL</strong>
                                        </p>
                                        <p className={`text-xs font-semibold mt-1 ${isFullyPaid ? 'text-green-700' : 'text-red-700'}`}>
                                            Kalan Borç: {remainingToPay.toFixed(1).replace(/\.0$/, '')} {item.unit}
                                        </p>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                     <div className="text-right text-md font-semibold mt-3 pt-3 border-t">
                        <p>Toplam Tutar: <span className="text-slate-800">{formatCurrency(sale.totalAmount)} TL</span></p>
                        <p>Toplam Ödenen: <span className="text-green-600">{formatCurrency(sale.paidAmount)} TL</span></p>
                        <p>Kalan Borç: <span className="text-red-600">{formatCurrency(remainingDebt)} TL</span></p>
                     </div>
                </div>
            </Modal>
            <ConfirmationModal
                isOpen={confirmation.isOpen}
                onClose={() => setConfirmation({ isOpen: false, message: '', action: null })}
                message={confirmation.message}
                onConfirm={confirmation.action}
                zIndex="z-[110]"
            />
        </>
    );
};

const PrescriptionWriterModal = ({ isOpen, onClose, patients, inventoryItems, clinicInfo, doctorInfo, onSave, isSaving, setNotification }) => {
    const prescriptionRef = useRef(null);
    const initialFormState = {
        selectedPatientId: '',
        prescriptionDate: new Date().toISOString().split('T')[0],
        prescribedDrugs: [],
        notes: '',
        diagnosis: '',
        ownerSearchTerm: '', 
    };
    const [formState, setFormState] = useState(initialFormState);
    const { selectedPatientId, prescriptionDate, prescribedDrugs, notes, diagnosis, ownerSearchTerm } = formState;

    const selectedPatient = useMemo(() => patients.find(p => p.id === selectedPatientId), [selectedPatientId, patients]);
    
    const formatCurrency = (value) => {
        const number = Number(value) || 0;
        if (isNaN(number)) return '0.00'; 
        return number.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    };


    // Hasta seçimi için filtreleme
    const patientOptions = useMemo(() => {
         return patients
            .filter(p => 
                p.ownerName?.toLowerCase().includes(ownerSearchTerm.toLowerCase()) ||
                p.name?.toLowerCase().includes(ownerSearchTerm.toLowerCase())
            )
            .map(p => ({
                id: p.id,
                name: p.name,
                ownerName: p.ownerName,
                publicId: p.publicId 
            }));
    }, [patients, ownerSearchTerm]);


    useEffect(() => {
        loadScript("https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.min.js")
            .catch(err => console.error(err));
    }, []);

    const resetForm = () => {
        setFormState(initialFormState);
    };

    const handleClose = () => {
        resetForm();
        onClose();
    };

    const handleFormChange = (field, value) => {
        setFormState(prev => ({ ...prev, [field]: value }));
    };

    const handlePatientClick = (p) => {
        handleFormChange('selectedPatientId', p.id);
        handleFormChange('ownerSearchTerm', p.ownerName);
    };

    const handleAddDrug = () => {
        handleFormChange('prescribedDrugs', [...prescribedDrugs, {
            id: crypto.randomUUID(), inventoryItemId: '', dosage: '', frequency: '', duration: '', customNotes: '',
        }]);
    };

    const handleRemoveDrug = (id) => {
        handleFormChange('prescribedDrugs', prescribedDrugs.filter(d => d.id !== id));
    };

    const handleDrugChange = (id, field, value) => {
        setFormState(prev => ({
             ...prev, 
             prescribedDrugs: prev.prescribedDrugs.map(drug => 
                drug.id === id ? { ...drug, [field]: value } : drug
            )
        }));
    };

    const handleDrugSelect = (id, inventoryItemId) => {
        const inventoryItem = inventoryItems.find(i => i.id === inventoryItemId);
        if (!inventoryItem || !selectedPatient) {
            handleDrugChange(id, 'inventoryItemId', inventoryItemId);
            return;
        }

        const dosageInfo = inventoryItem.dosages?.[selectedPatient.species];
        const patientWeight = Number(selectedPatient.weight) || 0;
        let calculatedDosage = '';

        if (dosageInfo && patientWeight > 0 && Number(dosageInfo.dosagePerKg) > 0 && Number(dosageInfo.concentration) > 0) {
            const doseInUnits = (patientWeight * Number(dosageInfo.dosagePerKg)) / Number(dosageInfo.concentration);
            calculatedDosage = `${doseInUnits.toFixed(2)} ${dosageInfo.dosageUnit || 'birim'}`;
        }
        
        setFormState(prev => ({
             ...prev, 
             prescribedDrugs: prev.prescribedDrugs.map(drug => 
                drug.id === id ? { 
                    ...drug, inventoryItemId: inventoryItemId, dosage: calculatedDosage, customNotes: dosageInfo?.notes || ''
                } : drug
            )
        }));
    };

    const generatePrescriptionHtml = () => {
        const patientInfoHtml = selectedPatient ? `
            <div class="section">
                <h2 class="section-title">Hasta Bilgileri</h2>
                <p><strong>Adı:</strong> ${selectedPatient.name}</p>
                <p><strong>Türü / Cinsi:</strong> ${selectedPatient.species} / ${selectedPatient.breed || 'Belirtilmemiş'}</p>
                <p><strong>Kilo:</strong> ${selectedPatient.weight || 'Belirtilmemiş'} kg</p>
                <p><strong>Sahibi:</strong> ${selectedPatient.ownerName}</p>
                <p><strong>Telefon:</strong> ${selectedPatient.ownerPhone}</p>
            </div>
        ` : '<div class="section"><h2 class="section-title">Hasta Seçilmedi</h2></div>';

        const drugsHtml = prescribedDrugs.map(drug => {
            const inventoryItem = inventoryItems.find(i => i.id === drug.inventoryItemId);
            return `
                <div class="drug-item">
                    <p class="drug-name"><strong>${inventoryItem ? inventoryItem.itemName : 'İlaç Seçilmedi'}</strong></p>
                    <p><strong>Kullanım Şekli:</strong> ${drug.dosage || 'Belirtilmedi'}, ${drug.frequency || 'Belirtilmedi'}, ${drug.duration || 'Belirtilmedi'}</p>
                    ${drug.customNotes ? `<p><strong>Notlar:</strong> ${drug.customNotes}</p>` : ''}
                </div>
            `;
        }).join('');

        const notesHtml = notes ? `
            <div class="section">
                <h2 class="section-title">Veteriner Hekim Notları</h2>
                <p>${notes.replace(/\n/g, '<br>')}</p>
            </div>
        ` : '';
        
        const diagnosisHtml = diagnosis ? `<h2 class="diagnosis-title">Teşhis: ${diagnosis}</h2>` : '';

        return `
            <!DOCTYPE html><html lang="tr"><head><meta charset="UTF-8"><title>Veteriner Reçetesi - ${selectedPatient?.name || ''}</title>
            <style>
                @import url('https://fonts.googleapis.com/css2?family=Roboto+Slab:wght@400;700&family=Roboto:wght@400;500&display=swap');
                body { font-family: 'Roboto', sans-serif; margin: 0; padding: 20px; font-size: 11pt; background-color: #fff; color: #333; }
                .prescription-container { width: 100%; max-width: 800px; margin: auto; border: 1px solid #ddd; padding: 25px; box-shadow: 0 0 15px rgba(0,0,0,0.05); border-radius: 8px; }
                .header { text-align: center; border-bottom: 2px solid #4A90E2; padding-bottom: 15px; margin-bottom: 20px; }
                .header h1 { font-family: 'Roboto Slab', serif; margin: 0; font-size: 22pt; color: #4A90E2; } 
                .header p { margin: 4px 0; font-size: 9pt; color: #555; }
                .content { margin-top: 20px; }
                .section { padding: 10px 0; margin-bottom: 10px; }
                .section-title { font-family: 'Roboto Slab', serif; font-size: 13pt; margin-top: 0; border-bottom: 1px solid #eee; padding-bottom: 5px; color: #333; }
                .drug-item { border-bottom: 1px dashed #e0e0e0; padding-bottom: 10px; margin-bottom: 10px; }
                .drug-item:last-child { border-bottom: none; }
                .drug-name { font-size: 12pt; font-weight: 500; }
                .drug-item p { margin: 4px 0; }
                .rx-symbol { font-family: 'Times New Roman', Times, serif; font-size: 48pt; font-weight: bold; float: left; margin-right: 20px; line-height: 1; color: #4A90E2; }
                .signature { margin-top: 50px; text-align: right; }
                .signature p { margin: 5px 0; }
                .diagnosis-title { font-family: 'Roboto Slab', serif; text-align: center; font-size: 14pt; margin-bottom: 20px; }
                .footer { text-align: center; font-size: 8pt; color: #999; margin-top: 30px; border-top: 1px solid #eee; padding-top: 10px;}
            </style></head><body>
            <div class="prescription-container" id="prescription-content">
                <div class="header"><h1>${clinicInfo.name}</h1><p>${clinicInfo.address} - Tel: ${clinicInfo.phone}</p></div>
                <div class="content">
                    <div style="display: flex; justify-content: space-between; align-items: flex-start; border-bottom: 1px solid #eee; padding-bottom: 15px;">
                        ${patientInfoHtml}
                        <div class="section" style="text-align: right;">
                             <p><strong>Reçete No:</strong> ${Date.now()}</p>
                             <p><strong>Tarih:</strong> ${new Date(prescriptionDate).toLocaleDateString('tr-TR')}</p>
                        </div>
                    </div>
                    <div class="section">${diagnosisHtml}</div>
                    <div class="section">
                        <span class="rx-symbol">R/p</span>
                        <h2 class="section-title" style="padding-top:15px;">İlaçlar</h2>
                        ${drugsHtml || '<p>Reçete edilen ilaç bulunmamaktadır.</p>'}
                    </div>
                    ${notesHtml}
                </div>
                <div class="signature"><p>_________________________</p><p><strong>Vet. Hek. ${doctorInfo.name}</strong></p><p>Kaşe / İmza</p></div>
                <div class="footer"><p>Geçmiş olsun dileklerimizle.</p></div>
            </div>
            </body></html>`;
    };
    
    const handlePrint = () => {
        if (!selectedPatientId) { setNotification("Lütfen bir hasta seçin."); return; }
        const htmlContent = generatePrescriptionHtml();
        const printWindow = window.open('', '_blank');
        printWindow.document.write(htmlContent);
        printWindow.document.close();
        printWindow.focus();
        setTimeout(() => { printWindow.print(); }, 500);
    };

    const handleWhatsAppShare = async () => {
        if (!selectedPatientId || !selectedPatient?.ownerPhone) {
            setNotification("Lütfen bir hasta seçin ve hastanın telefon numarasının kayıtlı olduğundan emin olun.");
            return;
        }
        if (typeof window.html2canvas === 'undefined') {
            setNotification("Paylaşım özelliği için kütüphane yüklenemedi. Lütfen tekrar deneyin.");
            return;
        }
    
        const prescriptionElement = prescriptionRef.current;
        if (!prescriptionElement) return;
    
        try {
            const canvas = await window.html2canvas(prescriptionElement, { scale: 2, backgroundColor: '#ffffff' });
            const blob = await new Promise(resolve => canvas.toBlob(resolve, 'image/png'));
            const file = new File([blob], `recete-${selectedPatient.name}.png`, { type: 'image/png' });
            
            if (navigator.share && navigator.canShare({ files: [file] })) {
                await navigator.share({
                    title: `Reçete - ${selectedPatient.name}`,
                    text: `${selectedPatient.name} için veteriner hekim reçetesi.`,
                    files: [file],
                });
            } else {
                 setNotification("Cihazınızda dosya paylaşımı desteklenmiyor. Lütfen başka bir yöntem deneyin.");
            }
        } catch (err) {
            setNotification(`Paylaşım sırasında bir hata oluştu: ${err.message}`);
        }
    };

    const handleSave = () => {
        if (!selectedPatientId) { setNotification("Lütfen bir hasta seçin."); return; }
        
        const fullPrescriptionText = `Teşhis: ${diagnosis}\n\nİlaçlar:\n${prescribedDrugs.map(d => {
            const item = inventoryItems.find(i => i.id === d.inventoryItemId);
            return `- ${item?.itemName || 'Bilinmeyen İlaç'}: Doz: ${d.dosage}, Sıklık: ${d.frequency}, Süre: ${d.duration}, Not: ${d.customNotes || ''}`;
        }).join('\n')}\n\nGenel Notlar:\n${notes}`;

        onSave({ patientId: selectedPatientId, diagnosis, fullPrescriptionText });
        handleClose();
    };

    return (
        <Modal isOpen={isOpen} onClose={handleClose} title="Reçete Oluştur" size="5xl">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="space-y-4">
                    {/* Hasta Sahibi / Hasta Seçimi */}
                    <div>
                        <label htmlFor="ownerSearch" className={labelClasses}>Hasta Sahibi / Hasta Adı İle Ara*</label>
                        <input 
                            type="text" 
                            id="ownerSearch" 
                            value={ownerSearchTerm} 
                            onChange={(e) => { handleFormChange('ownerSearchTerm', e.target.value); handleFormChange('selectedPatientId', ''); }} 
                            className={inputClasses + " mb-2"} 
                            placeholder="Sahip Adı veya Hayvan Adı" 
                            required
                            autoComplete="off"
                        />
                         <div className="max-h-24 overflow-y-auto border rounded-md p-2">
                            {patientOptions.length === 0 && ownerSearchTerm ? (
                                <p className="text-sm text-slate-500">Arama sonucunda hasta bulunamadı.</p>
                            ) : (
                                patientOptions.map(p => (
                                    <div 
                                        key={p.id} 
                                        onClick={() => handlePatientClick(p)}
                                        className={`p-1.5 cursor-pointer rounded-md ${selectedPatientId === p.id ? 'bg-blue-200 font-semibold' : 'hover:bg-slate-100'}`}
                                    >
                                        {p.name} ({p.ownerName}) {selectedPatientId === p.id && <CheckCircle size={14} className="inline ml-1 text-green-600"/>}
                                    </div>
                                ))
                            )}
                        </div>
                    </div>
                    
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                        <div>
                            <label htmlFor="patientNameDisplay" className={labelClasses}>Seçilen Hasta</label>
                            <input 
                                type="text" 
                                id="patientNameDisplay" 
                                value={selectedPatient?.name || 'Seçim Yapılmadı'} 
                                className={inputClasses + " bg-slate-100 font-semibold"} 
                                readOnly 
                            />
                        </div>
                        <div>
                            <label htmlFor="prescriptionDate" className={labelClasses}>Reçete Tarihi*</label>
                            <input type="date" id="prescriptionDate" value={prescriptionDate} onChange={e => handleFormChange('prescriptionDate', e.target.value)} className={inputClasses} required />
                        </div>
                    </div>
                     <div>
                        <label htmlFor="diagnosis" className={labelClasses}>Teşhis</label>
                        <input type="text" id="diagnosis" value={diagnosis} onChange={e => handleFormChange('diagnosis', e.target.value)} className={inputClasses} placeholder="Örn: Gastroenterit" />
                    </div>

                    <div className="space-y-3 mt-4 border-t pt-4">
                        <h4 className="text-md font-semibold text-slate-700">Reçete Edilen İlaçlar</h4>
                        {!selectedPatientId && <p className="text-red-500 text-sm">Lütfen ilaç dozajlarını görebilmek için yukarıdan bir hasta seçin.</p>}
                        {prescribedDrugs.map((drug, index) => (
                            <div key={drug.id} className="p-3 border rounded-md bg-slate-50 space-y-2">
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                                    <div>
                                        <label className="text-xs font-medium text-slate-600">İlaç*</label>
                                        <select value={drug.inventoryItemId} onChange={e => handleDrugSelect(drug.id, e.target.value)} className={inputClasses + " text-sm py-1.5"} required>
                                            <option value="">Stoktan İlaç Seçin...</option>
                                            {inventoryItems.map(item => <option key={item.id} value={item.id}>{item.itemName}</option>)}
                                        </select>
                                    </div>
                                    <div>
                                        <label className="text-xs font-medium text-slate-600">Doz</label>
                                        <input type="text" placeholder="örn: 1 tablet" value={drug.dosage} onChange={e => handleDrugChange(drug.id, 'dosage', e.target.value)} className={inputClasses + " text-sm py-1.5"} />
                                    </div>
                                    <div>
                                        <label className="text-xs font-medium text-slate-600">Sıklık</label>
                                        <input type="text" placeholder="örn: Günde 2 kez" value={drug.frequency} onChange={e => handleDrugChange(drug.id, 'frequency', e.target.value)} className={inputClasses + " text-sm py-1.5"} />
                                    </div>
                                    <div>
                                        <label className="text-xs font-medium text-slate-600">Süre</label>
                                        <input type="text" placeholder="örn: 5 gün" value={drug.duration} onChange={e => handleDrugChange(drug.id, 'duration', e.target.value)} className={inputClasses + " text-sm py-1.5"} />
                                    </div>
                                </div>
                                <div>
                                    <label className="text-xs font-medium text-slate-600">İlaç Notları</label>
                                    <textarea placeholder="İlaç için özel notlar..." value={drug.customNotes} onChange={e => handleDrugChange(drug.id, 'customNotes', e.target.value)} className={textareaClasses + " text-sm"} rows="1"></textarea>
                                </div>
                                <button type="button" onClick={() => handleRemoveDrug(drug.id)} className={dangerButtonClasses + " p-1 text-xs self-start"}>
                                    <Trash2 size={14}/>
                                </button>
                            </div>
                        ))}
                        <button type="button" onClick={handleAddDrug} className={infoButtonClasses + " text-sm py-1.5 px-3"}>
                            <PlusCircle size={16} className="mr-1.5"/> İlaç Ekle
                        </button>
                    </div>

                    <div>
                        <label htmlFor="notes" className={labelClasses}>Genel Notlar ve Talimatlar</label>
                        <textarea id="notes" value={notes} onChange={e => handleFormChange('notes', e.target.value)} className={textareaClasses} rows="3" placeholder="İlaçların kullanımı, diyet veya diğer önemli talimatlar..."></textarea>
                    </div>
                </div>

                <div className="bg-white p-4 border rounded-lg shadow-inner h-full overflow-auto">
                    <h4 className="text-md font-semibold text-slate-700 mb-2 text-center">Reçete Önizleme</h4>
                    {/* Önizleme div'i mutlaka bir ID'ye sahip olmalı */}
                    <div id="prescription-preview" ref={prescriptionRef} dangerouslySetInnerHTML={{ __html: generatePrescriptionHtml().match(/<body[^>]*>([\s\S]*)<\/body>/i)[1] }} />
                </div>
            </div>
            <div className="flex justify-end space-x-3 pt-4 border-t mt-4 pb-1">
                <button type="button" onClick={handleClose} className={secondaryButtonClasses}>Kapat</button>
                <button type="button" onClick={handlePrint} className={purpleButtonClasses} disabled={!selectedPatientId}>
                    <Printer size={18} className="mr-1.5"/> Yazdır
                </button>
                <button type="button" onClick={handleWhatsAppShare} className={`${successButtonClasses} bg-green-500 hover:bg-green-600`} disabled={!selectedPatientId}>
                    <Share2 size={18} className="mr-1.5"/> WhatsApp
                </button>
                <button type="button" onClick={handleSave} className={primaryButtonClasses} disabled={isSaving || !selectedPatientId}>
                    {isSaving ? <Loader2 className="animate-spin" /> : <Save size={18} className="mr-1.5"/>}
                    Ziyaret Olarak Kaydet
                </button>
            </div>
        </Modal>
    );
};

const PatientPortalLoginScreen = ({ db, appId, setViewMode, setPortalOwnerData, setNotification }) => {
    const [portalId, setPortalId] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const handleLogin = async (e) => {
        e.preventDefault();
        const trimmedId = portalId.trim().toUpperCase();
        if (!trimmedId) {
            setNotification("Lütfen Portal ID'nizi girin.");
            return;
        }
        setIsLoading(true);
        try {
            const publicPortalRef = doc(db, `artifacts/${appId}/public`, trimmedId);
            const publicPortalSnap = await getDoc(publicPortalRef);

            if (!publicPortalSnap.exists()) {
                setNotification("Geçersiz Portal ID. Lütfen kontrol edip tekrar deneyin.");
                setIsLoading(false);
                return;
            }

            const portalInfo = publicPortalSnap.data();
            
            const ownerData = {
                ownerName: portalInfo.ownerName,
                publicId: trimmedId,
                patients: portalInfo.patients || [],
                userId: portalInfo.userId, // Klinik sahibinin UID'si
            };

            setPortalOwnerData(ownerData);
            setViewMode('portal_view');

        } catch (error) {
            if (error.code === 'permission-denied') {
                 setNotification("Giriş başarısız. Veritabanı erişim izni sorunu. Lütfen kliniğinizle iletişime geçin.");
            } else {
                 setNotification("Giriş sırasında beklenmedik bir hata oluştu. Lütfen daha sonra tekrar deneyin.");
            }
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-slate-100 p-4">
            <div className="w-full max-w-md bg-white rounded-xl shadow-2xl p-8 space-y-6 animate-fade-in">
                <div className="text-center">
                    <h1 className="text-3xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-teal-600 to-cyan-500 pb-1">
                        Hasta Sahibi Portalı
                    </h1>
                    <p className="text-slate-500 mt-2">Size verilen Portal ID ile giriş yapın.</p>
                </div>
                <form onSubmit={handleLogin} className="space-y-4">
                    <div className="relative">
                        <KeyRound className="absolute left-3 top-1/2 -translate-y-1/2 h-5 w-5 text-slate-400" />
                        <input
                            type="text"
                            placeholder="Portal ID"
                            value={portalId}
                            onChange={(e) => setPortalId(e.target.value)}
                            className={inputClasses + " pl-10 text-center uppercase tracking-widest"}
                            required
                            autoComplete="off"
                        />
                    </div>
                    <button type="submit" className={`${infoButtonClasses} w-full`} disabled={isLoading}>
                        {isLoading ? <Loader2 className="animate-spin" /> : 'Giriş Yap'}
                    </button>
                </form>
                 <button onClick={() => setViewMode('entry')} className="text-sm text-blue-600 hover:underline mt-4">
                    &larr; Ana Giriş Ekranına Dön
                </button>
            </div>
        </div>
    );
};

const PatientPortalView = ({ ownerData, onExit, db, appId, patientsMap }) => {
    const [patientDetails, setPatientDetails] = useState([]); 
    const [isLoadingDetails, setIsLoadingDetails] = useState(true);
    const [detailModalPatient, setDetailModalPatient] = useState(null);
    const [ownerFinancialSummary, setOwnerFinancialSummary] = useState(null);
    const [isLoadingFinancial, setIsLoadingFinancial] = useState(true);

    const formatCurrency = (value) => {
        const number = Number(value) || 0;
        if (isNaN(number)) return '0.00'; 
        return number.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    };

    // Tüm ziyaretleri çekme (Finansal Özet için)
    useEffect(() => {
        const fetchFinancialData = async () => {
            if (!ownerData || !ownerData.userId) {
                setIsLoadingFinancial(false);
                return;
            }
            setIsLoadingFinancial(true);
            try {
                // Sadece bu sahibin hastalarına ait ziyaretleri çek.
                const ownerPatientIds = ownerData.patients.map(p => p.id);
                if (ownerPatientIds.length === 0) {
                     setOwnerFinancialSummary({ totalDebt: 0, portalReportHtml: '<div style="padding: 15px; border: 1px solid #d1fae5; background-color: #e6fff0; border-radius: 5px; text-align: center;"><h2 style="font-size: 16pt; margin: 0; color: green;">Toplam Cari Bakiye</h2><p style="font-size: 24pt; font-weight: bold; margin: 10px 0; color: green;">0.00 TL</p><p style="color: green; font-weight: bold;">Ödenmemiş borcunuz bulunmamaktadır.</p></div>' });
                     setIsLoadingFinancial(false);
                     return;
                }
                
                const visitsRef = collectionGroup(db, 'visits');
                const allVisitsSnapshot = await getDocs(query(visitsRef, where('userId', '==', ownerData.userId)));
                
                let totalDebt = 0;
                
                allVisitsSnapshot.docs.forEach(doc => {
                    const v = doc.data();
                    if (ownerPatientIds.includes(v.patientId)) {
                        // NaN Fix
                        const debt = (Number(v.visitCost) || 0) - (Number(v.paymentAmount) || 0);
                        totalDebt += debt;
                    }
                });

                // Rapor için sadece total borcu gösteren basit HTML oluşturulur 
                const total = Math.round(totalDebt * 100) / 100;
                const debtClass = total > 0.01 ? 'color: red;' : 'color: green;';
                const bgColor = total > 0.01 ? '#ffeaea' : '#e6fff0';
                const borderColor = total > 0.01 ? '#ffcccc' : '#d1fae5';
                
                const portalReportHtml = `
                    <div style="padding: 15px; border: 1px solid ${borderColor}; background-color: ${bgColor}; border-radius: 5px; text-align: center;">
                        <h2 style="font-size: 16pt; margin: 0; color: #444;">Toplam Cari Bakiye</h2>
                        <p style="font-size: 24pt; font-weight: bold; margin: 10px 0; ${debtClass}">
                            ${formatCurrency(total)} TL
                        </p>
                        ${total > 0.01 ? '<p style="color: red; font-weight: bold;">Ödenmemiş borcunuz bulunmaktadır. Lütfen kliniğinizle iletişime geçin.</p>' : '<p style="color: green; font-weight: bold;">Ödenmemiş borcunuz bulunmamaktadır.</p>'}
                    </div>
                `;
                
                setOwnerFinancialSummary({ totalDebt: total, portalReportHtml });

            } catch (error) {
                console.error("Finansal özet çekilirken hata:", error);
                 setOwnerFinancialSummary({ totalDebt: 0, portalReportHtml: '<p style="color: red;">Finansal veriler yüklenemedi.</p>' });
            } finally {
                setIsLoadingFinancial(false);
            }
        };
        fetchFinancialData();
    }, [ownerData, db, patientsMap]);


    // Hasta detaylarını çekme (Ziyaretler ve Hatırlatmalar için)
    useEffect(() => {
        const fetchAllDetails = async () => {
            if (!ownerData || !ownerData.userId || !ownerData.patients || ownerData.patients.length === 0) {
                setIsLoadingDetails(false);
                return;
            }
            setIsLoadingDetails(true);
            try {
                const patientIds = ownerData.patients.map(p => p.id);
                if (patientIds.length === 0) {
                    setPatientDetails([]);
                    setIsLoadingDetails(false);
                    return;
                }

                // Firestore'un where('__name__', 'in', ...) limitini aşmamak için 10'arlı gruplayalım
                const patientIdChunks = [];
                for (let i = 0; i < patientIds.length; i += 10) {
                    patientIdChunks.push(patientIds.slice(i, i + 10));
                }
                
                const patientDocsPromises = patientIdChunks.map(chunk => {
                    const patientsRef = collection(db, `artifacts/${appId}/users/${ownerData.userId}/patients`);
                    const q = query(patientsRef, where("__name__", "in", chunk));
                    return getDocs(q);
                });

                const allPatientDocsSnapshot = await Promise.all(patientDocsPromises);
                
                const patientsBaseData = [];
                allPatientDocsSnapshot.forEach(snapshot => {
                    snapshot.docs.forEach(doc => patientsBaseData.push({ id: doc.id, ...doc.data() }));
                });


                const patientDetailsPromises = patientsBaseData.map(async (patient) => {
                    const publicVisitsColRef = collection(db, `artifacts/${appId}/public/data/patient_visits/${patient.id}/visits`);
                    const visitsQuery = query(publicVisitsColRef, orderBy("visitDate", "desc"));
                    const visitSnapshot = await getDocs(visitsQuery);
                    const visits = visitSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
                    
                    const publicRemindersColRef = collection(db, `artifacts/${appId}/public/data/patient_reminders/${patient.id}/reminders`);
                    const remindersQuery = query(publicRemindersColRef, orderBy("reminderDate", "desc"));
                    const reminderSnapshot = await getDocs(remindersQuery);
                    const reminders = reminderSnapshot.docs.map(doc => ({id: doc.id, ...doc.data()}));

                    return { ...patient, visits, reminders };
                });

                const results = await Promise.all(patientDetailsPromises);
                setPatientDetails(results);

            } catch (error) {
                console.error("Hasta portalı için detaylar çekilirken hata:", error);
            } finally {
                setIsLoadingDetails(false);
            }
        };
        fetchAllDetails();
    }, [ownerData, db, appId]);

    if (!ownerData) return null;

    const { ownerName } = ownerData;

    return (
        <>
            <div className="min-h-screen bg-slate-50 p-4 sm:p-6 md:p-8 font-sans">
                <div className="max-w-5xl mx-auto">
                    <header className="flex flex-wrap justify-between items-center mb-6 pb-4 border-b gap-4">
                        <div>
                            <h1 className="text-2xl sm:text-3xl font-bold text-slate-800">Hoş Geldiniz, {ownerName}</h1>
                            <p className="text-slate-500 mt-1">Bu portalda kayıtlı hayvanlarınızı ve geçmişlerini görüntüleyebilirsiniz.</p>
                        </div>
                        <button onClick={onExit} className={dangerButtonClasses}>
                            <LogOut size={16} className="mr-1.5"/> Çıkış Yap
                        </button>
                    </header>

                    <div className="space-y-6">
                        
                        {/* Finansal Özet Kutucuğu */}
                        <h2 className="text-xl font-semibold text-slate-700 mb-4 flex items-center">
                            <CreditCard size={20} className="mr-2"/> Cari Hesap Durumu
                        </h2>
                        <div className="w-full sm:w-1/2 mx-auto">
                            {isLoadingFinancial ? (
                                <div className="flex justify-center items-center p-8 bg-white rounded-lg shadow-md"><Loader2 className="animate-spin h-6 w-6 text-blue-500" /> <span className="ml-3">Finansal Özet Yükleniyor...</span></div>
                            ) : (
                                <div dangerouslySetInnerHTML={{ __html: ownerFinancialSummary?.portalReportHtml || '' }} />
                            )}
                        </div>

                        <h2 className="text-xl font-semibold text-slate-700 mb-4 mt-8">Kayıtlı Hayvanlarınız</h2>
                        {isLoadingDetails ? (
                            <div className="flex justify-center items-center p-8 bg-white rounded-lg shadow-md"><Loader2 className="animate-spin h-8 w-8 text-blue-500" /> <span className="ml-3">Hayvan Detayları Yükleniyor...</span></div>
                        ) : patientDetails.length > 0 ? (
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                                {patientDetails.map(patient => (
                                    <div key={patient.id} className="bg-white p-5 rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300 transform hover:-translate-y-1">
                                        <div className="flex justify-between items-start">
                                            <div>
                                                <h3 className="text-xl font-bold text-blue-700">{patient.name}</h3>
                                                <p className="text-md text-slate-600">{patient.species} - {patient.breed || 'Cins belirtilmemiş'}</p>
                                                <span className="text-xs font-mono bg-slate-100 px-2 py-1 rounded mt-2 inline-block">ID: {patient.publicId || patient.id.substring(0, 8)}...</span>
                                            </div>
                                            <button 
                                                onClick={() => setDetailModalPatient(patient)}
                                                className={`${infoButtonClasses} text-sm py-2 px-4`}
                                            >
                                                <Eye size={16} className="mr-1.5"/> Geçmişi Gör
                                            </button>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <div className="text-center text-slate-500 bg-slate-100 p-6 rounded-lg shadow-inner">
                                <Info size={24} className="mx-auto mb-2 text-slate-400"/>
                                <p>Bu portala kayıtlı hayvan bulunmamaktadır.</p>
                            </div>
                        )}
                         <div className="mt-8 bg-yellow-50 border-l-4 border-yellow-400 p-4 rounded-r-lg shadow">
                            <h3 className="font-bold text-yellow-800 flex items-center"><Bell size={18} className="mr-2"/> Önemli Bilgilendirme</h3>
                            <p className="text-sm text-yellow-700 mt-2">Aşı ve parazit gibi yaklaşan randevu hatırlatmalarınız kliniğimiz tarafından size SMS/WhatsApp yoluyla ayrıca bildirilecektir. Portal üzerinden de tüm hatırlatmalarınızı takip edebilirsiniz.</p>
                        </div>
                    </div>
                </div>
            </div>
            {detailModalPatient && (
                 <Modal 
                    isOpen={!!detailModalPatient} 
                    onClose={() => setDetailModalPatient(null)} 
                    title={`${detailModalPatient.name} - Detaylar`} 
                    size="5xl" 
                    zIndex="z-[70]"
                 >
                    <PatientDetailView 
                        patient={detailModalPatient} 
                        visits={detailModalPatient.visits || []}
                        reminders={detailModalPatient.reminders || []}
                        allVisits={detailModalPatient.visits || []}
                        allCreditSales={[]}
                        isReadOnly={true}
                        // openPaymentCollectionModal sadece klinik görünümünde geçerli
                        openPaymentCollectionModal={() => console.log('Payment collection not available in portal view')} 
                    />
                </Modal>
            )}
        </>
    );
};

const DashboardView = ({ allVisits, creditSales, patients, inventoryItems, onChartClick }) => {
    const [timeRange, setTimeRange] = useState('last30days');
    const [customStartDate, setCustomStartDate] = useState('');
    const [customEndDate, setCustomEndDate] = useState('');
    
    const formatCurrency = (value) => {
        const number = Number(value) || 0;
        if (isNaN(number)) return '0.00'; 
        return number.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    };

    const timeRangeOptions = [
        { value: 'last7days', label: 'Son 7 Gün' },
        { value: 'last30days', label: 'Son 30 Gün' },
        { value: 'last6months', label: 'Son 6 Ay' },
        { value: 'last12months', label: 'Son 12 Ay' },
        { value: 'all', label: 'Tüm Zamanlar' },
        { value: 'custom', label: 'Özel Tarih Aralığı' },
    ];

    const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#A28DFF', '#FF69B4', '#17becf', '#f97316', '#84cc16', '#e879f9', '#8b5cf6', '#d946ef'];
    
    // 1- Hayvan Türü filtresi için state eklendi
    const [selectedSpeciesForBreed, setSelectedSpeciesForBreed] = useState('Köpek'); 
    
    // Tüm mevcut türleri bul
    const uniqueSpecies = useMemo(() => {
        const speciesList = [...new Set(patients.map(p => p.species).filter(s => s))];
        if (selectedSpeciesForBreed && !speciesList.includes(selectedSpeciesForBreed)) {
             // Eğer seçili tür listede yoksa, varsayılanı ilk türe ayarla
             setSelectedSpeciesForBreed(speciesList[0] || 'Köpek');
        }
        return speciesList;
    }, [patients, selectedSpeciesForBreed]);

    const { summary, chartData } = useMemo(() => {
        const now = new Date();
        let startDate = new Date();
        let endDate = new Date(now);
        endDate.setHours(23, 59, 59, 999);
        startDate.setHours(0, 0, 0, 0);

        if (timeRange === 'custom' && customStartDate && customEndDate) {
            startDate = new Date(customStartDate);
            startDate.setHours(0, 0, 0, 0);
            endDate = new Date(customEndDate);
            endDate.setHours(23, 59, 59, 999);
        } else if (timeRange === 'all') {
             // En eski ziyaretten başla
             const oldestVisitDate = allVisits.reduce((minDate, v) => v.visitDate?.toDate() && v.visitDate.toDate() < minDate ? v.visitDate.toDate() : minDate, new Date());
             const oldestPatientDate = patients.reduce((minDate, p) => p.createdAt?.toDate() && p.createdAt.toDate() < minDate ? p.createdAt.toDate() : minDate, new Date());
             startDate = new Date(Math.min(oldestVisitDate.getTime(), oldestPatientDate.getTime()));
             startDate.setHours(0, 0, 0, 0);
        } else {
             switch (timeRange) {
                case 'last7days':
                    startDate.setDate(now.getDate() - 7);
                    break;
                case 'last6months':
                    startDate.setMonth(now.getMonth() - 6);
                    break;
                case 'last12months':
                    startDate.setFullYear(now.getFullYear() - 1);
                    break;
                case 'last30days':
                default:
                    startDate.setDate(now.getDate() - 30);
                    break;
            }
        }
        
        const visitsInPeriod = allVisits.filter(v => v.visitDate?.toDate() >= startDate && v.visitDate?.toDate() <= endDate);
        const patientsInPeriod = patients.filter(p => p.createdAt?.toDate() >= startDate && p.createdAt?.toDate() <= endDate);

        // Summary Calculations
        // NaN Fix: Number() ile kontrol
        const totalRevenue = visitsInPeriod.reduce((sum, v) => sum + (Number(v.visitCost) || 0), 0);
        const totalCollected = visitsInPeriod.reduce((sum, v) => sum + (Number(v.paymentAmount) || 0), 0);
        const totalDebt = totalRevenue - totalCollected;
        const newPatientsCount = patientsInPeriod.length;
        const clinicalVisits = visitsInPeriod.filter(v => !v.isCreditSale && !v.isPrescriptionOnly && !v.isPaymentRecord);
        const avgVisitValue = clinicalVisits.length > 0 ? totalRevenue / clinicalVisits.length : 0;
        
        const summary = { totalRevenue, totalCollected, totalDebt, newPatientsCount, avgVisitValue };

        // Chart Data Calculations
        const diagnosisCounts = {};
        const productUsage = {};
        const revenueBySpecies = {};
        const speciesDistribution = {};
        const diagnosisRevenue = {}; // 1- Gelirin Teşhis Dağılımı için eklendi
        
        visitsInPeriod.forEach(v => {
            const patient = patients.find(p => p.id === v.patientId);
            const species = patient?.species || 'Bilinmeyen';

            revenueBySpecies[species] = (revenueBySpecies[species] || 0) + (Number(v.visitCost) || 0);

            const diagnosis = v.diagnosis?.trim();
            if (diagnosis && !v.isCreditSale && !v.isPrescriptionOnly && diagnosis !== 'Reçete' && diagnosis !== 'Finansal Hareket (Tahsilat)') {
                // Sadece klinik ziyaretlerinden gelen ücret/teşhis için
                const visitRevenue = (Number(v.visitCost) || 0) - (Number(v.paymentAmount) || 0);
                diagnosisCounts[diagnosis] = (diagnosisCounts[diagnosis] || 0) + 1;
                diagnosisRevenue[diagnosis] = (diagnosisRevenue[diagnosis] || 0) + visitRevenue;
            }

            v.usedStockItems?.forEach(item => {
                // NaN Fix
                productUsage[item.itemName] = (productUsage[item.itemName] || 0) + (Number(item.quantityUsed) || 0);
            });
        });
        
        creditSales.filter(cs => cs.saleDate?.toDate() >= startDate && cs.saleDate?.toDate() <= endDate)
            .forEach(cs => {
                 // İlaç satışlarından elde edilen gelir (Borçlanma miktarı)
                 const creditSaleDebt = (Number(cs.totalAmount) || 0) - (Number(cs.paidAmount) || 0);
                 const diagnosis = 'İlaç Satış (Veresiye)';
                 diagnosisRevenue[diagnosis] = (diagnosisRevenue[diagnosis] || 0) + creditSaleDebt;
                 
                 // Ürün kullanımı
                cs.items?.forEach(item => {
                    // NaN Fix
                    productUsage[item.itemName] = (productUsage[item.itemName] || 0) + (Number(item.quantity) || 0);
                });
            });

        patients.forEach(p => {
            const species = p.species || 'Bilinmeyen';
            speciesDistribution[species] = (speciesDistribution[species] || 0) + 1;
        });

        // Top 10 Teşhis (Vaka Sayısı)
        const top10diagnosesData = Object.entries(diagnosisCounts)
            .map(([name, value]) => ({ name, value }))
            .sort((a, b) => b.value - a.value)
            .slice(0, 10);
            
        // Top 10 Teşhis (Gelir Bazlı)
        const top10DiagnosisRevenueData = Object.entries(diagnosisRevenue)
            .map(([name, value]) => ({ name, value: Math.round(value * 100) / 100 }))
            .sort((a, b) => b.value - a.value)
            .slice(0, 10);


        const top10productsData = Object.entries(productUsage)
            .map(([name, value]) => ({ name, value: Math.round(value * 100) / 100 })) // Miktarı yuvarla
            .sort((a, b) => b.value - a.value)
            .slice(0, 10);

        const revenueBySpeciesData = Object.entries(revenueBySpecies)
            .map(([name, value]) => ({ name, value: Math.round(value * 100) / 100 }))
            .sort((a, b) => b.value - a.value);

        const paymentCollectionData = [
            { name: 'Tahsil Edilen', value: Math.round(totalCollected * 100) / 100 },
            { name: 'Veresiye Kalan', value: Math.max(0, Math.round(totalDebt * 100) / 100) },
        ];
        
        const speciesDistributionData = Object.entries(speciesDistribution)
            .map(([name, value]) => ({ name, value }))
            .sort((a, b) => b.value - a.value);
            
        // 1- Seçilen Türe Göre Cins Dağılımı
        const breedDistributionData = selectedSpeciesForBreed ? Object.entries(
                patients.filter(p => p.species === selectedSpeciesForBreed && p.breed)
                    .reduce((acc, p) => {
                        const breed = p.breed.trim() || 'Bilinmeyen';
                        acc[breed] = (acc[breed] || 0) + 1;
                        return acc;
                    }, {})
            )
            .map(([name, value]) => ({ name, value }))
            .sort((a, b) => b.value - a.value)
            .slice(0, 10) : [];

        // Aylık Vaka Dağılımı Verisi
        const top10DiagnosisNames = top10diagnosesData.map(d => d.name);
        const monthlyCaseDataMap = new Map();

        visitsInPeriod.forEach(v => {
            const diagnosis = v.diagnosis?.trim();
            if (diagnosis && !v.isCreditSale && !v.isPrescriptionOnly && top10DiagnosisNames.includes(diagnosis)) {
                const visitDate = v.visitDate.toDate();
                const monthKey = `${visitDate.getFullYear()}-${String(visitDate.getMonth()).padStart(2, '0')}`; 

                if (!monthlyCaseDataMap.has(monthKey)) {
                    const initialMonthData = {
                        name: visitDate.toLocaleDateString('tr-TR', { year: 'numeric', month: 'short' }),
                        sortKey: monthKey
                    };
                    top10DiagnosisNames.forEach(name => {
                        initialMonthData[name] = 0;
                    });
                    monthlyCaseDataMap.set(monthKey, initialMonthData);
                }
                monthlyCaseDataMap.get(monthKey)[diagnosis]++;
            }
        });

        const monthlyCaseDistributionData = Array.from(monthlyCaseDataMap.values())
            .sort((a, b) => a.sortKey.localeCompare(b.sortKey));


        return {
            summary,
            chartData: {
                top10diagnosesData,
                top10DiagnosisRevenueData,
                top10productsData,
                revenueBySpeciesData,
                paymentCollectionData,
                speciesDistributionData,
                breedDistributionData,
                monthlyCaseDistributionData, 
                top10DiagnosisNames 
            }
        };
    }, [allVisits, creditSales, patients, timeRange, customStartDate, customEndDate, selectedSpeciesForBreed]);

    const renderChart = (chartInfo) => (
        <div 
            className="p-4 bg-white rounded-xl shadow-lg h-[400px] flex flex-col cursor-pointer hover:shadow-2xl transition-shadow duration-300"
            onClick={() => window.onChartClick(chartInfo)}
        >
            <h3 className="text-md font-semibold text-slate-800 mb-4 text-center">{chartInfo.title}</h3>
            <div className="flex-grow">
                 <ResponsiveContainer width="100%" height="100%">
                    {chartInfo.chart}
                </ResponsiveContainer>
            </div>
        </div>
    );
    
    // Pie Chart için özel etiket
    const RADIAN = Math.PI / 180;
    const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index, name, value }) => {
        if (percent < 0.05) return null; // Küçük dilimleri gösterme
        const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
        const x = cx + radius * Math.cos(-midAngle * RADIAN);
        const y = cy + radius * Math.sin(-midAngle * RADIAN);
        return (
            <text x={x} y={y} fill="white" textAnchor="middle" dominantBaseline="central" fontSize="12px" fontWeight="bold">
                {`${(percent * 100).toFixed(0)}%`}
            </text>
        );
    };
    
    // onChartClick prop'u App'ten geliyor
    window.onChartClick = onChartClick; 

    return (
        <div className="space-y-6">
            <div className="flex flex-col md:flex-row justify-center items-end gap-4 p-3 bg-white rounded-lg shadow-md">
                <div className="flex-grow w-full md:w-auto">
                    <label htmlFor="timeRangeSelect" className={labelClasses}>Zaman Aralığı</label>
                    <select id="timeRangeSelect" value={timeRange} onChange={(e) => setTimeRange(e.target.value)} className={inputClasses}>
                        {timeRangeOptions.map(option => (
                             <option key={option.value} value={option.value}>{option.label}</option>
                        ))}
                    </select>
                </div>
                {timeRange === 'custom' && (
                    <>
                        <div className="flex-grow w-full md:w-auto">
                           <label htmlFor="customStartDate" className={labelClasses}>Başlangıç</label>
                           <input type="date" id="customStartDate" value={customStartDate} onChange={e => setCustomStartDate(e.target.value)} className={inputClasses} />
                        </div>
                        <div className="flex-grow w-full md:w-auto">
                            <label htmlFor="customEndDate" className={labelClasses}>Bitiş</label>
                            <input type="date" id="customEndDate" value={customEndDate} onChange={e => setCustomEndDate(e.target.value)} className={inputClasses} />
                        </div>
                    </>
                )}
            </div>
            
            <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-5 gap-4">
                <div className="p-4 bg-blue-50 rounded-lg shadow text-center"><p className="text-sm font-semibold text-blue-800">Toplam Ciro</p><p className="text-2xl font-bold text-blue-900">{formatCurrency(summary.totalRevenue)} TL</p></div>
                <div className="p-4 bg-green-50 rounded-lg shadow text-center"><p className="text-sm font-semibold text-green-800">Toplam Tahsilat</p><p className="text-2xl font-bold text-green-900">{formatCurrency(summary.totalCollected)} TL</p></div>
                <div className="p-4 bg-red-50 rounded-lg shadow text-center"><p className="text-sm font-semibold text-red-800">Veresiye</p><p className="text-2xl font-bold text-red-900">{formatCurrency(summary.totalDebt)} TL</p></div>
                <div className="p-4 bg-indigo-50 rounded-lg shadow text-center"><p className="text-sm font-semibold text-indigo-800">Yeni Hasta</p><p className="text-2xl font-bold text-indigo-900">{summary.newPatientsCount}</p></div>
                <div className="p-4 bg-yellow-50 rounded-lg shadow text-center"><p className="text-sm font-semibold text-yellow-800">Ort. Vaka Değeri</p><p className="text-2xl font-bold text-yellow-900">{formatCurrency(summary.avgVisitValue)} TL</p></div>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-6">
                 {renderChart({
                    title: 'Ödeme Tahsilat Oranı',
                    data: chartData.paymentCollectionData,
                    chart: (
                        <PieChart>
                            <Pie data={chartData.paymentCollectionData} dataKey="value" nameKey="name" cx="50%" cy="50%" outerRadius={100} labelLine={false} label={renderCustomizedLabel}>
                                {chartData.paymentCollectionData.map((entry, index) => <Cell key={`cell-${index}`} fill={entry.name === 'Tahsil Edilen' ? COLORS[1] : COLORS[3]} />)}
                            </Pie>
                            <Tooltip formatter={(value) => `${formatCurrency(value)} TL`} />
                            <Legend />
                        </PieChart>
                    ),
                    chartId: 'paymentCollection'
                })}
                {/* 1- Hayvan Türü ve Cins Dağılımı (Genel) grafiği güncellendi */}
                <div className="p-4 bg-white rounded-xl shadow-lg h-[400px] flex flex-col hover:shadow-2xl transition-shadow duration-300">
                     <h3 className="text-md font-semibold text-slate-800 mb-4 text-center">Hayvan Türü ve Cins Dağılımı (Genel)</h3>
                     <div className="flex justify-center items-center gap-2 mb-3">
                         <label htmlFor="species-filter" className="text-sm text-slate-600">Cins İçin Tür Seç:</label>
                         <select 
                            id="species-filter"
                            value={selectedSpeciesForBreed}
                            onChange={(e) => setSelectedSpeciesForBreed(e.target.value)}
                            className={inputClasses + " w-1/2 text-sm py-1"}
                         >
                            {uniqueSpecies.map(s => <option key={s} value={s}>{s}</option>)}
                         </select>
                     </div>
                     <div className="flex-grow grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div onClick={() => onChartClick({title: 'Tüm Hastaların Türe Göre Dağılımı', data: chartData.speciesDistributionData, chart: <PieChart><Pie data={chartData.speciesDistributionData} dataKey="value" nameKey="name" cx="50%" cy="50%" outerRadius={120} label><Cell fill={COLORS[0]}/><Cell fill={COLORS[1]}/><Cell fill={COLORS[2]}/><Cell fill={COLORS[3]}/></Pie><Tooltip/></PieChart>, chartId: 'speciesDist'})} className="cursor-pointer">
                           <h4 className="text-sm text-center font-medium text-slate-600 mb-1">Türe Göre Dağılım</h4>
                           <ResponsiveContainer width="100%" height={150}>
                             <PieChart>
                                <Pie data={chartData.speciesDistributionData} dataKey="value" nameKey="name" cx="50%" cy="50%" outerRadius={60} innerRadius={30}>
                                    {chartData.speciesDistributionData.map((entry, index) => <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />)}
                                </Pie>
                                <Tooltip formatter={(value) => [value, 'Adet']}/>
                             </PieChart>
                           </ResponsiveContainer>
                        </div>
                        <div onClick={() => onChartClick({title: `${selectedSpeciesForBreed} İçin Cins Dağılımı (Top 10)`, data: chartData.breedDistributionData, chart: <BarChart data={chartData.breedDistributionData} layout="vertical"><XAxis type="number"/><YAxis type="category" dataKey="name" width={80}/><Bar dataKey="value" fill={COLORS[1]} name="Adet"/><Tooltip/></BarChart>, chartId: 'breedDist'})} className="cursor-pointer">
                            <h4 className="text-sm text-center font-medium text-slate-600 mb-1">{selectedSpeciesForBreed} Cinsleri (Top 10)</h4>
                            <ResponsiveContainer width="100%" height={250}>
                                <BarChart data={chartData.breedDistributionData} layout="vertical" margin={{ top: 5, right: 20, left: 20, bottom: 5 }}>
                                    <XAxis type="number" allowDecimals={false} />
                                    <YAxis type="category" dataKey="name" width={60} interval={0} tick={{ fontSize: 9 }}/>
                                    <Bar dataKey="value" fill={COLORS[1]} name="Adet" barSize={15} />
                                    <Tooltip/>
                                </BarChart>
                            </ResponsiveContainer>
                        </div>
                     </div>
                </div>
                {renderChart({
                    title: 'Gelirin Hayvan Türüne Göre Dağılımı',
                    data: chartData.revenueBySpeciesData,
                    chart: (
                        <BarChart data={chartData.revenueBySpeciesData} layout="vertical" margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis type="number" tickFormatter={(value) => `${formatCurrency(value)}`}/>
                            <YAxis type="category" dataKey="name" width={80}/>
                            <Tooltip formatter={(value) => `${formatCurrency(value)} TL`} />
                            <Bar dataKey="value" name="Ciro" barSize={20}>
                                 {chartData.revenueBySpeciesData.map((entry, index) => <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />)}
                            </Bar>
                        </BarChart>
                    ),
                    chartId: 'revenueBySpecies'
                })}
                {/* 1- Teşhis Dağılımı (Top 10) grafiği Gelirin Teşhis Dağılımı (Top 10) olarak değiştirildi. */}
                 {renderChart({
                    title: 'Gelirin Teşhis Dağılımı (Top 10)',
                    data: chartData.top10DiagnosisRevenueData,
                    chart: (
                        <BarChart data={chartData.top10DiagnosisRevenueData} layout="vertical" margin={{ top: 5, right: 30, left: 50, bottom: 5 }}>
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis type="number" tickFormatter={(value) => `${formatCurrency(value)}`}/>
                            <YAxis type="category" dataKey="name" width={120} interval={0} tick={{ fontSize: 10 }}/>
                            <Tooltip formatter={(value) => [`${formatCurrency(value)} TL`, 'Gelir']}/>
                            <Bar dataKey="value" fill="#8884d8" name="Gelir (TL)" barSize={20} />
                        </BarChart>
                    ),
                    chartId: 'top10DiagnosisRevenue'
                })}
                {renderChart({
                    title: 'En Çok Kullanılan Ürünler (Top 10)',
                    data: chartData.top10productsData,
                    chart: (
                         <BarChart data={chartData.top10productsData} layout="vertical" margin={{ top: 5, right: 30, left: 50, bottom: 5 }}>
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis type="number" allowDecimals={false} />
                            <YAxis type="category" dataKey="name" width={120} interval={0} tick={{ fontSize: 10 }}/>
                            <Tooltip formatter={(value) => [value, 'Adet']}/>
                            <Bar dataKey="value" fill="#ffc658" name="Adet" barSize={20} />
                        </BarChart>
                    ),
                    chartId: 'top10products'
                })}
                {chartData.monthlyCaseDistributionData.length > 0 && renderChart({
                    title: 'Aylık Vaka Dağılımı (Top 10 Vaka)',
                    data: chartData.monthlyCaseDistributionData,
                    chart: (
                        <BarChart data={chartData.monthlyCaseDistributionData} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="name" />
                            <YAxis allowDecimals={false}/>
                            <Tooltip />
                            <Legend wrapperStyle={{fontSize: '10px'}}/>
                            {chartData.top10DiagnosisNames.map((name, index) => (
                                <Bar key={name} dataKey={name} stackId="a" fill={COLORS[index % COLORS.length]} />
                            ))}
                        </BarChart>
                    ),
                    chartId: 'monthlyCase'
                })}
            </div>
        </div>
    );
};

const BackupModal = ({ isBackingUp, setIsBackingUp, setNotification, userId, db, appId }) => {
    const handleCreateBackup = async () => {
        if (!userId || !db) {
            setNotification("Yedekleme için kullanıcı ve veritabanı bilgileri eksik.");
            return;
        }
        setIsBackingUp(true);
        setNotification("Yedekleme işlemi başlatıldı. Lütfen bekleyin, bu işlem veri miktarına göre uzun sürebilir.");

        try {
            const backupData = {
                backupDate: new Date().toISOString(),
                schemaVersion: '1.0',
            };

            const collectionsToBackup = [
                'patients', 'reminders', 'inventory', 'creditSales', 'uniqueDiagnoses'
            ];

            for (const collectionName of collectionsToBackup) {
                 const collectionRef = collection(db, `artifacts/${appId}/users/${userId}/${collectionName}`);
                 const snapshot = await getDocs(collectionRef);
                 backupData[collectionName] = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
            }
            
            if (backupData.patients) {
                for (const patient of backupData.patients) {
                    const visitsRef = collection(db, `artifacts/${appId}/users/${userId}/patients/${patient.id}/visits`);
                    const visitsSnapshot = await getDocs(visitsRef);
                    patient.visits = visitsSnapshot.docs.map(d => ({ id: d.id, ...d.data() }));
                    
                    const herdEventsRef = collection(db, `artifacts/${appId}/users/${userId}/patients/${patient.id}/herdEvents`);
                    const herdEventsSnapshot = await getDocs(herdEventsRef);
                    patient.herdEvents = herdEventsSnapshot.docs.map(d => ({ id: d.id, ...d.data() }));
                }
            }

            const jsonString = JSON.stringify(backupData, (key, value) => {
                // Firestore Timestamp nesnesini ISO string'e dönüştür
                if (value && typeof value === 'object' && value.hasOwnProperty('seconds') && value.hasOwnProperty('nanoseconds')) {
                    return new Date(value.seconds * 1000).toISOString();
                }
                return value;
            }, 2);
            
            const blob = new Blob([jsonString], { type: 'application/json' });
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            const dateStr = new Date().toISOString().split('T')[0];
            a.download = `klinik_yedek_${dateStr}.json`;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);
            
            setNotification("Veritabanı yedeği başarıyla oluşturuldu ve indirildi!");

        } catch (error) {
            setNotification(`Yedekleme sırasında bir hata oluştu: ${error.message}`);
        } finally {
            setIsBackingUp(false);
        }
    };

    return (
        <div className="text-center">
            <p className="text-slate-600 mb-6">
                Tüm klinik verilerinizin (hastalar, ziyaretler, stok vb.) tam bir yedeğini JSON formatında bilgisayarınıza indirmek için butona tıklayın.
            </p>
            <button
                onClick={handleCreateBackup}
                disabled={isBackingUp}
                className={primaryButtonClasses + " w-full py-3"}
            >
                 {isBackingUp ? (
                    <><Loader2 size={20} className="animate-spin mr-2"/> Yedek Oluşturuluyor...</>
                ) : (
                    <><Download size={20} className="mr-2"/> Yedeği Oluştur ve İndir</>
                )}
            </button>
        </div>
    );
};

export default App;